/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER_GOOGLE = 'LOGIN_USER_GOOGLE';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';


/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';

/********************MENU ROLE*******************************************************/
export const MENU_ROLE = 'MENU_ROLE';
export const MENU_ROLE_SUCCESS = 'MENU_ROLE_SUCCESS';
export const MENU_ROLE_ERROR = 'MENU_ROLE_ERROR';


/********************REPORT BUGS*******************************************************/
export const REPORT_BUGS_USER_LIST = 'REPORT_BUGS_USER_LIST';
export const REPORT_BUGS_USER_LIST_SUCCESS = 'REPORT_BUGS_USER_LIST_SUCCESS';
export const REPORT_BUGS_USER_LIST_ERROR = 'REPORT_BUGS_USER_LIST_ERROR';
export const REPORT_BUGS_MENU = 'REPORT_BUGS_MENU';
export const REPORT_BUGS_MENU_SUCCESS = 'REPORT_BUGS_MENU_SUCCESS';
export const REPORT_BUGS_MENU_ERROR = 'REPORT_BUGS_MENU_ERROR';
export const REPORT_BUGS_RESOURCE = 'REPORT_BUGS_RESOURCE';
export const REPORT_BUGS_RESOURCE_SUCCESS = 'REPORT_BUGS_RESOURCE_SUCCESS';
export const REPORT_BUGS_RESOURCE_ERROR = 'REPORT_BUGS_RESOURCE_ERROR';
export const REPORT_BUGS_BY_USER = 'REPORT_BUGS_BY_USER';
export const REPORT_BUGS_BY_USER_SUCCESS = 'REPORT_BUGS_BY_USER_SUCCESS';
export const REPORT_BUGS_BY_USER_ERROR = 'REPORT_BUGS_BY_USER_ERROR';
export const REPORT_BUGS_PAGE_SET = 'REPORT_BUGS_PAGE_SET';
export const REPORT_BUGS_ADD_MODAL_SET = 'REPORT_BUGS_ADD_MODAL_SET';
export const REPORT_BUGS_ADD_CHANGE_SET = 'REPORT_BUGS_ADD_CHANGE_SET';
export const REPORT_BUGS_ADD = 'REPORT_BUGS_ADD';
export const REPORT_BUGS_ADD_SUCCESS = 'REPORT_BUGS_ADD_SUCCESS';
export const REPORT_BUGS_ADD_ERROR = 'REPORT_BUGS_ADD_ERROR';
export const REPORT_BUGS_CANCEL = 'REPORT_BUGS_CANCEL';
export const REPORT_BUGS_CANCEL_SUCCESS = 'REPORT_BUGS_CANCEL_SUCCESS';
export const REPORT_BUGS_CANCEL_ERROR = 'REPORT_BUGS_CANCEL_ERROR';
export const REPORT_BUGS_APPROVED = 'REPORT_BUGS_APPROVED';
export const REPORT_BUGS_APPROVED_SUCCESS = 'REPORT_BUGS_APPROVED_SUCCESS';
export const REPORT_BUGS_APPROVED_ERROR = 'REPORT_BUGS_APPROVED_ERROR';
export const REPORT_BUGS_LIST = 'REPORT_BUGS_LIST';
export const REPORT_BUGS_LIST_SUCCESS = 'REPORT_BUGS_LIST_SUCCESS';
export const REPORT_BUGS_LIST_ERROR = 'REPORT_BUGS_LIST_ERROR';

/********************ADMIN COMMUNICATION*******************************************************/
export const COM_PURCHASE_ORDER = 'COM_PURCHASE_ORDER';
export const COM_PURCHASE_ORDER_SUCCESS = 'COM_PURCHASE_ORDER_SUCCESS';
export const COM_PURCHASE_ORDER_ERROR = 'COM_PURCHASE_ORDER_ERROR';
export const COM_SUPPLIER = 'COM_SUPPLIER';
export const COM_SUPPLIER_SUCCESS = 'COM_SUPPLIER_SUCCESS';
export const COM_SUPPLIER_ERROR = 'COM_SUPPLIER_ERROR';
export const COM_CATEGORY = 'COM_CATEGORY';
export const COM_CATEGORY_SUCCESS = 'COM_CATEGORY_SUCCESS';
export const COM_CATEGORY_ERROR = 'COM_CATEGORY_ERROR';
export const COM_USER_ASSIGNED = 'COM_USER_ASSIGNED';
export const COM_USER_ASSIGNED_SUCCESS = 'COM_USER_ASSIGNED_SUCCESS';
export const COM_USER_ASSIGNED_ERROR = 'COM_USER_ASSIGNED_ERROR';
export const COM_STATUS = 'COM_STATUS';
export const COM_STATUS_SUCCESS = 'COM_STATUS_SUCCESS';
export const COM_STATUS_ERROR = 'COM_STATUS_ERROR';
export const COM_USER_FOR_ASSIGN = 'COM_USER_FOR_ASSIGN';
export const COM_USER_FOR_ASSIGN_SUCCESS = 'COM_USER_FOR_ASSIGN_SUCCESS';
export const COM_USER_FOR_ASSIGN_ERROR = 'COM_USER_FOR_ASSIGN_ERROR';
export const COMMUNICATION_LIST = 'COMMUNICATION_LIST';
export const COMMUNICATION_LIST_SUCCESS = 'COMMUNICATION_LIST_SUCCESS';
export const COMMUNICATION_LIST_ERROR = 'COMMUNICATION_LIST_ERROR';
export const COMMUNICATION_SEARCH_CHANGE = 'COMMUNICATION_SEARCH_CHANGE';
export const COMMUNICATION_PAGE_SET = 'COMMUNICATION_PAGE_SET';
export const COMMUNICATION_EDIT_MODAL_SET = 'COMMUNICATION_EDIT_MODAL_SET';
export const COMMUNICATION_EDIT_SET_DATA = 'COMMUNICATION_EDIT_SET_DATA';
export const COMMUNICATION_EDIT_CHANGE_SET = 'COMMUNICATION_EDIT_CHANGE_SET';
export const COMMUNICATION_EDIT = 'COMMUNICATION_EDIT';
export const COMMUNICATION_EDIT_SUCCESS = 'COMMUNICATION_EDIT_SUCCESS';
export const COMMUNICATION_EDIT_ERROR = 'COMMUNICATION_EDIT_ERROR';
export const COMMUNICATION_ANSWER_MODAL_SET = 'COMMUNICATION_ANSWER_MODAL_SET';
export const COMMUNICATION_ANSWER_SET_DATA = 'COMMUNICATION_ANSWER_SET_DATA';
export const COMMUNICATION_ANSWER_CHANGE_SET = 'COMMUNICATION_ANSWER_CHANGE_SET';
export const COMMUNICATION_ANSWER = 'COMMUNICATION_ANSWER';
export const COMMUNICATION_ANSWER_SUCCESS = 'COMMUNICATION_ANSWER_SUCCESS';
export const COMMUNICATION_ANSWER_ERROR = 'COMMUNICATION_ANSWER_ERROR';
export const COMMUNICATION_SEE_MODAL_SET = 'COMMUNICATION_SEE_MODAL_SET';
export const COMMUNICATION_SEE_SET_DATA = 'COMMUNICATION_SEE_SET_DATA';
export const COMMUNICATION_UPLOAD_SET = 'COMMUNICATION_UPLOAD_SET';
export const COMMUNICATION_UPLOAD_SET_SUCCESS = 'COMMUNICATION_UPLOAD_SET_SUCCESS';
export const COMMUNICATION_UPLOAD_SET_ERROR = 'COMMUNICATION_UPLOAD_SET_ERROR';
export const COMMUNICATION_UPLOAD_RESET = 'COMMUNICATION_UPLOAD_RESET';

/********************SUPPLIER COMMUNICATION*******************************************************/
export const SUPPLIER_COM_SUPPLIER = 'SUPPLIER_COM_SUPPLIER';
export const SUPPLIER_COM_SUPPLIER_SUCCESS = 'SUPPLIER_COM_SUPPLIER_SUCCESS';
export const SUPPLIER_COM_SUPPLIER_ERROR = 'SUPPLIER_COM_SUPPLIER_ERROR';
export const SUPPLIER_COM_EMAIL = 'SUPPLIER_COM_EMAIL';
export const SUPPLIER_COM_EMAIL_SUCCESS = 'SUPPLIER_COM_EMAIL_SUCCESS';
export const SUPPLIER_COM_EMAIL_ERROR = 'SUPPLIER_COM_EMAIL_ERROR';
export const SUPPLIER_COM_PO = 'SUPPLIER_COM_PO';
export const SUPPLIER_COM_PO_SUCCESS = 'SUPPLIER_COM_PO_SUCCESS';
export const SUPPLIER_COM_PO_ERROR = 'SUPPLIER_COM_PO_ERROR';
export const SUPPLIER_COM_CATEGORY = 'SUPPLIER_COM_CATEGORY';
export const SUPPLIER_COM_CATEGORY_SUCCESS = 'SUPPLIER_COM_CATEGORY_SUCCESS';
export const SUPPLIER_COM_CATEGORY_ERROR = 'SUPPLIER_COM_CATEGORY_ERROR';
export const SUPPLIER_COMMUNICATION_LIST = 'SUPPLIER_COMMUNICATION_LIST';
export const SUPPLIER_COMMUNICATION_LIST_SUCCESS = 'SUPPLIER_COMMUNICATION_LIST_SUCCESS';
export const SUPPLIER_COMMUNICATION_LIST_ERROR = 'SUPPLIER_COMMUNICATION_LIST_ERROR';
export const SUPPLIER_COMMUNICATION_SEARCH_CHANGE = 'SUPPLIER_COMMUNICATION_SEARCH_CHANGE';
export const SUPPLIER_COMMUNICATION_PAGE_SET = 'SUPPLIER_COMMUNICATION_PAGE_SET';
export const SUPPLIER_COMMUNICATION_ADD_MODAL_SET = 'SUPPLIER_COMMUNICATION_ADD_MODAL_SET';
export const SUPPLIER_COMMUNICATION_ADD_SET_DATA = 'SUPPLIER_COMMUNICATION_ADD_SET_DATA';
export const SUPPLIER_COMMUNICATION_ADD_CHANGE_SET = 'SUPPLIER_COMMUNICATION_ADD_CHANGE_SET';
export const SUPPLIER_COMMUNICATION_ADD = 'SUPPLIER_COMMUNICATION_ADD';
export const SUPPLIER_COMMUNICATION_ADD_SUCCESS = 'SUPPLIER_COMMUNICATION_ADD_SUCCESS';
export const SUPPLIER_COMMUNICATION_ADD_ERROR = 'SUPPLIER_COMMUNICATION_ADD_ERROR';
export const SUPPLIER_COMMUNICATION_EDIT_MODAL_SET = 'SUPPLIER_COMMUNICATION_EDIT_MODAL_SET';
export const SUPPLIER_COMMUNICATION_EDIT_SET_DATA = 'SUPPLIER_COMMUNICATION_EDIT_SET_DATA';
export const SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET = 'SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET';
export const SUPPLIER_COMMUNICATION_EDIT = 'SUPPLIER_COMMUNICATION_EDIT';
export const SUPPLIER_COMMUNICATION_EDIT_SUCCESS = 'SUPPLIER_COMMUNICATION_EDIT_SUCCESS';
export const SUPPLIER_COMMUNICATION_EDIT_ERROR = 'SUPPLIER_COMMUNICATION_EDIT_ERROR';
export const SUPPLIER_COMMUNICATION_UPLOAD_SET = 'SUPPLIER_COMMUNICATION_UPLOAD_SET';
export const SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS = 'SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS';
export const SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR = 'SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR';
export const SUPPLIER_COMMUNICATION_UPLOAD_RESET = 'SUPPLIER_COMMUNICATION_UPLOAD_RESET';
export const SUPPLIER_COMMUNICATION_SEE_MODAL_SET = 'SUPPLIER_COMMUNICATION_SEE_MODAL_SET';
export const SUPPLIER_COMMUNICATION_SEE_SET_DATA = 'SUPPLIER_COMMUNICATION_SEE_SET_DATA';

/********************SUPPLIER COMMUNICATION INFRA*******************************************************/
export const SUPPLIER_COM_INFRA_SUPPLIER = 'SUPPLIER_COM_INFRA_SUPPLIER';
export const SUPPLIER_COM_INFRA_SUPPLIER_SUCCESS = 'SUPPLIER_COM_INFRA_SUPPLIER_SUCCESS';
export const SUPPLIER_COM_INFRA_SUPPLIER_ERROR = 'SUPPLIER_COM_INFRA_SUPPLIER_ERROR';
export const SUPPLIER_COM_INFRA_TYPE = 'SUPPLIER_COM_INFRA_TYPE';
export const SUPPLIER_COM_INFRA_TYPE_SUCCESS = 'SUPPLIER_COM_INFRA_TYPE_SUCCESS';
export const SUPPLIER_COM_INFRA_TYPE_ERROR = 'SUPPLIER_COM_INFRA_TYPE_ERROR';


export const SUPPLIER_COMMUNICATION_INFRA_LIST = 'SUPPLIER_COMMUNICATION_INFRA_LIST';
export const SUPPLIER_COMMUNICATION_INFRA_LIST_SUCCESS = 'SUPPLIER_COMMUNICATION_INFRA_LIST_SUCCESS';
export const SUPPLIER_COMMUNICATION_INFRA_LIST_ERROR = 'SUPPLIER_COMMUNICATION_INFRA_LIST_ERROR';
export const SUPPLIER_COMMUNICATION_INFRA_SEARCH_CHANGE = 'SUPPLIER_COMMUNICATION_INFRA_SEARCH_CHANGE';
export const SUPPLIER_COMMUNICATION_INFRA_PAGE_SET = 'SUPPLIER_COMMUNICATION_INFRA_PAGE_SET';
export const SUPPLIER_COMMUNICATION_INFRA_ADD_MODAL_SET = 'SUPPLIER_COMMUNICATION_INFRA_ADD_MODAL_SET';
export const SUPPLIER_COMMUNICATION_INFRA_ADD_SET_DATA = 'SUPPLIER_COMMUNICATION_INFRA_ADD_SET_DATA';
export const SUPPLIER_COMMUNICATION_INFRA_ADD_CHANGE_SET = 'SUPPLIER_COMMUNICATION_INFRA_ADD_CHANGE_SET';
export const SUPPLIER_COMMUNICATION_INFRA_ADD = 'SUPPLIER_COMMUNICATION_INFRA_ADD';
export const SUPPLIER_COMMUNICATION_INFRA_ADD_SUCCESS = 'SUPPLIER_COMMUNICATION_INFRA_ADD_SUCCESS';
export const SUPPLIER_COMMUNICATION_INFRA_ADD_ERROR = 'SUPPLIER_COMMUNICATION_INFRA_ADD_ERROR';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT_MODAL_SET = 'SUPPLIER_COMMUNICATION_INFRA_EDIT_MODAL_SET';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT_SET_DATA = 'SUPPLIER_COMMUNICATION_INFRA_EDIT_SET_DATA';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT_CHANGE_SET = 'SUPPLIER_COMMUNICATION_INFRA_EDIT_CHANGE_SET';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT = 'SUPPLIER_COMMUNICATION_INFRA_EDIT';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT_SUCCESS = 'SUPPLIER_COMMUNICATION_INFRA_EDIT_SUCCESS';
export const SUPPLIER_COMMUNICATION_INFRA_EDIT_ERROR = 'SUPPLIER_COMMUNICATION_INFRA_EDIT_ERROR';
export const SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET = 'SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET';
export const SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_SUCCESS = 'SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_SUCCESS';
export const SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_ERROR = 'SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET_ERROR';
export const SUPPLIER_COMMUNICATION_INFRA_UPLOAD_RESET = 'SUPPLIER_COMMUNICATION_INFRA_UPLOAD_RESET';
export const SUPPLIER_COMMUNICATION_INFRA_SEE_MODAL_SET = 'SUPPLIER_COMMUNICATION_INFRA_SEE_MODAL_SET';
export const SUPPLIER_COMMUNICATION_INFRA_SEE_SET_DATA = 'SUPPLIER_COMMUNICATION_INFRA_SEE_SET_DATA';

/********************COMMUNICATION INFRA*******************************************************/
export const COM_INFRA_CODE = 'COM_INFRA_CODE';
export const COM_INFRA_CODE_SUCCESS = 'COM_INFRA_CODE_SUCCESS';
export const COM_INFRA_CODE_ERROR = 'COM_INFRA_CODE_ERROR';
export const COM_INFRA_DESTINATION = 'COM_INFRA_DESTINATION';
export const COM_INFRA_DESTINATION_SUCCESS = 'COM_INFRA_DESTINATION_SUCCESS';
export const COM_INFRA_DESTINATION_ERROR = 'COM_INFRA_DESTINATION_ERROR';
export const COM_INFRA_AREA = 'COM_INFRA_AREA';
export const COM_INFRA_AREA_SUCCESS = 'COM_INFRA_AREA_SUCCESS';
export const COM_INFRA_AREA_ERROR = 'COM_INFRA_AREA_ERROR';
export const COM_INFRA_PROJECT = 'COM_INFRA_PROJECT';
export const COM_INFRA_PROJECT_SUCCESS = 'COM_INFRA_PROJECT_SUCCESS';
export const COM_INFRA_PROJECT_ERROR = 'COM_INFRA_PROJECT_ERROR';
export const COM_INFRA_TYPE = 'COM_INFRA_TYPE';
export const COM_INFRA_TYPE_SUCCESS = 'COM_INFRA_TYPE_SUCCESS';
export const COM_INFRA_TYPE_ERROR = 'COM_INFRA_TYPE_ERROR';
export const COM_INFRA_STATUS = 'COM_INFRA_STATUS';
export const COM_INFRA_STATUS_SUCCESS = 'COM_INFRA_STATUS_SUCCESS';
export const COM_INFRA_STATUS_ERROR = 'COM_INFRA_STATUS_ERROR';
export const COM_INFRA_SUPPLIER = 'COM_INFRA_SUPPLIER';
export const COM_INFRA_SUPPLIER_SUCCESS = 'COM_INFRA_SUPPLIER_SUCCESS';
export const COM_INFRA_SUPPLIER_ERROR = 'COM_INFRA_SUPPLIER_ERROR';
export const COM_INFRA_USER_ASSIGN = 'COM_INFRA_USER_ASSIGN';
export const COM_INFRA_USER_ASSIGN_SUCCESS = 'COM_INFRA_USER_ASSIGN_SUCCESS';
export const COM_INFRA_USER_ASSIGN_ERROR = 'COM_INFRA_USER_ASSIGN_ERROR';
export const COM_INFRA_LIST = 'COM_INFRA_LIST';
export const COM_INFRA_LIST_SUCCESS = 'COM_INFRA_LIST_SUCCESS';
export const COM_INFRA_LIST_ERROR = 'COM_INFRA_LIST_ERROR';
export const COM_INFRA_SEARCH_CHANGE = 'COM_INFRA_SEARCH_CHANGE';
export const COM_INFRA_PAGE_SET = 'COM_INFRA_PAGE_SET';
export const COM_INFRA_EDIT_MODAL_SET = 'COM_INFRA_EDIT_MODAL_SET';
export const COM_INFRA_EDIT_SET_DATA = 'COM_INFRA_EDIT_SET_DATA';
export const COM_INFRA_EDIT_CHANGE_SET = 'COM_INFRA_EDIT_CHANGE_SET';
export const COM_INFRA_EDIT = 'COM_INFRA_EDIT';
export const COM_INFRA_EDIT_SUCCESS = 'COM_INFRA_EDIT_SUCCESS';
export const COM_INFRA_EDIT_ERROR = 'COM_INFRA_EDIT_ERROR';
export const COM_INFRA_ANSWER_MODAL_SET = 'COM_INFRA_ANSWER_MODAL_SET';
export const COM_INFRA_ANSWER_SET_DATA = 'COM_INFRA_ANSWER_SET_DATA';
export const COM_INFRA_ANSWER_CHANGE_SET = 'COM_INFRA_ANSWER_CHANGE_SET';
export const COM_INFRA_ANSWER = 'COM_INFRA_ANSWER';
export const COM_INFRA_ANSWER_SUCCESS = 'COM_INFRA_ANSWER_SUCCESS';
export const COM_INFRA_ANSWER_ERROR = 'COM_INFRA_ANSWER_ERROR';
export const COM_INFRA_SEE_MODAL_SET = 'COM_INFRA_SEE_MODAL_SET';
export const COM_INFRA_SEE_SET_DATA = 'COM_INFRA_SEE_SET_DATA';
export const COM_INFRA_UPLOAD_SET = 'COM_INFRA_UPLOAD_SET';
export const COM_INFRA_UPLOAD_SET_SUCCESS = 'COM_INFRA_UPLOAD_SET_SUCCESS';
export const COM_INFRA_UPLOAD_SET_ERROR = 'COM_INFRA_UPLOAD_SET_ERROR';
export const COM_INFRA_UPLOAD_REMOVE = 'COM_INFRA_UPLOAD_REMOVE';
export const COM_INFRA_UPLOAD_RESET = 'COM_INFRA_UPLOAD_RESET';


/********************SPE TOOL*******************************************************/
export const SPE_PURCHASE_ORDER = 'SPE_PURCHASE_ORDER';
export const SPE_PURCHASE_ORDER_SUCCESS = 'SPE_PURCHASE_ORDER_SUCCESS';
export const SPE_PURCHASE_ORDER_ERROR = 'SPE_PURCHASE_ORDER_ERROR';
export const SPE_SUPPLIER = 'SPE_SUPPLIER';
export const SPE_SUPPLIER_SUCCESS = 'SPE_SUPPLIER_SUCCESS';
export const SPE_SUPPLIER_ERROR = 'SPE_SUPPLIER_ERROR';
export const SPE_CATEGORY = 'SPE_CATEGORY';
export const SPE_CATEGORY_SUCCESS = 'SPE_CATEGORY_SUCCESS';
export const SPE_CATEGORY_ERROR = 'SPE_CATEGORY_ERROR';
export const SPE_PURCHASE_ORDER_STATUS = 'SPE_PURCHASE_ORDER_STATUS';
export const SPE_PURCHASE_ORDER_STATUS_SUCCESS = 'SPE_PURCHASE_ORDER_STATUS_SUCCESS';
export const SPE_PURCHASE_ORDER_STATUS_ERROR = 'SPE_PURCHASE_ORDER_STATUS_ERROR';
export const SPE_USER_ROLE = 'SPE_USER_ROLE';
export const SPE_USER_ROLE_SUCCESS = 'SPE_USER_ROLE_SUCCESS';
export const SPE_USER_ROLE_ERROR = 'SPE_USER_ROLE_ERROR';
export const PO_SPE_LIST = 'PO_SPE_LIST';
export const PO_SPE_LIST_SUCCESS = 'PO_SPE_LIST_SUCCESS';
export const PO_SPE_LIST_ERROR = 'PO_SPE_LIST_ERROR';
export const PO_SPE_LIST_SEARCH_CHANGE = 'PO_SPE_LIST_SEARCH_CHANGE';
export const PO_SPE_LIST_PAGE_SET = 'PO_SPE_LIST_PAGE_SET';
export const SPE_ADD_COMITE_MODAL_SET = 'SPE_ADD_COMITE_MODAL_SET';
export const SPE_ADD_COMITE_CHANGE_SET = 'SPE_ADD_COMITE_CHANGE_SET';
export const SPE_ADD_COMITE = 'SPE_ADD_COMITE';
export const SPE_ADD_COMITE_SUCCESS = 'SPE_ADD_COMITE_SUCCESS';
export const SPE_ADD_COMITE_ERROR = 'SPE_ADD_COMITE_ERROR';
export const SPE_ADD_EVALUATION_MODAL_SET = 'SPE_ADD_EVALUATION_MODAL_SET';
export const SPE_CHECKLIST = 'SPE_CHECKLIST';
export const SPE_CHECKLIST_SUCCESS = 'SPE_CHECKLIST_SUCCESS';
export const SPE_CHECKLIST_ERROR = 'SPE_CHECKLIST_ERROR';
export const SPE_EVALUATION_OPTION = 'SPE_EVALUATION_OPTION';
export const SPE_EVALUATION_OPTION_SUCCESS = 'SPE_EVALUATION_OPTION_SUCCESS';
export const SPE_EVALUATION_OPTION_ERROR = 'SPE_EVALUATION_OPTION_ERROR';
export const SPE_ADD_EVALUATION_CHANGE_SET = 'SPE_ADD_EVALUATION_CHANGE_SET';
export const SPE_ADD_EVALUATION = 'SPE_ADD_EVALUATION';
export const SPE_ADD_EVALUATION_SUCCESS = 'SPE_ADD_EVALUATION_SUCCESS';
export const SPE_ADD_EVALUATION_ERROR = 'SPE_ADD_EVALAUTION_ERROR';
export const SPE_CLOSED_EVALUATION_MODAL_SET = 'SPE_CLOSED_EVALUATION_MODAL_SET';
export const SPE_CLOSED_EVALUATION_CHANGE_SET = 'SPE_CLOSED_EVALUATION_CHANGE_SET';
export const SPE_CLOSED_EVALUATION = 'SPE_CLOSED_EVALUATION';
export const SPE_CLOSED_EVALUATION_SUCCESS = 'SPE_CLOSED_EVALUATION_SUCCESS';
export const SPE_CLOSED_EVALUATION_ERROR = 'SPE_CLOSED_EVALAUTION_ERROR';
export const SPE_DOWNLOAD_EVALUATION_MODAL_SET = 'SPE_DOWNLOAD_EVALUATION_MODAL_SET';
export const SPE_DOWNLOAD_EVALUATION_CHANGE_SET = 'SPE_DOWNLOAD_EVALUATION_CHANGE_SET';
export const SPE_CHECKLIST_SCORE = 'SPE_CHECKLIST_SCORE';
export const SPE_CHECKLIST_SCORE_SUCCESS = 'SPE_CHECKLIST_SCORE_SUCCESS';
export const SPE_CHECKLIST_SCORE_ERROR = 'SPE_CHECKLIST_SCORE_ERROR';
export const SPE_EDIT_COMITE_MODAL_SET = 'SPE_EDIT_COMITE_MODAL_SET';
export const SPE_EDIT_COMITE_CHANGE_SET = 'SPE_EDIT_COMITE_CHANGE_SET';
export const SPE_EDIT_COMITE = 'SPE_EDIT_COMITE';
export const SPE_EDIT_COMITE_SUCCESS = 'SPE_EDIT_COMITE_SUCCESS';
export const SPE_EDIT_COMITE_ERROR = 'SPE_EDIT_COMITE_ERROR';

/********************QUALITY / HEALTH REGISTRATION *******************************************************/
export const HR_PRODUCT = 'HR_PRODUCT';
export const HR_PRODUCT_SUCCESS = 'HR_PRODUCT_SUCCESS';
export const HR_PRODUCT_ERROR = 'HR_PRODUCT_ERROR';
export const HR_PRODUCT_LIST = 'HR_PRODUCT_LIST';
export const HR_PRODUCT_LIST_SUCCESS = 'HR_PRODUCT_LIST_SUCCESS';
export const HR_PRODUCT_LIST_ERROR = 'HR_PRODUCT_LIST_ERROR';
export const HR_SUPPLIER = 'HR_SUPPLIER';
export const HR_SUPPLIER_SUCCESS = 'HR_SUPPLIER_SUCCESS';
export const HR_SUPPLIER_ERROR = 'HR_SUPPLIER_ERROR';
export const HR_CATEGORY = 'HR_CATEGORY';
export const HR_CATEGORY_SUCCESS = 'HR_CATEGORY_SUCCESS';
export const HR_CATEGORY_ERROR = 'HR_CATEGORY_ERROR';
export const HR_COUNTRY = 'HR_COUNTRY';
export const HR_COUNTRY_SUCCESS = 'HR_COUNTRY_SUCCESS';
export const HR_COUNTRY_ERROR = 'HR_COUNTRY_ERROR';
export const HR_STATUS = 'HR_STATUS';
export const HR_STATUS_SUCCESS = 'HR_STATUS_SUCCESS';
export const HR_STATUS_ERROR = 'HR_STATUS_ERROR';
export const HR_LIST = 'HR_LIST';
export const HR_LIST_SUCCESS = 'HR_LIST_SUCCESS';
export const HR_LIST_ERROR = 'HR_LIST_ERROR';
export const HR_LIST_SEARCH_CHANGE = 'HR_LIST_SEARCH_CHANGE';
export const HR_LIST_PAGE_SET = 'HR_LIST_PAGE_SET';
export const HR_ADD_MODAL_SET = 'HR_ADD_MODAL_SET';
export const HR_ADD_CHANGE_SET = 'HR_ADD_CHANGE_SET';
export const HR_ADD = 'HR_ADD';
export const HR_ADD_SUCCESS = 'HR_ADD_SUCCESS';
export const HR_ADD_ERROR = 'HR_ADD_ERROR';
export const HR_EDIT_MODAL_SET = 'HR_EDIT_MODAL_SET';
export const HR_EDIT_CHANGE_SET = 'HR_EDIT_CHANGE_SET';
export const HR_EDIT = 'HR_EDIT';
export const HR_EDIT_SUCCESS = 'HR_EDIT_SUCCESS';
export const HR_EDIT_ERROR = 'HR_EDIT_ERROR';
export const HR_UPLOAD_SET = 'HR_UPLOAD_SET';
export const HR_UPLOAD_SET_SUCCESS = 'HR_UPLOAD_SET_SUCCESS';
export const HR_UPLOAD_SET_ERROR = 'HR_UPLOAD_SET_ERROR';
export const HR_UPLOAD_RESET = 'HR_UPLOAD_RESET';

/********************QUALITY / HEALTH LICENSE *******************************************************/
export const HL_SUPPLIER = 'HL_SUPPLIER';
export const HL_SUPPLIER_SUCCESS = 'HL_SUPPLIER_SUCCESS';
export const HL_SUPPLIER_ERROR = 'HL_SUPPLIER_ERROR';
export const HL_CATEGORY = 'HL_CATEGORY';
export const HL_CATEGORY_SUCCESS = 'HL_CATEGORY_SUCCESS';
export const HL_CATEGORY_ERROR = 'HL_CATEGORY_ERROR';
export const HL_LIST = 'HL_LIST';
export const HL_LIST_SUCCESS = 'HL_LIST_SUCCESS';
export const HL_LIST_ERROR = 'HL_LIST_ERROR';
export const HL_LIST_SEARCH_CHANGE = 'HL_LIST_SEARCH_CHANGE';
export const HL_LIST_PAGE_SET = 'HL_LIST_PAGE_SET';
export const HL_ADD_MODAL_SET = 'HL_ADD_MODAL_SET';
export const HL_ADD_CHANGE_SET = 'HL_ADD_CHANGE_SET';
export const HL_ADD = 'HL_ADD';
export const HL_ADD_SUCCESS = 'HL_ADD_SUCCESS';
export const HL_ADD_ERROR = 'HL_ADD_ERROR';
export const HL_EDIT_MODAL_SET = 'HL_EDIT_MODAL_SET';
export const HL_EDIT_CHANGE_SET = 'HL_EDIT_CHANGE_SET';
export const HL_EDIT = 'HL_EDIT';
export const HL_EDIT_SUCCESS = 'HL_EDIT_SUCCESS';
export const HL_EDIT_ERROR = 'HL_EDIT_ERROR';
export const HL_UPLOAD_SET = 'HL_UPLOAD_SET';
export const HL_UPLOAD_SET_SUCCESS = 'HL_UPLOAD_SET_SUCCESS';
export const HL_UPLOAD_SET_ERROR = 'HL_UPLOAD_SET_ERROR';
export const HL_UPLOAD_RESET = 'HL_UPLOAD_RESET';

/********************QUALITY / BPM *******************************************************/
export const BPM_PRODUCT = 'BPM_PRODUCT';
export const BPM_PRODUCT_SUCCESS = 'BPM_PRODUCT_SUCCESS';
export const BPM_PRODUCT_ERROR = 'BPM_PRODUCT_ERROR';
export const BPM_SUPPLIER = 'BPM_SUPPLIER';
export const BPM_SUPPLIER_SUCCESS = 'BPM_SUPPLIER_SUCCESS';
export const BPM_SUPPLIER_ERROR = 'BPM_SUPPLIER_ERROR';
export const BPM_CATEGORY = 'BPM_CATEGORY';
export const BPM_CATEGORY_SUCCESS = 'BPM_CATEGORY_SUCCESS';
export const BPM_CATEGORY_ERROR = 'BPM_CATEGORY_ERROR';
export const BPM_COUNTRY = 'BPM_COUNTRY';
export const BPM_COUNTRY_SUCCESS = 'BPM_COUNTRY_SUCCESS';
export const BPM_COUNTRY_ERROR = 'BPM_COUNTRY_ERROR';
export const BPM_LIST = 'BPM_LIST';
export const BPM_LIST_SUCCESS = 'BPM_LIST_SUCCESS';
export const BPM_LIST_ERROR = 'BPM_LIST_ERROR';
export const BPM_LIST_SEARCH_CHANGE = 'BPM_LIST_SEARCH_CHANGE';
export const BPM_LIST_PAGE_SET = 'BPM_LIST_PAGE_SET';
export const BPM_ADD_MODAL_SET = 'BPM_ADD_MODAL_SET';
export const BPM_ADD_CHANGE_SET = 'BPM_ADD_CHANGE_SET';
export const BPM_ADD = 'BPM_ADD';
export const BPM_ADD_SUCCESS = 'BPM_ADD_SUCCESS';
export const BPM_ADD_ERROR = 'BPM_ADD_ERROR';
export const BPM_EDIT_MODAL_SET = 'BPM_EDIT_MODAL_SET';
export const BPM_EDIT_CHANGE_SET = 'BPM_EDIT_CHANGE_SET';
export const BPM_EDIT = 'BPM_EDIT';
export const BPM_EDIT_SUCCESS = 'BPM_EDIT_SUCCESS';
export const BPM_EDIT_ERROR = 'BPM_EDIT_ERROR';
export const BPM_UPLOAD_SET = 'BPM_UPLOAD_SET';
export const BPM_UPLOAD_SET_SUCCESS = 'BPM_UPLOAD_SET_SUCCESS';
export const BPM_UPLOAD_SET_ERROR = 'BPM_UPLOAD_SET_ERROR';
export const BPM_UPLOAD_RESET = 'BPM_UPLOAD_RESET';
export const BPM_UPLOAD2_SET = 'BPM_UPLOAD2_SET';
export const BPM_UPLOAD2_SET_SUCCESS = 'BPM_UPLOAD2_SET_SUCCESS';
export const BPM_UPLOAD2_SET_ERROR = 'BPM_UPLOAD2_SET_ERROR';
export const BPM_UPLOAD2_RESET = 'BPM_UPLOAD2_RESET';

/********************QUALITY / PRODUCT INFO *******************************************************/
export const PI_PRODUCT = 'PI_PRODUCT';
export const PI_PRODUCT_SUCCESS = 'PI_PRODUCT_SUCCESS';
export const PI_PRODUCT_ERROR = 'PI_PRODUCT_ERROR';
export const PI_ATC = 'PI_ATC';
export const PI_ATC_SUCCESS = 'PI_ATC_SUCCESS';
export const PI_ATC_ERROR = 'PI_ATC_ERROR';
export const PI_ATC_LIST = 'PI_ATC_LIST';
export const PI_ATC_LIST_SUCCESS = 'PI_ATC_LIST_SUCCESS';
export const PI_ATC_LIST_ERROR = 'PI_ATC_LIST_ERROR';
export const PI_PHARMACEUTICAL_FORM = 'PI_PHARMACEUTICAL_FORM';
export const PI_PHARMACEUTICAL_FORM_SUCCESS = 'PI_PHARMACEUTICAL_FORM_SUCCESS';
export const PI_PHARMACEUTICAL_FORM_ERROR = 'PI_PHARMACEUTICAL_FORM_ERROR';
export const PI_PRESENTATION = 'PI_PRESENTATION';
export const PI_PRESENTATION_SUCCESS = 'PI_PRESENTATION_SUCCESS';
export const PI_PRESENTATION_ERROR = 'PI_PRESENTATION_ERROR';
export const PI_LIST = 'PI_LIST';
export const PI_LIST_SUCCESS = 'PI_LIST_SUCCESS';
export const PI_LIST_ERROR = 'PI_LIST_ERROR';
export const PI_LIST_SEARCH_CHANGE = 'PI_LIST_SEARCH_CHANGE';
export const PI_LIST_PAGE_SET = 'PI_LIST_PAGE_SET';
export const PI_EDIT_MODAL_SET = 'PI_EDIT_MODAL_SET';
export const PI_EDIT_CHANGE_SET = 'PI_EDIT_CHANGE_SET';
export const PI_EDIT = 'PI_EDIT';
export const PI_EDIT_SUCCESS = 'PI_EDIT_SUCCESS';
export const PI_EDIT_ERROR = 'PI_EDIT_ERROR';

/*****************INDEX_RPT QUALITY*************************************************************/
export const IDX_RPT_QUALITY_REPORT = 'IDX_RPT_QUALITY_REPORT';
export const IDX_RPT_QUALITY_REPORT_SUCCESS = 'IDX_RPT_QUALITY_REPORT_SUCCESS';
export const IDX_RPT_QUALITY_REPORT_ERROR = 'IDX_RPT_QUALITY_REPORT_ERROR';
export const IDX_RPT_QUALITY_SUPPLIER = 'IDX_RPT_QUALITY_SUPPLIER';
export const IDX_RPT_QUALITY_SUPPLIER_SUCCESS = 'IDX_RPT_QUALITY_SUPPLIER_SUCCESS';
export const IDX_RPT_QUALITY_SUPPLIER_ERROR = 'IDX_RPT_QUALITY_SUPPLIER_ERROR';
export const IDX_RPT_QUALITY_PRODUCT = 'IDX_RPT_QUALITY_PRODUCT';
export const IDX_RPT_QUALITY_PRODUCT_SUCCESS = 'IDX_RPT_QUALITY_PRODUCT_SUCCESS';
export const IDX_RPT_QUALITY_PRODUCT_ERROR = 'IDX_RPT_QUALITY_PRODUCT_ERROR';
export const IDX_RPT_QUALITY_MTX_QA_MED = 'IDX_RPT_QUALITY_MTX_QA_MED';
export const IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS = 'IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS';
export const IDX_RPT_QUALITY_MTX_QA_MED_ERROR = 'IDX_RPT_QUALITY_MTX_QA_MED_ERROR';
export const IDX_RPT_QUALITY_SEARCH_CHANGE = 'IDX_RPT_QUALITY_SEARCH_CHANGE';
export const IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET = 'IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET';
export const IDX_RPT_QUALITY_SUPPLIER_MMQ = 'IDX_RPT_QUALITY_SUPPLIER_MMQ';
export const IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS = 'IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS';
export const IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR = 'IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR';
export const IDX_RPT_QUALITY_PRODUCT_MMQ = 'IDX_RPT_QUALITY_PRODUCT_MMQ';
export const IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS = 'IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS';
export const IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR = 'IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR';
export const IDX_RPT_QUALITY_MTX_QA_MMQ = 'IDX_RPT_QUALITY_MTX_QA_MMQ';
export const IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS = 'IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS';
export const IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR = 'IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR';
export const IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE = 'IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE';
export const IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET = 'IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET';


/////********************************FINANCE**********************************************///////////
/********************FINANCE / CASH RECEIPT *******************************************************/
export const CR_SUPPLIER = 'CR_SUPPLIER';
export const CR_SUPPLIER_SUCCESS = 'CR_SUPPLIER_SUCCESS';
export const CR_SUPPLIER_ERROR = 'CR_SUPPLIER_ERROR';
export const CR_DELIVERY_ORDER = 'CR_DELIVERY_ORDER';
export const CR_DELIVERY_ORDER_SUCCESS = 'CR_DELIVERY_ORDER_SUCCESS';
export const CR_DELIVERY_ORDER_ERROR = 'CR_DELIVERY_ORDER_ERROR';
export const CR_ASSIGNED_USER = 'CR_ASSIGNED_USER';
export const CR_ASSIGNED_USER_SUCCESS = 'CR_ASSIGNED_USER_SUCCESS';
export const CR_ASSIGNED_USER_ERROR = 'CR_ASSIGNED_USER_ERROR';
export const CR_STATUS = 'CR_STATUS';
export const CR_STATUS_SUCCESS = 'CR_STATUS_SUCCESS';
export const CR_STATUS_ERROR = 'CR_STATUS_ERROR';
export const CR_LIST = 'CR_LIST';
export const CR_LIST_SUCCESS = 'CR_LIST_SUCCESS';
export const CR_LIST_ERROR = 'CR_LIST_ERROR';
export const CR_LIST_SEARCH_CHANGE = 'CR_LIST_SEARCH_CHANGE';
export const CR_LIST_PAGE_SET = 'CR_LIST_PAGE_SET';
export const CR_ASSIGN_MODAL_SET = 'CR_ASSIGN_MODAL_SET';
export const CR_ASSIGN_CHANGE_SET = 'CR_ASSIGN_CHANGE_SET';
export const CR_ASSIGN = 'CR_ASSIGN';
export const CR_ASSIGN_SUCCESS = 'CR_ASSIGN_SUCCESS';
export const CR_ASSIGN_ERROR = 'CR_ASSIGN_ERROR';
export const CR_LIST_UNASSIGNED = 'CR_LIST_UNASSIGNED';
export const CR_LIST_UNASSIGNED_SUCCESS = 'CR_LIST_UNASSIGNED_SUCCESS';
export const CR_LIST_UNASSIGNED_ERROR = 'CR_LIST_UNASSIGNED_ERROR';
export const CR_LIST_USER = 'CR_LIST_USER';
export const CR_LIST_USER_SUCCESS = 'CR_LIST_USER_SUCCESS';
export const CR_LIST_USER_ERROR = 'CR_LIST_USER_ERROR';
export const CR_VERIFY_MODAL_SET = 'CR_VERIFY_MODAL_SET';
export const CR_VERIFY_CHANGE_SET = 'CR_VERIFY_CHANGE_SET';
export const CR_VERIFY = 'CR_VERIFY';
export const CR_VERIFY_SUCCESS = 'CR_VERIFY_SUCCESS';
export const CR_VERIFY_ERROR = 'CR_VERIFY_ERROR';

/********************FINANCE / PAYMENT RECEIPT *******************************************************/
export const PR_SUPPLIER = 'PR_SUPPLIER';
export const PR_SUPPLIER_SUCCESS = 'PR_SUPPLIER_SUCCESS';
export const PR_SUPPLIER_ERROR = 'PR_SUPPLIER_ERROR';
export const PR_DELIVERY_ORDER = 'PR_DELIVERY_ORDER';
export const PR_DELIVERY_ORDER_SUCCESS = 'PR_DELIVERY_ORDER_SUCCESS';
export const PR_DELIVERY_ORDER_ERROR = 'PR_DELIVERY_ORDER_ERROR';
export const PR_LIST = 'PR_LIST';
export const PR_LIST_SUCCESS = 'PR_LIST_SUCCESS';
export const PR_LIST_ERROR = 'PR_LIST_ERROR';
export const PR_LIST_SEARCH_CHANGE = 'PR_LIST_SEARCH_CHANGE';
export const PR_LIST_PAGE_SET = 'PR_LIST_PAGE_SET';
export const PR_LIST_WITHOUT_PR = 'PR_LIST_WITHOUT_PR';
export const PR_LIST_WITHOUT_PR_SUCCESS = 'PR_LIST_WITHOUT_PR_SUCCESS';
export const PR_LIST_WITHOUT_PR_ERROR = 'PR_LIST_WITHOUT_PR_ERROR';
export const PR_UPLOAD_MODAL_SET = 'PR_UPLOAD_MODAL_SET';
export const PR_UPLOAD_CHANGE_SET = 'PR_UPLOAD_CHANGE_SET';
export const PR_UPLOAD = 'PR_UPLOAD';
export const PR_UPLOAD_SUCCESS = 'PR_UPLOAD_SUCCESS';
export const PR_UPLOAD_ERROR = 'PR_UPLOAD_ERROR';
export const PR_UPLOAD_SET = 'PR_UPLOAD_SET';
export const PR_UPLOAD_SET_SUCCESS = 'PR_UPLOAD_SET_SUCCESS';
export const PR_UPLOAD_SET_ERROR = 'PR_UPLOAD_SET_ERROR';
export const PR_UPLOAD_RESET = 'PR_UPLOAD_RESET';

/*************************************************************************************************/
/********************EQUIPMENT / TRACKING POST INSTALLATION *******************************************************/
export const TPI_PRODUCT = 'TPI_PRODUCT';
export const TPI_PRODUCT_SUCCESS = 'TPI_PRODUCT_SUCCESS';
export const TPI_PRODUCT_ERROR = 'TPI_PRODUCT_ERROR';
export const TPI_SUPPLIER = 'TPI_SUPPLIER';
export const TPI_SUPPLIER_SUCCESS = 'TPI_SUPPLIER_SUCCESS';
export const TPI_SUPPLIER_ERROR = 'TPI_SUPPLIER_ERROR';
export const TPI_DELIVERY_ORDER = 'TPI_DELIVERY_ORDER';
export const TPI_DELIVERY_ORDER_SUCCESS = 'TPI_DELIVERY_ORDER_SUCCESS';
export const TPI_DELIVERY_ORDER_ERROR = 'TPI_ATC_DELIVERY_ORDER_ERROR';
export const TPI_STATUS_DOCS = 'TPI_STATUS_DOCS';
export const TPI_STATUS_DOCS_SUCCESS = 'TPI_STATUS_DOCS_SUCCESS';
export const TPI_STATUS_DOCS_ERROR = 'TPI_STATUS_DOCS_ERROR';
export const TPI_LIST = 'TPI_LIST';
export const TPI_LIST_SUCCESS = 'TPI_LIST_SUCCESS';
export const TPI_LIST_ERROR = 'TPI_LIST_ERROR';
export const TPI_LIST_SEARCH_CHANGE = 'TPI_LIST_SEARCH_CHANGE';
export const TPI_LIST_PAGE_SET = 'TPI_LIST_PAGE_SET';
export const TPI_EDIT_MODAL_SET = 'TPI_EDIT_MODAL_SET';
export const TPI_EDIT_CHANGE_SET = 'TPI_EDIT_CHANGE_SET';
export const TPI_EDIT = 'TPI_EDIT';
export const TPI_EDIT_SUCCESS = 'TPI_EDIT_SUCCESS';
export const TPI_EDIT_ERROR = 'TPI_EDIT_ERROR';
export const TPI_MTO_MODAL_SET = 'TPI_MTO_MODAL_SET';
export const TPI_MTO_CHANGE_SET = 'TPI_MTO_CHANGE_SET';
export const TPI_MTO_DETAIL = 'TPI_MTO_DETAIL';
export const TPI_MTO_DETAIL_SUCCESS = 'TPI_MTO_DETAIL_SUCCESS';
export const TPI_MTO_DETAIL_ERROR = 'TPI_MTO_DETAIL_ERROR';
export const TPI_EDIT_MTO_MODAL_SET = 'TPI_EDIT_MTO_MODAL_SET';
export const TPI_EDIT_MTO_CHANGE_SET = 'TPI_EDIT_MTO_CHANGE_SET';
export const TPI_EDIT_MTO = 'TPI_EDIT_MTO';
export const TPI_EDIT_MTO_SUCCESS = 'TPI_EDIT_MTO_SUCCESS';
export const TPI_EDIT_MTO_ERROR = 'TPI_EDIT_MTO_ERROR';
export const TPI_PROJECTION_MAINTENANCE_DATES = 'TPI_PROJECTION_MAINTENANCE_DATES';
export const TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS = 'TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS';
export const TPI_PROJECTION_MAINTENANCE_DATES_ERROR = 'TPI_PROJECTION_MAINTENANCE_DATES_ERROR';
export const TPI_DOCUMENTATION = 'TPI_DOCUMENTATION';
export const TPI_DOCUMENTATION_SUCCESS = 'TPI_DOCUMENTATION_SUCCESS';
export const TPI_DOCUMENTATION_ERROR = 'TPI_DOCUMENTATION_ERROR';

/********************EQUIPMENT / ASSIGN TECHNIC *******************************************************/
export const EQP_ASSIGN_USER = 'EQP_ASSIGN_USER';
export const EQP_ASSIGN_USER_SUCCESS = 'EQP_ASSIGN_USER_SUCCESS';
export const EQP_ASSIGN_USER_ERROR = 'EQP_ASSIGN_USER_ERROR';
export const EQP_ASSIGN_TECH_USER_LIST = 'EQP_ASSIGN_TECH_USER_LIST';
export const EQP_ASSIGN_TECH_USER_LIST_SUCCESS = 'EQP_ASSIGN_TECH_USER_LIST_SUCCESS';
export const EQP_ASSIGN_TECH_USER_LIST_ERROR = 'EQP_ASSIGN_TECH_USER_LIST_ERROR';
export const EQP_ASSIGN_UNIT_HEALTH = 'EQP_ASSIGN_UNIT_HEALTH';
export const EQP_ASSIGN_UNIT_HEALTH_SUCCESS = 'EQP_ASSIGN_UNIT_HEALTH_SUCCESS';
export const EQP_ASSIGN_UNIT_HEALTH_ERROR = 'EQP_ASSIGN_UNIT_HEALTH_ERROR';
export const EQP_ASSIGN_DELIVERY_ORDER = 'EQP_ASSIGN_DELIVERY_ORDER';
export const EQP_ASSIGN_DELIVERY_ORDER_SUCCESS = 'EQP_ASSIGN_DELIVERY_ORDER_SUCCESS';
export const EQP_ASSIGN_DELIVERY_ORDER_ERROR = 'EQP_ASSIGN_DELIVERY_ORDER_ERROR';
export const EQP_ASSIGN_EQUIPMENT = 'EQP_ASSIGN_EQUIPMENT';
export const EQP_ASSIGN_EQUIPMENT_SUCCESS = 'EQP_ASSIGN_EQUIPMENT_SUCCESS';
export const EQP_ASSIGN_EQUIPMENT_ERROR = 'EQP_ASSIGN_EQUIPMENT_ERROR';
export const EQP_ASSIGN_DOCUMENT_TYPE = 'EQP_ASSIGN_DOCUMENT_TYPE';
export const EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS = 'EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS';
export const EQP_ASSIGN_DOCUMENT_TYPE_ERROR = 'EQP_ASSIGN_DOCUMENT_TYPE_ERROR';
export const EQP_ASSIGN_USER_ASSIGN = 'EQP_ASSIGN_USER_ASSIGN';
export const EQP_ASSIGN_USER_ASSIGN_SUCCESS = 'EQP_ASSIGN_USER_ASSIGN_SUCCESS';
export const EQP_ASSIGN_USER_ASSIGN_ERROR = 'EQP_ASSIGN_USER_ASSIGN_ERROR';
export const EQP_ASSIGN_LIST = 'EQP_ASSIGN_LIST';
export const EQP_ASSIGN_LIST_SUCCESS = 'EQP_ASSIGN_LIST_SUCCESS';
export const EQP_ASSIGN_LIST_ERROR = 'EQP_ASSIGN_LIST_ERROR';
export const EQP_ASSIGN_LIST_SEARCH_CHANGE = 'EQP_ASSIGN_LIST_SEARCH_CHANGE';
export const EQP_ASSIGN_LIST_PAGE_SET = 'EQP_ASSIGN_LIST_PAGE_SET';
export const EQP_ASSIGN = 'EQP_ASSIGN';
export const EQP_ASSIGN_SUCCESS = 'EQP_ASSIGN_SUCCESS';
export const EQP_ASSIGN_ERROR = 'EQP_ASSIGN_ERROR';
export const EQP_ASSIGN_HISTORY = 'EQP_ASSIGN_HISTORY';
export const EQP_ASSIGN_HISTORY_SUCCESS = 'EQP_ASSIGN_HISTORY_SUCCESS';
export const EQP_ASSIGN_HISTORY_ERROR = 'EQP_ASSIGN_HISTORY_ERROR';

/********************EQUIPMENT / VALIDATION DOCUMENT REVIEW *******************************************************/
export const VDR_DATA_USER = 'VDR_DATA_USER';
export const VDR_DATA_USER_SUCCESS = 'VDR_DATA_USER_SUCCESS';
export const VDR_DATA_USER_ERROR = 'VDR_DATA_USER_ERROR';
export const VDR_DOCUMENT_TYPE = 'VDR_DOCUMENT_TYPE';
export const VDR_DOCUMENT_TYPE_SUCCESS = 'VDR_DOCUMENT_TYPE_SUCCESS';
export const VDR_DOCUMENT_TYPE_ERROR = 'VDR_DOCUMENT_TYPE_ERROR';
export const VDR_DELIVERY_ORDER = 'VDR_DELIVERY_ORDER';
export const VDR_DELIVERY_ORDER_SUCCESS = 'VDR_DELIVERY_ORDER_SUCCESS';
export const VDR_DELIVERY_ORDER_ERROR = 'VDR_DELIVERY_ORDER_ERROR';
export const VDR_SUPPLIER = 'VDR_SUPPLIER';
export const VDR_SUPPLIER_SUCCESS = 'VDR_SUPPLIER_SUCCESS';
export const VDR_SUPPLIER_ERROR = 'VDR_SUPPLIER_ERROR';
export const VDR_EQUIPMENT = 'VDR_EQUIPMENT';
export const VDR_EQUIPMENT_SUCCESS = 'VDR_EQUIPMENT_SUCCESS';
export const VDR_EQUIPMENT_ERROR = 'VDR_EQUIPMENT_ERROR';
export const VDR_SERIAL = 'VDR_SERIAL';
export const VDR_SERIAL_SUCCESS = 'VDR_SERIAL_SUCCESS';
export const VDR_SERIAL_ERROR = 'VDR_SERIAL_ERROR';
export const VDR_STATUS_REVIEW = 'VDR_STATUS_REVIEW';
export const VDR_STATUS_REVIEW_SUCCESS = 'VDR_STATUS_REVIEW_SUCCESS';
export const VDR_STATUS_REVIEW_ERROR = 'VDR_STATUS_REVIEW_ERROR';
export const VDR_USER_REVIEW = 'VDR_USER_REVIEW';
export const VDR_USER_REVIEW_SUCCESS = 'VDR_USER_REVIEW_SUCCESS';
export const VDR_USER_REVIEW_ERROR = 'VDR_USER_REVIEW_ERROR';
export const VDR_STATUS_DOCS = 'VDR_STATUS_DOCS';
export const VDR_STATUS_DOCS_SUCCESS = 'VDR_STATUS_DOCS_SUCCESS';
export const VDR_STATUS_DOCS_ERROR = 'VDR_STATUS_DOCS_ERROR';
export const VDR_UNIT_HEALTH = 'VDR_UNIT_HEALTH';
export const VDR_UNIT_HEALTH_SUCCESS = 'VDR_UNIT_HEALTH_SUCCESS';
export const VDR_UNIT_HEALTH_ERROR = 'VDR_UNIT_HEALTH_ERROR';
export const VDR_LIST = 'VDR_LIST';
export const VDR_LIST_SUCCESS = 'VDR_LIST_SUCCESS';
export const VDR_LIST_ERROR = 'VDR_LIST_ERROR';
export const VDR_LIST_SEARCH_CHANGE = 'VDR_LIST_SEARCH_CHANGE';
export const VDR_LIST_PAGE_SET = 'VDR_LIST_PAGE_SET';
export const VDR_VALIDATE_MODAL_SET = 'VDR_VALIDATE_MODAL_SET';
export const VDR_VALIDATE_CHANGE_SET = 'VDR_VALIDATE_CHANGE_SET';
export const VDR_VALIDATE = 'VDR_VALIDATE';
export const VDR_VALIDATE_SUCCESS = 'VDR_VALIDATE_SUCCESS';
export const VDR_VALIDATE_ERROR = 'VDR_VALIDATE_ERROR';
export const VDR_CHECKLIST_VALIDATION = 'VDR_CHECKLIST_VALIDATION';
export const VDR_CHECKLIST_VALIDATION_SUCCESS = 'VDR_CHECKLIST_VALIDATION_SUCCESS';
export const VDR_CHECKLIST_VALIDATION_ERROR = 'VDR_CHECKLIST_VALIDATION_ERROR';
export const VDR_SEE_VALIDATE_MODAL_SET = 'VDR_SEE_VALIDATE_MODAL_SET';
export const VDR_SEE_VALIDATE_CHANGE_SET = 'VDR_SEE_VALIDATE_CHANGE_SET';
export const VDR_SEE_VALIDATE = 'VDR_SEE_VALIDATE';
export const VDR_SEE_VALIDATE_SUCCESS = 'VDR_SEE_VALIDATE_SUCCESS';
export const VDR_SEE_VALIDATE_ERROR = 'VDR_SEE_VALIDATE_ERROR';

/********************HOSPITAL NET - EVALUATION*******************************************************/
export const HOSPITAL_EVALUATION_LIST = 'HOSPITAL_EVALUATION_LIST';
export const HOSPITAL_EVALUATION_LIST_SUCCESS = 'HOSPITAL_EVALUATION_LIST_SUCCESS';
export const HOSPITAL_EVALUATION_LIST_ERROR = 'HOSPITAL_EVALUATION_LIST_ERROR';
export const HOSPITAL_EVALUATION_DESTINATION = 'HOSPITAL_EVALUATION_DESTINATION';
export const HOSPITAL_EVALUATION_DESTINATION_SUCCESS = 'HOSPITAL_EVALUATION_DESTINATION_SUCCESS';
export const HOSPITAL_EVALUATION_DESTINATION_ERROR = 'HOSPITAL_EVALUATION_DESTINATION_ERROR';
export const HOSPITAL_EVALUATION_AREA = 'HOSPITAL_EVALUATION_AREA';
export const HOSPITAL_EVALUATION_AREA_SUCCESS = 'HOSPITAL_EVALUATION_AREA_SUCCESS';
export const HOSPITAL_EVALUATION_AREA_ERROR = 'HOSPITAL_EVALUATION_AREA_ERROR';
export const HOSPITAL_EVALUATION_JOB = 'HOSPITAL_EVALUATION_JOB';
export const HOSPITAL_EVALUATION_JOB_SUCCESS = 'HOSPITAL_EVALUATION_JOB_SUCCESS';
export const HOSPITAL_EVALUATION_JOB_ERROR = 'HOSPITAL_EVALUATION_JOB_ERROR';
export const HOSPITAL_EVALUATION_ADD_MODAL_SET = 'HOSPITAL_EVALUATION_ADD_MODAL_SET';
export const HOSPITAL_EVALUATION_ADD_CHANGE_SET = 'HOSPITAL_EVALUATION_ADD_CHANGE_SET';
export const HOSPITAL_EVALUATION_ADD = 'HOSPITAL_EVALUATION_ADD';
export const HOSPITAL_EVALUATION_ADD_SUCCESS = 'HOSPITAL_EVALUATION_ADD_SUCCESS';
export const HOSPITAL_EVALUATION_ADD_ERROR = 'HOSPITAL_EVALUATION_ADD_ERROR';
export const HOSPITAL_EVALUATION_TAB_SET = 'HOSPITAL_EVALUATION_TAB_SET';
export const HOSPITAL_EVALUATION_CAPACITY_INSTALL = 'HOSPITAL_EVALUATION_CAPACITY_INSTALL';
export const HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS = 'HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS';
export const HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR = 'HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR';
export const HOSPITAL_EVALUATION_INFRASTRUCTURE = 'HOSPITAL_EVALUATION_INFRASTRUCTURE';
export const HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS = 'HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS';
export const HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR = 'HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR';
export const HOSPITAL_EVALUATION_HUMAN_TALENT = 'HOSPITAL_EVALUATION_HUMAN_TALENT';
export const HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS = 'HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS';
export const HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR = 'HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR';
export const HOSPITAL_EVALUATION_PRODUCTION = 'HOSPITAL_EVALUATION_PRODUCTION';
export const HOSPITAL_EVALUATION_PRODUCTION_SUCCESS = 'HOSPITAL_EVALUATION_PRODUCTION_SUCCESS';
export const HOSPITAL_EVALUATION_PRODUCTION_ERROR = 'HOSPITAL_EVALUATION_PRODUCTION_ERROR';
export const HOSPITAL_EVALUATION_AVAILABILITY = 'HOSPITAL_EVALUATION_AVAILABILITY';
export const HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS = 'HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS';
export const HOSPITAL_EVALUATION_AVAILABILITY_ERROR = 'HOSPITAL_EVALUATION_AVAILABILITY_ERROR';

/* ASSESSMENT */

/* ASSESSMENT */
export const ASSESSMENT_LIST = 'ASSESSMENT_LIST';
export const ASSESSMENT_LIST_SUCCESS = 'ASSESSMENT_LIST_SUCCESS';
export const ASSESSMENT_LIST_ERROR = 'ASSESSMENT_LIST_ERROR';
export const ASSESSMENT_PAGE_SET = 'ASSESSMENT_PAGE_SET';
export const ASSESSMENT_SEARCH_SET = 'ASSESSMENT_SEARCH_SET';
export const ASSESSMENT_SEARCH_ASSESSMENT_TYPE = 'ASSESSMENT_SEARCH_ASSESSMENT_TYPE';
export const ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS = 'ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS';
export const ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR = 'ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR';
export const ASSESSMENT_SEARCH_CHANGE = 'ASSESSMENT_SEARCH_CHANGE';
export const ASSESSMENT_ADD_SET = 'ASSESSMENT_ADD_SET';
export const ASSESSMENT_ADD_MODAL_SET = 'ASSESSMENT_ADD_MODAL_SET';
export const ASSESSMENT_ADD = 'ASSESSMENT_ADD';
export const ASSESSMENT_ADD_SUCCESS = 'ASSESSMENT_ADD_SUCCESS';
export const ASSESSMENT_ADD_ERROR = 'ASSESSMENT_ADD_ERROR';
export const ASSESSMENT_ADD_CHANGE = 'ASSESSMENT_ADD_CHANGE';
export const ASSESSMENT_DETAIL = 'ASSESSMENT_DETAIL';
export const ASSESSMENT_DETAIL_SUCCESS = 'ASSESSMENT_DETAIL_SUCCESS';
export const ASSESSMENT_DETAIL_ERROR = 'ASSESSMENT_DETAIL_ERROR';
export const ASSESSMENT_VIEW_MODAL_SET = 'ASSESSMENT_VIEW_MODAL_SET';
export const ASSESSMENT_EDIT_MODAL_SET = 'ASSESSMENT_EDIT_MODAL_SET';
export const ASSESSMENT_EDIT_SET = 'ASSESSMENT_EDIT_SET';
export const ASSESSMENT_EDIT_CHANGE = 'ASSESSMENT_EDIT_CHANGE';
export const ASSESSMENT_UPDATE = 'ASSESSMENT_UPDATE';
export const ASSESSMENT_UPDATE_SUCCESS = 'ASSESSMENT_UPDATE_SUCCESS';
export const ASSESSMENT_UPDATE_ERROR = 'ASSESSMENT_UPDATE_ERROR';
export const ASSESSMENT_VIEW_TAB_SET = 'ASSESSMENT_VIEW_TAB_SET';
export const ASSESSMENT_UPLOAD_SET = 'ASSESSMENT_UPLOAD_SET';
export const ASSESSMENT_UPLOAD_SET_SUCCESS = 'ASSESSMENT_UPLOAD_SET_SUCCESS';
export const ASSESSMENT_UPLOAD_SET_ERROR = 'ASSESSMENT_UPLOAD_SET_ERROR';
export const ASSESSMENT_UPLOAD_RESET = 'ASSESSMENT_UPLOAD_RESET';

/* SECTION */
export const SECTION_LIST = 'SECTION_LIST';
export const SECTION_LIST_SUCCESS = 'SECTION_LIST_SUCCESS';
export const SECTION_LIST_ERROR = 'SECTION_LIST_ERROR';
export const SECTION_PAGE_SET = 'SECTION_PAGE_SET';
export const SECTION_SEARCH_SET = 'SECTION_SEARCH_SET';
export const SECTION_SEARCH_CHANGE = 'SECTION_SEARCH_CHANGE';
export const SECTION_SEARCH_ASSESSMENT_LIST = 'SECTION_SEARCH_ASSESSMENT_LIST';
export const SECTION_SEARCH_ASSESSMENT_LIST_SUCCESS = 'SECTION_SEARCH_ASSESSMENT_SUCCESS';
export const SECTION_SEARCH_ASSESSMENT_LIST_ERROR = 'SECTION_SEARCH_ASSESSMENT_LIST_ERROR';
export const SECTION_ADD_SET = 'SECTION_ADD_SET';
export const SECTION_ADD_MODAL_SET = 'SECTION_ADD_MODAL_SET';
export const SECTION_ADD = 'SECTION_ADD';
export const SECTION_ADD_SUCCESS = 'SECTION_ADD_SUCCESS';
export const SECTION_ADD_ERROR = 'SECTION_ADD_ERROR';
export const SECTION_ADD_CHANGE = 'SECTION_ADD_CHANGE';
export const SECTION_DETAIL = 'SECTION_DETAIL';
export const SECTION_DETAIL_SUCCESS = 'SECTION_DETAIL_SUCCESS';
export const SECTION_DETAIL_ERROR = 'SECTION_DETAIL_ERROR';
export const SECTION_VIEW_MODAL_SET = 'SECTION_VIEW_MODAL_SET';
export const SECTION_EDIT_MODAL_SET = 'SECTION_EDIT_MODAL_SET';
export const SECTION_EDIT_SET = 'SECTION_EDIT_SET';
export const SECTION_EDIT_CHANGE = 'SECTION_EDIT_CHANGE';
export const SECTION_UPDATE = 'SECTION_UPDATE';
export const SECTION_UPDATE_SUCCESS = 'SECTION_UPDATE_SUCCESS';
export const SECTION_UPDATE_ERROR = 'SECTION_UPDATE_ERROR';
export const SECTION_VIEW_TAB_SET = 'SECTION_VIEW_TAB_SET';
export const SECTION_UPLOAD_SET = 'SECTION_UPLOAD_SET';
export const SECTION_UPLOAD_SET_SUCCESS = 'SECTION_UPLOAD_SET_SUCCESS';
export const SECTION_UPLOAD_SET_ERROR = 'SECTION_UPLOAD_SET_ERROR';
export const SECTION_UPLOAD_RESET = 'SECTION_UPLOAD_RESET';

/* QUESTION */
export const QUESTION_LIST = 'QUESTION_LIST';
export const QUESTION_LIST_SUCCESS = 'QUESTION_LIST_SUCCESS';
export const QUESTION_LIST_ERROR = 'QUESTION_LIST_ERROR';
export const QUESTION_PAGE_SET = 'QUESTION_PAGE_SET';
export const QUESTION_SEARCH_SET = 'QUESTION_SEARCH_SET';
export const QUESTION_SEARCH_CHANGE = 'QUESTION_SEARCH_CHANGE';
export const QUESTION_SEARCH_SECTION_LIST = 'QUESTION_SEARCH_SECTION_LIST';
export const QUESTION_SEARCH_SECTION_LIST_SUCCESS = 'QUESTION_SEARCH_SECTION_SUCCESS';
export const QUESTION_SEARCH_SECTION_LIST_ERROR = 'QUESTION_SEARCH_SECTION_LIST_ERROR';
export const QUESTION_ADD_SET = 'QUESTION_ADD_SET';
export const QUESTION_ADD_MODAL_SET = 'QUESTION_ADD_MODAL_SET';
export const QUESTION_ADD = 'QUESTION_ADD';
export const QUESTION_ADD_SUCCESS = 'QUESTION_ADD_SUCCESS';
export const QUESTION_ADD_ERROR = 'QUESTION_ADD_ERROR';
export const QUESTION_ADD_CHANGE = 'QUESTION_ADD_CHANGE';
export const QUESTION_DETAIL = 'QUESTION_DETAIL';
export const QUESTION_DETAIL_SUCCESS = 'QUESTION_DETAIL_SUCCESS';
export const QUESTION_DETAIL_ERROR = 'QUESTION_DETAIL_ERROR';
export const QUESTION_VIEW_MODAL_SET = 'QUESTION_VIEW_MODAL_SET';
export const QUESTION_EDIT_MODAL_SET = 'QUESTION_EDIT_MODAL_SET';
export const QUESTION_EDIT_SET = 'QUESTION_EDIT_SET';
export const QUESTION_EDIT_CHANGE = 'QUESTION_EDIT_CHANGE';
export const QUESTION_UPDATE = 'QUESTION_UPDATE';
export const QUESTION_UPDATE_SUCCESS = 'QUESTION_UPDATE_SUCCESS';
export const QUESTION_UPDATE_ERROR = 'QUESTION_UPDATE_ERROR';
export const QUESTION_VIEW_TAB_SET = 'QUESTION_VIEW_TAB_SET';
export const QUESTION_UPLOAD_SET = 'QUESTION_UPLOAD_SET';
export const QUESTION_UPLOAD_SET_SUCCESS = 'QUESTION_UPLOAD_SET_SUCCESS';
export const QUESTION_UPLOAD_SET_ERROR = 'QUESTION_UPLOAD_SET_ERROR';
export const QUESTION_UPLOAD_RESET = 'QUESTION_UPLOAD_RESET';

/* EQUIPMENT_SECTION */
export const SECTION_EQUIPMENT_AREA = 'SECTION_EQUIPMENT_AREA';
export const SECTION_EQUIPMENT_AREA_SUCCESS = 'SECTION_EQUIPMENT_AREA_SUCCESS';
export const SECTION_EQUIPMENT_AREA_ERROR = 'SECTION_EQUIPMENT_AREA_ERROR';
export const SECTION_EQUIPMENT_COMPLEXITY = 'SECTION_EQUIPMENT_COMPLEXITY';
export const SECTION_EQUIPMENT_COMPLEXITY_SUCCESS = 'SECTION_EQUIPMENT_COMPLEXITY_SUCCESS';
export const SECTION_EQUIPMENT_COMPLEXITY_ERROR = 'SECTION_EQUIPMENT_COMPLEXITY_ERROR';
export const SECTION_EQUIPMENT_EQUIPMENT = 'SECTION_EQUIPMENT_EQUIPMENT';
export const SECTION_EQUIPMENT_EQUIPMENT_SUCCESS = 'SECTION_EQUIPMENT_EQUIPMENT_SUCCESS';
export const SECTION_EQUIPMENT_EQUIPMENT_ERROR = 'SECTION_EQUIPMENT_EQUIPMENT_ERROR';
export const SECTION_EQUIPMENT_LIST = 'SECTION_EQUIPMENT_LIST';
export const SECTION_EQUIPMENT_LIST_SUCCESS = 'SECTION_EQUIPMENT_LIST_SUCCESS';
export const SECTION_EQUIPMENT_LIST_ERROR = 'SECTION_EQUIPMENT_LIST_ERROR';
export const SECTION_EQUIPMENT_ADD = 'SECTION_EQUIPMENT_ADD';
export const SECTION_EQUIPMENT_ADD_SUCCESS = 'SECTION_EQUIPMENT_ADD_SUCCESS';
export const SECTION_EQUIPMENT_ADD_ERROR = 'SECTION_EQUIPMENT_ADD_ERROR';
export const SECTION_EQUIPMENT_ADD_CHANGE = 'SECTION_EQUIPMENT_ADD_CHANGE';
export const SECTION_EQUIPMENT_EDIT_SET = 'SECTION_EQUIPMENT_EDIT_SET';
export const SECTION_EQUIPMENT_EDIT_CHANGE = 'SECTION_EQUIPMENT_EDIT_CHANGE';
export const SECTION_EQUIPMENT_UPDATE = 'SECTION_EQUIPMENT_UPDATE';
export const SECTION_EQUIPMENT_UPDATE_SUCCESS = 'SECTION_EQUIPMENT_UPDATE_SUCCESS';
export const SECTION_EQUIPMENT_UPDATE_ERROR = 'SECTION_EQUIPMENT_UPDATE_ERROR';


/* ANSWER */
export const ANSWER_LIST = 'ANSWER_LIST';
export const ANSWER_LIST_SUCCESS = 'ANSWER_LIST_SUCCESS';
export const ANSWER_LIST_ERROR = 'ANSWER_LIST_ERROR';
export const ANSWER_PAGE_SET = 'ANSWER_PAGE_SET';
export const ANSWER_SEARCH_SET = 'ANSWER_SEARCH_SET';
export const ANSWER_SEARCH_CHANGE = 'ANSWER_SEARCH_CHANGE';
export const ANSWER_SEARCH_ASSESSMENT_LIST = 'ANSWER_SEARCH_ASSESSMENT_LIST';
export const ANSWER_SEARCH_ASSESSMENT_LIST_SUCCESS = 'ANSWER_SEARCH_ASSESSMENT_SUCCESS';
export const ANSWER_SEARCH_ASSESSMENT_LIST_ERROR = 'ANSWER_SEARCH_ASSESSMENT_LIST_ERROR';
export const ANSWER_ADD_SET = 'ANSWER_ADD_SET';
export const ANSWER_ADD_MODAL_SET = 'ANSWER_ADD_MODAL_SET';
export const ANSWER_ADD = 'ANSWER_ADD';
export const ANSWER_ADD_SUCCESS = 'ANSWER_ADD_SUCCESS';
export const ANSWER_ADD_ERROR = 'ANSWER_ADD_ERROR';
export const ANSWER_ADD_CHANGE = 'ANSWER_ADD_CHANGE';
export const ANSWER_DETAIL = 'ANSWER_DETAIL';
export const ANSWER_DETAIL_SUCCESS = 'ANSWER_DETAIL_SUCCESS';
export const ANSWER_DETAIL_ERROR = 'ANSWER_DETAIL_ERROR';
export const ANSWER_VIEW_MODAL_SET = 'ANSWER_VIEW_MODAL_SET';
export const ANSWER_EDIT_MODAL_SET = 'ANSWER_EDIT_MODAL_SET';
export const ANSWER_EDIT_SET = 'ANSWER_EDIT_SET';
export const ANSWER_EDIT_CHANGE = 'ANSWER_EDIT_CHANGE';
export const ANSWER_UPDATE = 'ANSWER_UPDATE';
export const ANSWER_UPDATE_SUCCESS = 'ANSWER_UPDATE_SUCCESS';
export const ANSWER_UPDATE_ERROR = 'ANSWER_UPDATE_ERROR';
export const ANSWER_VIEW_TAB_SET = 'ANSWER_VIEW_TAB_SET';
export const ANSWER_UPLOAD_SET = 'ANSWER_UPLOAD_SET';
export const ANSWER_UPLOAD_SET_SUCCESS = 'ANSWER_UPLOAD_SET_SUCCESS';
export const ANSWER_UPLOAD_SET_ERROR = 'ANSWER_UPLOAD_SET_ERROR';
export const ANSWER_UPLOAD_RESET = 'ANSWER_UPLOAD_RESET';

/* ASSESSMENT_PROJECT */
export const ASSESSMENT_PROJECT_LIST = 'ASSESSMENT_PROJECT_LIST';
export const ASSESSMENT_PROJECT_LIST_SUCCESS = 'ASSESSMENT_PROJECT_LIST_SUCCESS';
export const ASSESSMENT_PROJECT_LIST_ERROR = 'ASSESSMENT_PROJECT_LIST_ERROR';
export const ASSESSMENT_PROJECT_PAGE_SET = 'ASSESSMENT_PROJECT_PAGE_SET';
export const ASSESSMENT_PROJECT_SEARCH_SET = 'ASSESSMENT_PROJECT_SEARCH_SET';
export const ASSESSMENT_PROJECT_SEARCH_CHANGE = 'ASSESSMENT_PROJECT_SEARCH_CHANGE';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS';
export const ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR = 'ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR';
export const ASSESSMENT_PROJECT_SEARCH_DESTINATION = 'ASSESSMENT_PROJECT_SEARCH_DESTINATION';
export const ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS = 'ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS';
export const ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR = 'ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR';
export const ASSESSMENT_PROJECT_SEARCH_CONTRACT = 'ASSESSMENT_PROJECT_SEARCH_CONTRACT';
export const ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS = 'ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS';
export const ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR = 'ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR';
export const ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE = 'ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE';
export const ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS = 'ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS';
export const ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR = 'ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR';
export const ASSESSMENT_PROJECT_ADD_SET = 'ASSESSMENT_PROJECT_ADD_SET';
export const ASSESSMENT_PROJECT_ADD_MODAL_SET = 'ASSESSMENT_PROJECT_ADD_MODAL_SET';
export const ASSESSMENT_PROJECT_ADD = 'ASSESSMENT_PROJECT_ADD';
export const ASSESSMENT_PROJECT_ADD_SUCCESS = 'ASSESSMENT_PROJECT_ADD_SUCCESS';
export const ASSESSMENT_PROJECT_ADD_ERROR = 'ASSESSMENT_PROJECT_ADD_ERROR';
export const ASSESSMENT_PROJECT_ADD_CHANGE = 'ASSESSMENT_PROJECT_ADD_CHANGE';
export const ASSESSMENT_PROJECT_DETAIL = 'ASSESSMENT_PROJECT_DETAIL';
export const ASSESSMENT_PROJECT_DETAIL_SUCCESS = 'ASSESSMENT_PROJECT_DETAIL_SUCCESS';
export const ASSESSMENT_PROJECT_DETAIL_ERROR = 'ASSESSMENT_PROJECT_DETAIL_ERROR';
export const ASSESSMENT_PROJECT_VIEW_MODAL_SET = 'ASSESSMENT_PROJECT_VIEW_MODAL_SET';
export const ASSESSMENT_PROJECT_EDIT_MODAL_SET = 'ASSESSMENT_PROJECT_EDIT_MODAL_SET';
export const ASSESSMENT_PROJECT_EDIT_SET = 'ASSESSMENT_PROJECT_EDIT_SET';
export const ASSESSMENT_PROJECT_EDIT_CHANGE = 'ASSESSMENT_PROJECT_EDIT_CHANGE';
export const ASSESSMENT_PROJECT_UPDATE = 'ASSESSMENT_PROJECT_UPDATE';
export const ASSESSMENT_PROJECT_UPDATE_SUCCESS = 'ASSESSMENT_PROJECT_UPDATE_SUCCESS';
export const ASSESSMENT_PROJECT_UPDATE_ERROR = 'ASSESSMENT_PROJECT_UPDATE_ERROR';
export const ASSESSMENT_PROJECT_VIEW_TAB_SET = 'ASSESSMENT_PROJECT_VIEW_TAB_SET';

/* EVALUATION */
export const EVALUATION_LIST = 'EVALUATION_LIST';
export const EVALUATION_LIST_SUCCESS = 'EVALUATION_LIST_SUCCESS';
export const EVALUATION_LIST_ERROR = 'EVALUATION_LIST_ERROR';
export const EVALUATION_PAGE_SET = 'EVALUATION_PAGE_SET';
export const EVALUATION_SEARCH_SET = 'EVALUATION_SEARCH_SET';
export const EVALUATION_SEARCH_CHANGE = 'EVALUATION_SEARCH_CHANGE';
export const EVALUATION_SEARCH_ASSESSMENT = 'EVALUATION_SEARCH_ASSESSMENT';
export const EVALUATION_SEARCH_ASSESSMENT_SUCCESS = 'EVALUATION_SEARCH_ASSESSMENT_SUCCESS';
export const EVALUATION_SEARCH_ASSESSMENT_ERROR = 'EVALUATION_SEARCH_ASSESSMENT_ERROR';
export const EVALUATION_SEARCH_ASSESSMENT_PROJECT = 'EVALUATION_SEARCH_ASSESSMENT_PROJECT';
export const EVALUATION_SEARCH_ASSESSMENT_PROJECT_SUCCESS = 'EVALUATION_SEARCH_ASSESSMENT_PROJECT_SUCCESS';
export const EVALUATION_SEARCH_ASSESSMENT_PROJECT_ERROR = 'EVALUATION_SEARCH_ASSESSMENT_PROJECT_ERROR';
export const EVALUATION_ADD_SET = 'EVALUATION_ADD_SET';
export const EVALUATION_ADD_MODAL_SET = 'EVALUATION_ADD_MODAL_SET';
export const EVALUATION_ADD = 'EVALUATION_ADD';
export const EVALUATION_ADD_SUCCESS = 'EVALUATION_ADD_SUCCESS';
export const EVALUATION_ADD_ERROR = 'EVALUATION_ADD_ERROR';
export const EVALUATION_ADD_CHANGE = 'EVALUATION_ADD_CHANGE';
export const EVALUATION_GET = 'EVALUATION_GET';
export const EVALUATION_GET_SUCCESS = 'EVALUATION_GET_SUCCESS';
export const EVALUATION_GET_ERROR = 'EVALUATION_GET_ERROR';
export const EVALUATION_DETAIL = 'EVALUATION_DETAIL';
export const EVALUATION_DETAIL_SUCCESS = 'EVALUATION_DETAIL_SUCCESS';
export const EVALUATION_DETAIL_ERROR = 'EVALUATION_DETAIL_ERROR';
export const EVALUATION_VIEW_MODAL_SET = 'EVALUATION_VIEW_MODAL_SET';
export const EVALUATION_EDIT_MODAL_SET = 'EVALUATION_EDIT_MODAL_SET';
export const EVALUATION_EDIT_SET = 'EVALUATION_EDIT_SET';
export const EVALUATION_EDIT_CHANGE = 'EVALUATION_EDIT_CHANGE';
export const EVALUATION_UPDATE = 'EVALUATION_UPDATE';
export const EVALUATION_UPDATE_SUCCESS = 'EVALUATION_UPDATE_SUCCESS';
export const EVALUATION_UPDATE_ERROR = 'EVALUATION_UPDATE_ERROR';
export const EVALUATION_VIEW_TAB_SET = 'EVALUATION_VIEW_TAB_SET';
export const EVALUATION_UPLOAD_SET = 'EVALUATION_UPLOAD_SET';
export const EVALUATION_UPLOAD_SET_SUCCESS = 'EVALUATION_UPLOAD_SET_SUCCESS';
export const EVALUATION_UPLOAD_SET_ERROR = 'EVALUATION_UPLOAD_SET_ERROR';
export const EVALUATION_UPLOAD_RESET = 'EVALUATION_UPLOAD_RESET';

/* EVALUATION_DETAIL */
export const EVALUATION_DETAIL_LIST = 'EVALUATION_DETAIL_LIST';
export const EVALUATION_DETAIL_LIST_SUCCESS = 'EVALUATION_DETAIL_LIST_SUCCESS';
export const EVALUATION_DETAIL_LIST_ERROR = 'EVALUATION_DETAIL_LIST_ERROR';
export const EVALUATION_DETAIL_PAGE_SET = 'EVALUATION_DETAIL_PAGE_SET';
export const EVALUATION_DETAIL_SEARCH_SET = 'EVALUATION_DETAIL_SEARCH_SET';
export const EVALUATION_DETAIL_SEARCH_CHANGE = 'EVALUATION_DETAIL_SEARCH_CHANGE';
export const EVALUATION_DETAIL_SEARCH_EVALUATION = 'EVALUATION_DETAIL_SEARCH_EVALUATION';
export const EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS = 'EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS';
export const EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR = 'EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR';
export const EVALUATION_DETAIL_SEARCH_ANSWER = 'EVALUATION_DETAIL_SEARCH_ANSWER';
export const EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS = 'EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS';
export const EVALUATION_DETAIL_SEARCH_ANSWER_ERROR = 'EVALUATION_DETAIL_SEARCH_ANSWER_ERROR';
export const EVALUATION_DETAIL_SEARCH_DOCUMENT = 'EVALUATION_DETAIL_SEARCH_DOCUMENT';
export const EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS = 'EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS';
export const EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR = 'EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR';
export const EVALUATION_DETAIL_ADD_SET = 'EVALUATION_DETAIL_ADD_SET';
export const EVALUATION_DETAIL_ADD_MODAL_SET = 'EVALUATION_DETAIL_ADD_MODAL_SET';
export const EVALUATION_DETAIL_ADD = 'EVALUATION_DETAIL_ADD';
export const EVALUATION_DETAIL_ADD_SUCCESS = 'EVALUATION_DETAIL_ADD_SUCCESS';
export const EVALUATION_DETAIL_ADD_ERROR = 'EVALUATION_DETAIL_ADD_ERROR';
export const EVALUATION_DETAIL_ADD_CHANGE = 'EVALUATION_DETAIL_ADD_CHANGE';
export const EVALUATION_DETAIL_DETAIL = 'EVALUATION_DETAIL_DETAIL';
export const EVALUATION_DETAIL_DETAIL_SUCCESS = 'EVALUATION_DETAIL_DETAIL_SUCCESS';
export const EVALUATION_DETAIL_DETAIL_ERROR = 'EVALUATION_DETAIL_DETAIL_ERROR';
export const EVALUATION_DETAIL_VIEW_MODAL_SET = 'EVALUATION_DETAIL_VIEW_MODAL_SET';
export const EVALUATION_DETAIL_EDIT_MODAL_SET = 'EVALUATION_DETAIL_EDIT_MODAL_SET';
export const EVALUATION_DETAIL_EDIT_SET = 'EVALUATION_DETAIL_EDIT_SET';
export const EVALUATION_DETAIL_EDIT_CHANGE = 'EVALUATION_DETAIL_EDIT_CHANGE';
export const EVALUATION_DETAIL_UPDATE = 'EVALUATION_DETAIL_UPDATE';
export const EVALUATION_DETAIL_UPDATE_SUCCESS = 'EVALUATION_DETAIL_UPDATE_SUCCESS';
export const EVALUATION_DETAIL_UPDATE_ERROR = 'EVALUATION_DETAIL_UPDATE_ERROR';
export const EVALUATION_DETAIL_VIEW_TAB_SET = 'EVALUATION_DETAIL_VIEW_TAB_SET';

/* ASSESSMENT_DOCUMENT_TYPE */
export const ASSESSMENT_DOCUMENT_TYPE_LIST = 'ASSESSMENT_DOCUMENT_TYPE_LIST';
export const ASSESSMENT_DOCUMENT_TYPE_LIST_SUCCESS = 'ASSESSMENT_DOCUMENT_TYPE_LIST_SUCCESS';
export const ASSESSMENT_DOCUMENT_TYPE_LIST_ERROR = 'ASSESSMENT_DOCUMENT_TYPE_LIST_ERROR';
export const ASSESSMENT_DOCUMENT_TYPE_PAGE_SET = 'ASSESSMENT_DOCUMENT_TYPE_PAGE_SET';
export const ASSESSMENT_DOCUMENT_TYPE_SEARCH_SET = 'ASSESSMENT_DOCUMENT_TYPE_SEARCH_SET';
export const ASSESSMENT_DOCUMENT_TYPE_SEARCH_CHANGE = 'ASSESSMENT_DOCUMENT_TYPE_SEARCH_CHANGE';
export const ASSESSMENT_DOCUMENT_TYPE_ADD_SET = 'ASSESSMENT_DOCUMENT_TYPE_ADD_SET';
export const ASSESSMENT_DOCUMENT_TYPE_ADD_MODAL_SET = 'ASSESSMENT_DOCUMENT_TYPE_ADD_MODAL_SET';
export const ASSESSMENT_DOCUMENT_TYPE_ADD = 'ASSESSMENT_DOCUMENT_TYPE_ADD';
export const ASSESSMENT_DOCUMENT_TYPE_ADD_SUCCESS = 'ASSESSMENT_DOCUMENT_TYPE_ADD_SUCCESS';
export const ASSESSMENT_DOCUMENT_TYPE_ADD_ERROR = 'ASSESSMENT_DOCUMENT_TYPE_ADD_ERROR';
export const ASSESSMENT_DOCUMENT_TYPE_ADD_CHANGE = 'ASSESSMENT_DOCUMENT_TYPE_ADD_CHANGE';
export const ASSESSMENT_DOCUMENT_TYPE_DETAIL = 'ASSESSMENT_DOCUMENT_TYPE_DETAIL';
export const ASSESSMENT_DOCUMENT_TYPE_DETAIL_SUCCESS = 'ASSESSMENT_DOCUMENT_TYPE_DETAIL_SUCCESS';
export const ASSESSMENT_DOCUMENT_TYPE_DETAIL_ERROR = 'ASSESSMENT_DOCUMENT_TYPE_DETAIL_ERROR';
export const ASSESSMENT_DOCUMENT_TYPE_VIEW_MODAL_SET = 'ASSESSMENT_DOCUMENT_TYPE_VIEW_MODAL_SET';
export const ASSESSMENT_DOCUMENT_TYPE_EDIT_MODAL_SET = 'ASSESSMENT_DOCUMENT_TYPE_EDIT_MODAL_SET';
export const ASSESSMENT_DOCUMENT_TYPE_EDIT_SET = 'ASSESSMENT_DOCUMENT_TYPE_EDIT_SET';
export const ASSESSMENT_DOCUMENT_TYPE_EDIT_CHANGE = 'ASSESSMENT_DOCUMENT_TYPE_EDIT_CHANGE';
export const ASSESSMENT_DOCUMENT_TYPE_UPDATE = 'ASSESSMENT_DOCUMENT_TYPE_UPDATE';
export const ASSESSMENT_DOCUMENT_TYPE_UPDATE_SUCCESS = 'ASSESSMENT_DOCUMENT_TYPE_UPDATE_SUCCESS';
export const ASSESSMENT_DOCUMENT_TYPE_UPDATE_ERROR = 'ASSESSMENT_DOCUMENT_TYPE_UPDATE_ERROR';
export const ASSESSMENT_DOCUMENT_TYPE_VIEW_TAB_SET = 'ASSESSMENT_DOCUMENT_TYPE_VIEW_TAB_SET';

/* ASSESSMENT_TYPE */
export const ASSESSMENT_TYPE_LIST = 'ASSESSMENT_TYPE_LIST';
export const ASSESSMENT_TYPE_LIST_SUCCESS = 'ASSESSMENT_TYPE_LIST_SUCCESS';
export const ASSESSMENT_TYPE_LIST_ERROR = 'ASSESSMENT_TYPE_LIST_ERROR';
export const ASSESSMENT_TYPE_PAGE_SET = 'ASSESSMENT_TYPE_PAGE_SET';
export const ASSESSMENT_TYPE_SEARCH_SET = 'ASSESSMENT_TYPE_SEARCH_SET';
export const ASSESSMENT_TYPE_SEARCH_CHANGE = 'ASSESSMENT_TYPE_SEARCH_CHANGE';
export const ASSESSMENT_TYPE_ADD_SET = 'ASSESSMENT_TYPE_ADD_SET';
export const ASSESSMENT_TYPE_ADD_MODAL_SET = 'ASSESSMENT_TYPE_ADD_MODAL_SET';
export const ASSESSMENT_TYPE_ADD = 'ASSESSMENT_TYPE_ADD';
export const ASSESSMENT_TYPE_ADD_SUCCESS = 'ASSESSMENT_TYPE_ADD_SUCCESS';
export const ASSESSMENT_TYPE_ADD_ERROR = 'ASSESSMENT_TYPE_ADD_ERROR';
export const ASSESSMENT_TYPE_ADD_CHANGE = 'ASSESSMENT_TYPE_ADD_CHANGE';
export const ASSESSMENT_TYPE_DETAIL = 'ASSESSMENT_TYPE_DETAIL';
export const ASSESSMENT_TYPE_DETAIL_SUCCESS = 'ASSESSMENT_TYPE_DETAIL_SUCCESS';
export const ASSESSMENT_TYPE_DETAIL_ERROR = 'ASSESSMENT_TYPE_DETAIL_ERROR';
export const ASSESSMENT_TYPE_VIEW_MODAL_SET = 'ASSESSMENT_TYPE_VIEW_MODAL_SET';
export const ASSESSMENT_TYPE_EDIT_MODAL_SET = 'ASSESSMENT_TYPE_EDIT_MODAL_SET';
export const ASSESSMENT_TYPE_EDIT_SET = 'ASSESSMENT_TYPE_EDIT_SET';
export const ASSESSMENT_TYPE_EDIT_CHANGE = 'ASSESSMENT_TYPE_EDIT_CHANGE';
export const ASSESSMENT_TYPE_UPDATE = 'ASSESSMENT_TYPE_UPDATE';
export const ASSESSMENT_TYPE_UPDATE_SUCCESS = 'ASSESSMENT_TYPE_UPDATE_SUCCESS';
export const ASSESSMENT_TYPE_UPDATE_ERROR = 'ASSESSMENT_TYPE_UPDATE_ERROR';
export const ASSESSMENT_TYPE_VIEW_TAB_SET = 'ASSESSMENT_TYPE_VIEW_TAB_SET';
export const ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY = 'ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY';
export const ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCCESS = 'ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCESS';
export const ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR = 'ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR';

/* DOCUMENT */
export const DOCUMENT_LIST = 'DOCUMENT_LIST';
export const DOCUMENT_LIST_SUCCESS = 'DOCUMENT_LIST_SUCCESS';
export const DOCUMENT_LIST_ERROR = 'DOCUMENT_LIST_ERROR';
export const DOCUMENT_PAGE_SET = 'DOCUMENT_PAGE_SET';
export const DOCUMENT_SEARCH_SET = 'DOCUMENT_SEARCH_SET';
export const DOCUMENT_SEARCH_CHANGE = 'DOCUMENT_SEARCH_CHANGE';
export const DOCUMENT_SEARCH_DOCUMENT_TYPE = 'DOCUMENT_SEARCH_DOCUMENT_TYPE';
export const DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS = 'DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS';
export const DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR = 'DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR';
export const DOCUMENT_ADD_SET = 'DOCUMENT_ADD_SET';
export const DOCUMENT_ADD_MODAL_SET = 'DOCUMENT_ADD_MODAL_SET';
export const DOCUMENT_ADD = 'DOCUMENT_ADD';
export const DOCUMENT_ADD_SUCCESS = 'DOCUMENT_ADD_SUCCESS';
export const DOCUMENT_ADD_ERROR = 'DOCUMENT_ADD_ERROR';
export const DOCUMENT_ADD_CHANGE = 'DOCUMENT_ADD_CHANGE';
export const DOCUMENT_DETAIL = 'DOCUMENT_DETAIL';
export const DOCUMENT_DETAIL_SUCCESS = 'DOCUMENT_DETAIL_SUCCESS';
export const DOCUMENT_DETAIL_ERROR = 'DOCUMENT_DETAIL_ERROR';
export const DOCUMENT_VIEW_MODAL_SET = 'DOCUMENT_VIEW_MODAL_SET';
export const DOCUMENT_EDIT_MODAL_SET = 'DOCUMENT_EDIT_MODAL_SET';
export const DOCUMENT_EDIT_SET = 'DOCUMENT_EDIT_SET';
export const DOCUMENT_EDIT_CHANGE = 'DOCUMENT_EDIT_CHANGE';
export const DOCUMENT_UPDATE = 'DOCUMENT_UPDATE';
export const DOCUMENT_UPDATE_SUCCESS = 'DOCUMENT_UPDATE_SUCCESS';
export const DOCUMENT_UPDATE_ERROR = 'DOCUMENT_UPDATE_ERROR';
export const DOCUMENT_VIEW_TAB_SET = 'DOCUMENT_VIEW_TAB_SET';
export const DOCUMENT_UPLOAD_SET = 'DOCUMENT_UPLOAD_SET';
export const DOCUMENT_UPLOAD_SET_SUCCESS = 'DOCUMENT_UPLOAD_SET_SUCCESS';
export const DOCUMENT_UPLOAD_SET_ERROR = 'DOCUMENT_UPLOAD_SET_ERROR';
export const DOCUMENT_UPLOAD_RESET = 'DOCUMENT_UPLOAD_RESET';

/* EVALUATION_STATE */
export const EVALUATION_STATE_LIST = 'EVALUATION_STATE_LIST';
export const EVALUATION_STATE_LIST_SUCCESS = 'EVALUATION_STATE_LIST_SUCCESS';
export const EVALUATION_STATE_LIST_ERROR = 'EVALUATION_STATE_LIST_ERROR';
export const EVALUATION_STATE_PAGE_SET = 'EVALUATION_STATE_PAGE_SET';
export const EVALUATION_STATE_SEARCH_SET = 'EVALUATION_STATE_SEARCH_SET';
export const EVALUATION_STATE_SEARCH_CHANGE = 'EVALUATION_STATE_SEARCH_CHANGE';
export const EVALUATION_STATE_SEARCH_ASSESSMENT_LIST = 'EVALUATION_STATE_SEARCH_ASSESSMENT_LIST';
export const EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_SUCCESS = 'EVALUATION_STATE_SEARCH_ASSESSMENT_SUCCESS';
export const EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR = 'EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR';
export const EVALUATION_STATE_ADD_SET = 'EVALUATION_STATE_ADD_SET';
export const EVALUATION_STATE_ADD_MODAL_SET = 'EVALUATION_STATE_ADD_MODAL_SET';
export const EVALUATION_STATE_ADD = 'EVALUATION_STATE_ADD';
export const EVALUATION_STATE_ADD_SUCCESS = 'EVALUATION_STATE_ADD_SUCCESS';
export const EVALUATION_STATE_ADD_ERROR = 'EVALUATION_STATE_ADD_ERROR';
export const EVALUATION_STATE_ADD_CHANGE = 'EVALUATION_STATE_ADD_CHANGE';
export const EVALUATION_STATE_DETAIL = 'EVALUATION_STATE_DETAIL';
export const EVALUATION_STATE_DETAIL_SUCCESS = 'EVALUATION_STATE_DETAIL_SUCCESS';
export const EVALUATION_STATE_DETAIL_ERROR = 'EVALUATION_STATE_DETAIL_ERROR';
export const EVALUATION_STATE_VIEW_MODAL_SET = 'EVALUATION_STATE_VIEW_MODAL_SET';
export const EVALUATION_STATE_EDIT_MODAL_SET = 'EVALUATION_STATE_EDIT_MODAL_SET';
export const EVALUATION_STATE_EDIT_SET = 'EVALUATION_STATE_EDIT_SET';
export const EVALUATION_STATE_EDIT_CHANGE = 'EVALUATION_STATE_EDIT_CHANGE';
export const EVALUATION_STATE_UPDATE = 'EVALUATION_STATE_UPDATE';
export const EVALUATION_STATE_UPDATE_SUCCESS = 'EVALUATION_STATE_UPDATE_SUCCESS';
export const EVALUATION_STATE_UPDATE_ERROR = 'EVALUATION_STATE_UPDATE_ERROR';
export const EVALUATION_STATE_VIEW_TAB_SET = 'EVALUATION_STATE_VIEW_TAB_SET';
export const EVALUATION_STATE_UPLOAD_SET = 'EVALUATION_STATE_UPLOAD_SET';
export const EVALUATION_STATE_UPLOAD_SET_SUCCESS = 'EVALUATION_STATE_UPLOAD_SET_SUCCESS';
export const EVALUATION_STATE_UPLOAD_SET_ERROR = 'EVALUATION_STATE_UPLOAD_SET_ERROR';
export const EVALUATION_STATE_UPLOAD_RESET = 'EVALUATION_STATE_UPLOAD_RESET';

/* EVALUATION_ROLE */
export const EVALUATION_ROLE_LIST = 'EVALUATION_ROLE_LIST';
export const EVALUATION_ROLE_LIST_SUCCESS = 'EVALUATION_ROLE_LIST_SUCCESS';
export const EVALUATION_ROLE_LIST_ERROR = 'EVALUATION_ROLE_LIST_ERROR';
export const EVALUATION_ROLE_PAGE_SET = 'EVALUATION_ROLE_PAGE_SET';
export const EVALUATION_ROLE_SEARCH_SET = 'EVALUATION_ROLE_SEARCH_SET';
export const EVALUATION_ROLE_SEARCH_CHANGE = 'EVALUATION_ROLE_SEARCH_CHANGE';
export const EVALUATION_ROLE_ADD_SET = 'EVALUATION_ROLE_ADD_SET';
export const EVALUATION_ROLE_ADD_MODAL_SET = 'EVALUATION_ROLE_ADD_MODAL_SET';
export const EVALUATION_ROLE_ADD = 'EVALUATION_ROLE_ADD';
export const EVALUATION_ROLE_ADD_SUCCESS = 'EVALUATION_ROLE_ADD_SUCCESS';
export const EVALUATION_ROLE_ADD_ERROR = 'EVALUATION_ROLE_ADD_ERROR';
export const EVALUATION_ROLE_ADD_CHANGE = 'EVALUATION_ROLE_ADD_CHANGE';
export const EVALUATION_ROLE_DETAIL = 'EVALUATION_ROLE_DETAIL';
export const EVALUATION_ROLE_DETAIL_SUCCESS = 'EVALUATION_ROLE_DETAIL_SUCCESS';
export const EVALUATION_ROLE_DETAIL_ERROR = 'EVALUATION_ROLE_DETAIL_ERROR';
export const EVALUATION_ROLE_VIEW_MODAL_SET = 'EVALUATION_ROLE_VIEW_MODAL_SET';
export const EVALUATION_ROLE_EDIT_MODAL_SET = 'EVALUATION_ROLE_EDIT_MODAL_SET';
export const EVALUATION_ROLE_EDIT_SET = 'EVALUATION_ROLE_EDIT_SET';
export const EVALUATION_ROLE_EDIT_CHANGE = 'EVALUATION_ROLE_EDIT_CHANGE';
export const EVALUATION_ROLE_UPDATE = 'EVALUATION_ROLE_UPDATE';
export const EVALUATION_ROLE_UPDATE_SUCCESS = 'EVALUATION_ROLE_UPDATE_SUCCESS';
export const EVALUATION_ROLE_UPDATE_ERROR = 'EVALUATION_ROLE_UPDATE_ERROR';
export const EVALUATION_ROLE_VIEW_TAB_SET = 'EVALUATION_ROLE_VIEW_TAB_SET';

/* EVALUATION_USER */
export const EVALUATION_USER_LIST = 'EVALUATION_USER_LIST';
export const EVALUATION_USER_LIST_SUCCESS = 'EVALUATION_USER_LIST_SUCCESS';
export const EVALUATION_USER_LIST_ERROR = 'EVALUATION_USER_LIST_ERROR';
export const EVALUATION_USER_PAGE_SET = 'EVALUATION_USER_PAGE_SET';
export const EVALUATION_USER_SEARCH_SET = 'EVALUATION_USER_SEARCH_SET';
export const EVALUATION_USER_SEARCH_CHANGE = 'EVALUATION_USER_SEARCH_CHANGE';
export const EVALUATION_USER_SEARCH_EVALUATION_ROLE = 'EVALUATION_USER_SEARCH_EVALUATION_ROLE';
export const EVALUATION_USER_SEARCH_EVALUATION_ROLE_SUCCESS = 'EVALUATION_USER_SEARCH_EVALUATION_ROLE_SUCCESS';
export const EVALUATION_USER_SEARCH_EVALUATION_ROLE_ERROR = 'EVALUATION_USER_SEARCH_EVALUATION_ROLE_ERROR';
export const EVALUATION_USER_SEARCH_USER = 'EVALUATION_USER_SEARCH_USER';
export const EVALUATION_USER_SEARCH_USER_SUCCESS = 'EVALUATION_USER_SEARCH_USER_SUCCESS';
export const EVALUATION_USER_SEARCH_USER_ERROR = 'EVALUATION_USER_SEARCH_USER_ERROR';
export const EVALUATION_USER_ADD_SET = 'EVALUATION_USER_ADD_SET';
export const EVALUATION_USER_ADD_MODAL_SET = 'EVALUATION_USER_ADD_MODAL_SET';
export const EVALUATION_USER_ADD = 'EVALUATION_USER_ADD';
export const EVALUATION_USER_ADD_SUCCESS = 'EVALUATION_USER_ADD_SUCCESS';
export const EVALUATION_USER_ADD_ERROR = 'EVALUATION_USER_ADD_ERROR';
export const EVALUATION_USER_ADD_CHANGE = 'EVALUATION_USER_ADD_CHANGE';
export const EVALUATION_USER_DETAIL = 'EVALUATION_USER_DETAIL';
export const EVALUATION_USER_DETAIL_SUCCESS = 'EVALUATION_USER_DETAIL_SUCCESS';
export const EVALUATION_USER_DETAIL_ERROR = 'EVALUATION_USER_DETAIL_ERROR';
export const EVALUATION_USER_VIEW_MODAL_SET = 'EVALUATION_USER_VIEW_MODAL_SET';
export const EVALUATION_USER_EDIT_MODAL_SET = 'EVALUATION_USER_EDIT_MODAL_SET';
export const EVALUATION_USER_EDIT_SET = 'EVALUATION_USER_EDIT_SET';
export const EVALUATION_USER_EDIT_CHANGE = 'EVALUATION_USER_EDIT_CHANGE';
export const EVALUATION_USER_UPDATE = 'EVALUATION_USER_UPDATE';
export const EVALUATION_USER_UPDATE_SUCCESS = 'EVALUATION_USER_UPDATE_SUCCESS';
export const EVALUATION_USER_UPDATE_ERROR = 'EVALUATION_USER_UPDATE_ERROR';
export const EVALUATION_USER_VIEW_TAB_SET = 'EVALUATION_USER_VIEW_TAB_SET';
export const EVALUATION_USER_UPLOAD_SET = 'EVALUATION_USER_UPLOAD_SET';
export const EVALUATION_USER_UPLOAD_SET_SUCCESS = 'EVALUATION_USER_UPLOAD_SET_SUCCESS';
export const EVALUATION_USER_UPLOAD_SET_ERROR = 'EVALUATION_USER_UPLOAD_SET_ERROR';
export const EVALUATION_USER_UPLOAD_RESET = 'EVALUATION_USER_UPLOAD_RESET';

/* EVALUATION_MESSAGE */
export const EVALUATION_MESSAGE_LIST = 'EVALUATION_MESSAGE_LIST';
export const EVALUATION_MESSAGE_LIST_SUCCESS = 'EVALUATION_MESSAGE_LIST_SUCCESS';
export const EVALUATION_MESSAGE_LIST_ERROR = 'EVALUATION_MESSAGE_LIST_ERROR';
export const EVALUATION_MESSAGE_PAGE_SET = 'EVALUATION_MESSAGE_PAGE_SET';
export const EVALUATION_MESSAGE_SEARCH_SET = 'EVALUATION_MESSAGE_SEARCH_SET';
export const EVALUATION_MESSAGE_SEARCH_CHANGE = 'EVALUATION_MESSAGE_SEARCH_CHANGE';
export const EVALUATION_MESSAGE_SEARCH_ASSESSMENT = 'EVALUATION_MESSAGE_SEARCH_ASSESSMENT';
export const EVALUATION_MESSAGE_SEARCH_ASSESSMENT_SUCCESS = 'EVALUATION_MESSAGE_SEARCH_ASSESSMENT_SUCCESS';
export const EVALUATION_MESSAGE_SEARCH_ASSESSMENT_ERROR = 'EVALUATION_MESSAGE_SEARCH_ASSESSMENT_ERROR';
export const EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL = 'EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL';
export const EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_SUCCESS = 'EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_SUCCESS';
export const EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_ERROR = 'EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_ERROR';
export const EVALUATION_MESSAGE_ADD_SET = 'EVALUATION_MESSAGE_ADD_SET';
export const EVALUATION_MESSAGE_ADD_MODAL_SET = 'EVALUATION_MESSAGE_ADD_MODAL_SET';
export const EVALUATION_MESSAGE_ADD = 'EVALUATION_MESSAGE_ADD';
export const EVALUATION_MESSAGE_ADD_SUCCESS = 'EVALUATION_MESSAGE_ADD_SUCCESS';
export const EVALUATION_MESSAGE_ADD_ERROR = 'EVALUATION_MESSAGE_ADD_ERROR';
export const EVALUATION_MESSAGE_ADD_CHANGE = 'EVALUATION_MESSAGE_ADD_CHANGE';
export const EVALUATION_MESSAGE_DETAIL = 'EVALUATION_MESSAGE_DETAIL';
export const EVALUATION_MESSAGE_DETAIL_SUCCESS = 'EVALUATION_MESSAGE_DETAIL_SUCCESS';
export const EVALUATION_MESSAGE_DETAIL_ERROR = 'EVALUATION_MESSAGE_DETAIL_ERROR';
export const EVALUATION_MESSAGE_VIEW_MODAL_SET = 'EVALUATION_MESSAGE_VIEW_MODAL_SET';
export const EVALUATION_MESSAGE_EDIT_MODAL_SET = 'EVALUATION_MESSAGE_EDIT_MODAL_SET';
export const EVALUATION_MESSAGE_EDIT_SET = 'EVALUATION_MESSAGE_EDIT_SET';
export const EVALUATION_MESSAGE_EDIT_CHANGE = 'EVALUATION_MESSAGE_EDIT_CHANGE';
export const EVALUATION_MESSAGE_UPDATE = 'EVALUATION_MESSAGE_UPDATE';
export const EVALUATION_MESSAGE_UPDATE_SUCCESS = 'EVALUATION_MESSAGE_UPDATE_SUCCESS';
export const EVALUATION_MESSAGE_UPDATE_ERROR = 'EVALUATION_MESSAGE_UPDATE_ERROR';
export const EVALUATION_MESSAGE_VIEW_TAB_SET = 'EVALUATION_MESSAGE_VIEW_TAB_SET';
export const EVALUATION_MESSAGE_UPLOAD_SET = 'EVALUATION_MESSAGE_UPLOAD_SET';
export const EVALUATION_MESSAGE_UPLOAD_SET_SUCCESS = 'EVALUATION_MESSAGE_UPLOAD_SET_SUCCESS';
export const EVALUATION_MESSAGE_UPLOAD_SET_ERROR = 'EVALUATION_MESSAGE_UPLOAD_SET_ERROR';
export const EVALUATION_MESSAGE_UPLOAD_RESET = 'EVALUATION_MESSAGE_UPLOAD_RESET';


/* SUPERVISION_REPORT */
export const SUPERVISION_REPORT_LIST = 'SUPERVISION_REPORT_LIST';
export const SUPERVISION_REPORT_LIST_SUCCESS = 'SUPERVISION_REPORT_LIST_SUCCESS';
export const SUPERVISION_REPORT_LIST_ERROR = 'SUPERVISION_REPORT_LIST_ERROR';
export const SUPERVISION_REPORT_PAGE_SET = 'SUPERVISION_REPORT_PAGE_SET';
export const SUPERVISION_REPORT_SEARCH_SET = 'SUPERVISION_REPORT_SEARCH_SET';
export const SUPERVISION_REPORT_SEARCH_CHANGE = 'SUPERVISION_REPORT_SEARCH_CHANGE';
export const SUPERVISION_REPORT_ADD_SET = 'SUPERVISION_REPORT_ADD_SET';
export const SUPERVISION_REPORT_ADD_MODAL_SET = 'SUPERVISION_REPORT_ADD_MODAL_SET';
export const SUPERVISION_REPORT_ADD = 'SUPERVISION_REPORT_ADD';
export const SUPERVISION_REPORT_ADD_SUCCESS = 'SUPERVISION_REPORT_ADD_SUCCESS';
export const SUPERVISION_REPORT_ADD_ERROR = 'SUPERVISION_REPORT_ADD_ERROR';
export const SUPERVISION_REPORT_ADD_CHANGE = 'SUPERVISION_REPORT_ADD_CHANGE';
export const SUPERVISION_REPORT_DETAIL = 'SUPERVISION_REPORT_DETAIL';
export const SUPERVISION_REPORT_DETAIL_SUCCESS = 'SUPERVISION_REPORT_DETAIL_SUCCESS';
export const SUPERVISION_REPORT_DETAIL_ERROR = 'SUPERVISION_REPORT_DETAIL_ERROR';
export const SUPERVISION_REPORT_VIEW_MODAL_SET = 'SUPERVISION_REPORT_VIEW_MODAL_SET';
export const SUPERVISION_REPORT_EDIT_MODAL_SET = 'SUPERVISION_REPORT_EDIT_MODAL_SET';
export const SUPERVISION_REPORT_EDIT_SET = 'SUPERVISION_REPORT_EDIT_SET';
export const SUPERVISION_REPORT_EDIT_CHANGE = 'SUPERVISION_REPORT_EDIT_CHANGE';
export const SUPERVISION_REPORT_UPDATE = 'SUPERVISION_REPORT_UPDATE';
export const SUPERVISION_REPORT_UPDATE_SUCCESS = 'SUPERVISION_REPORT_UPDATE_SUCCESS';
export const SUPERVISION_REPORT_UPDATE_ERROR = 'SUPERVISION_REPORT_UPDATE_ERROR';
export const SUPERVISION_REPORT_VIEW_TAB_SET = 'SUPERVISION_REPORT_VIEW_TAB_SET';

/* TECHNICAL_DOCUMENT_TYPE */
export const TECHNICAL_DOCUMENT_TYPE_LIST = 'TECHNICAL_DOCUMENT_TYPE_LIST';
export const TECHNICAL_DOCUMENT_TYPE_LIST_SUCCESS = 'TECHNICAL_DOCUMENT_TYPE_LIST_SUCCESS';
export const TECHNICAL_DOCUMENT_TYPE_LIST_ERROR = 'TECHNICAL_DOCUMENT_TYPE_LIST_ERROR';
export const TECHNICAL_DOCUMENT_TYPE_PAGE_SET = 'TECHNICAL_DOCUMENT_TYPE_PAGE_SET';
export const TECHNICAL_DOCUMENT_TYPE_SEARCH_SET = 'TECHNICAL_DOCUMENT_TYPE_SEARCH_SET';
export const TECHNICAL_DOCUMENT_TYPE_SEARCH_CHANGE = 'TECHNICAL_DOCUMENT_TYPE_SEARCH_CHANGE';
export const TECHNICAL_DOCUMENT_TYPE_ADD_SET = 'TECHNICAL_DOCUMENT_TYPE_ADD_SET';
export const TECHNICAL_DOCUMENT_TYPE_ADD_MODAL_SET = 'TECHNICAL_DOCUMENT_TYPE_ADD_MODAL_SET';
export const TECHNICAL_DOCUMENT_TYPE_ADD = 'TECHNICAL_DOCUMENT_TYPE_ADD';
export const TECHNICAL_DOCUMENT_TYPE_ADD_SUCCESS = 'TECHNICAL_DOCUMENT_TYPE_ADD_SUCCESS';
export const TECHNICAL_DOCUMENT_TYPE_ADD_ERROR = 'TECHNICAL_DOCUMENT_TYPE_ADD_ERROR';
export const TECHNICAL_DOCUMENT_TYPE_ADD_CHANGE = 'TECHNICAL_DOCUMENT_TYPE_ADD_CHANGE';
export const TECHNICAL_DOCUMENT_TYPE_DETAIL = 'TECHNICAL_DOCUMENT_TYPE_DETAIL';
export const TECHNICAL_DOCUMENT_TYPE_DETAIL_SUCCESS = 'TECHNICAL_DOCUMENT_TYPE_DETAIL_SUCCESS';
export const TECHNICAL_DOCUMENT_TYPE_DETAIL_ERROR = 'TECHNICAL_DOCUMENT_TYPE_DETAIL_ERROR';
export const TECHNICAL_DOCUMENT_TYPE_VIEW_MODAL_SET = 'TECHNICAL_DOCUMENT_TYPE_VIEW_MODAL_SET';
export const TECHNICAL_DOCUMENT_TYPE_EDIT_MODAL_SET = 'TECHNICAL_DOCUMENT_TYPE_EDIT_MODAL_SET';
export const TECHNICAL_DOCUMENT_TYPE_EDIT_SET = 'TECHNICAL_DOCUMENT_TYPE_EDIT_SET';
export const TECHNICAL_DOCUMENT_TYPE_EDIT_CHANGE = 'TECHNICAL_DOCUMENT_TYPE_EDIT_CHANGE';
export const TECHNICAL_DOCUMENT_TYPE_UPDATE = 'TECHNICAL_DOCUMENT_TYPE_UPDATE';
export const TECHNICAL_DOCUMENT_TYPE_UPDATE_SUCCESS = 'TECHNICAL_DOCUMENT_TYPE_UPDATE_SUCCESS';
export const TECHNICAL_DOCUMENT_TYPE_UPDATE_ERROR = 'TECHNICAL_DOCUMENT_TYPE_UPDATE_ERROR';
export const TECHNICAL_DOCUMENT_TYPE_VIEW_TAB_SET = 'TECHNICAL_DOCUMENT_TYPE_VIEW_TAB_SET';

/* TECHNICAL_DOCUMENT */
export const TECHNICAL_DOCUMENT_LIST = 'TECHNICAL_DOCUMENT_LIST';
export const TECHNICAL_DOCUMENT_LIST_SUCCESS = 'TECHNICAL_DOCUMENT_LIST_SUCCESS';
export const TECHNICAL_DOCUMENT_LIST_ERROR = 'TECHNICAL_DOCUMENT_LIST_ERROR';
export const TECHNICAL_DOCUMENT_PAGE_SET = 'TECHNICAL_DOCUMENT_PAGE_SET';
export const TECHNICAL_DOCUMENT_SEARCH_SET = 'TECHNICAL_DOCUMENT_SEARCH_SET';
export const TECHNICAL_DOCUMENT_SEARCH_CHANGE = 'TECHNICAL_DOCUMENT_SEARCH_CHANGE';
export const TECHNICAL_DOCUMENT_SEARCH_EVALUATION = 'TECHNICAL_DOCUMENT_SEARCH_EVALUATION';
export const TECHNICAL_DOCUMENT_SEARCH_EVALUATION_SUCCESS = 'TECHNICAL_DOCUMENT_SEARCH_EVALUATION_SUCCESS';
export const TECHNICAL_DOCUMENT_SEARCH_EVALUATION_ERROR = 'TECHNICAL_DOCUMENT_SEARCH_EVALUATION_ERROR';
export const TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE = 'TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE';
export const TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE_SUCCESS = 'TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE_SUCCESS';
export const TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE_ERROR = 'TECHNICAL_DOCUMENT_SEARCH_TECHNICAL_DOCUMENT_TYPE_ERROR';
export const TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT = 'TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT';
export const TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT_SUCCESS = 'TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT_SUCCESS';
export const TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT_ERROR = 'TECHNICAL_DOCUMENT_SEARCH_SUPERVISION_REPORT_ERROR';
export const TECHNICAL_DOCUMENT_ADD_SET = 'TECHNICAL_DOCUMENT_ADD_SET';
export const TECHNICAL_DOCUMENT_ADD_MODAL_SET = 'TECHNICAL_DOCUMENT_ADD_MODAL_SET';
export const TECHNICAL_DOCUMENT_ADD = 'TECHNICAL_DOCUMENT_ADD';
export const TECHNICAL_DOCUMENT_ADD_SUCCESS = 'TECHNICAL_DOCUMENT_ADD_SUCCESS';
export const TECHNICAL_DOCUMENT_ADD_ERROR = 'TECHNICAL_DOCUMENT_ADD_ERROR';
export const TECHNICAL_DOCUMENT_ADD_CHANGE = 'TECHNICAL_DOCUMENT_ADD_CHANGE';
export const TECHNICAL_DOCUMENT_DETAIL = 'TECHNICAL_DOCUMENT_DETAIL';
export const TECHNICAL_DOCUMENT_DETAIL_SUCCESS = 'TECHNICAL_DOCUMENT_DETAIL_SUCCESS';
export const TECHNICAL_DOCUMENT_DETAIL_ERROR = 'TECHNICAL_DOCUMENT_DETAIL_ERROR';
export const TECHNICAL_DOCUMENT_VIEW_MODAL_SET = 'TECHNICAL_DOCUMENT_VIEW_MODAL_SET';
export const TECHNICAL_DOCUMENT_EDIT_MODAL_SET = 'TECHNICAL_DOCUMENT_EDIT_MODAL_SET';
export const TECHNICAL_DOCUMENT_EDIT_SET = 'TECHNICAL_DOCUMENT_EDIT_SET';
export const TECHNICAL_DOCUMENT_EDIT_CHANGE = 'TECHNICAL_DOCUMENT_EDIT_CHANGE';
export const TECHNICAL_DOCUMENT_UPDATE = 'TECHNICAL_DOCUMENT_UPDATE';
export const TECHNICAL_DOCUMENT_UPDATE_SUCCESS = 'TECHNICAL_DOCUMENT_UPDATE_SUCCESS';
export const TECHNICAL_DOCUMENT_UPDATE_ERROR = 'TECHNICAL_DOCUMENT_UPDATE_ERROR';
export const TECHNICAL_DOCUMENT_VIEW_TAB_SET = 'TECHNICAL_DOCUMENT_VIEW_TAB_SET';
export const TECHNICAL_DOCUMENT_UPLOAD_SET = 'TECHNICAL_DOCUMENT_UPLOAD_SET';
export const TECHNICAL_DOCUMENT_UPLOAD_SET_SUCCESS = 'TECHNICAL_DOCUMENT_UPLOAD_SET_SUCCESS';
export const TECHNICAL_DOCUMENT_UPLOAD_SET_ERROR = 'TECHNICAL_DOCUMENT_UPLOAD_SET_ERROR';
export const TECHNICAL_DOCUMENT_UPLOAD_RESET = 'TECHNICAL_DOCUMENT_UPLOAD_RESET';

export const EVALUATION_SEARCH_SUPERVISION_REPORT = 'EVALUATION_SEARCH_SUPERVISION_REPORT';
export const EVALUATION_SEARCH_SUPERVISION_REPORT_SUCCESS = 'EVALUATION_SEARCH_SUPERVISION_REPORT_SUCCESS';
export const EVALUATION_SEARCH_SUPERVISION_REPORT_ERROR = 'EVALUATION_SEARCH_SUPERVISION_REPORT_ERROR';


/* EQUIPMENT_STOCK */
export const EQUIPMENT_STOCK_LIST = 'EQUIPMENT_STOCK_LIST';
export const EQUIPMENT_STOCK_LIST_SUCCESS = 'EQUIPMENT_STOCK_LIST_SUCCESS';
export const EQUIPMENT_STOCK_LIST_ERROR = 'EQUIPMENT_STOCK_LIST_ERROR';
export const EQUIPMENT_STOCK_PAGE_SET = 'EQUIPMENT_STOCK_PAGE_SET';
export const EQUIPMENT_STOCK_SEARCH_SET = 'EQUIPMENT_STOCK_SEARCH_SET';
export const EQUIPMENT_STOCK_SEARCH_CHANGE = 'EQUIPMENT_STOCK_SEARCH_CHANGE';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT_SUCCESS';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT_ERROR';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_SUCCESS';
export const EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR = 'EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT_ERROR';
export const EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT = 'EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT';
export const EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS = 'EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_SUCCESS';
export const EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR = 'EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT_ERROR';
export const EQUIPMENT_STOCK_ADD_SET = 'EQUIPMENT_STOCK_ADD_SET';
export const EQUIPMENT_STOCK_ADD_MODAL_SET = 'EQUIPMENT_STOCK_ADD_MODAL_SET';
export const EQUIPMENT_STOCK_ADD = 'EQUIPMENT_STOCK_ADD';
export const EQUIPMENT_STOCK_ADD_SUCCESS = 'EQUIPMENT_STOCK_ADD_SUCCESS';
export const EQUIPMENT_STOCK_ADD_ERROR = 'EQUIPMENT_STOCK_ADD_ERROR';
export const EQUIPMENT_STOCK_ADD_CHANGE = 'EQUIPMENT_STOCK_ADD_CHANGE';
export const EQUIPMENT_STOCK_GET = 'EQUIPMENT_STOCK_GET';
export const EQUIPMENT_STOCK_GET_SUCCESS = 'EQUIPMENT_STOCK_GET_SUCCESS';
export const EQUIPMENT_STOCK_GET_ERROR = 'EQUIPMENT_STOCK_GET_ERROR';
export const EQUIPMENT_STOCK_DETAIL = 'EQUIPMENT_STOCK_DETAIL';
export const EQUIPMENT_STOCK_DETAIL_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ERROR = 'EQUIPMENT_STOCK_DETAIL_ERROR';
export const EQUIPMENT_STOCK_VIEW_MODAL_SET = 'EQUIPMENT_STOCK_VIEW_MODAL_SET';
export const EQUIPMENT_STOCK_EDIT_MODAL_SET = 'EQUIPMENT_STOCK_EDIT_MODAL_SET';
export const EQUIPMENT_STOCK_EDIT_SET = 'EQUIPMENT_STOCK_EDIT_SET';
export const EQUIPMENT_STOCK_EDIT_CHANGE = 'EQUIPMENT_STOCK_EDIT_CHANGE';
export const EQUIPMENT_STOCK_UPDATE = 'EQUIPMENT_STOCK_UPDATE';
export const EQUIPMENT_STOCK_UPDATE_SUCCESS = 'EQUIPMENT_STOCK_UPDATE_SUCCESS';
export const EQUIPMENT_STOCK_UPDATE_ERROR = 'EQUIPMENT_STOCK_UPDATE_ERROR';
export const EQUIPMENT_STOCK_VIEW_TAB_SET = 'EQUIPMENT_STOCK_VIEW_TAB_SET';
export const EQUIPMENT_STOCK_UPLOAD_SET = 'EQUIPMENT_STOCK_UPLOAD_SET';
export const EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS = 'EQUIPMENT_STOCK_UPLOAD_SET_SUCCESS';
export const EQUIPMENT_STOCK_UPLOAD_SET_ERROR = 'EQUIPMENT_STOCK_UPLOAD_SET_ERROR';
export const EQUIPMENT_STOCK_UPLOAD_RESET = 'EQUIPMENT_STOCK_UPLOAD_RESET';

/* EQUIPMENT_STOCK_DETAIL */
export const EQUIPMENT_STOCK_DETAIL_LIST = 'EQUIPMENT_STOCK_DETAIL_LIST';
export const EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_LIST_ERROR = 'EQUIPMENT_STOCK_DETAIL_LIST_ERROR';
export const EQUIPMENT_STOCK_DETAIL_PAGE_SET = 'EQUIPMENT_STOCK_DETAIL_PAGE_SET';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_SET = 'EQUIPMENT_STOCK_DETAIL_SEARCH_SET';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE = 'EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_OPERATION_STATUS_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION = 'EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_FILE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE = 'EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_ACQUISITION_MODE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION = 'EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_INSTALLATION_CONDITION_ERROR';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE = 'EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE_ERROR = 'EQUIPMENT_STOCK_DETAIL_SEARCH_SERVICE_TYPE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ADD_SET = 'EQUIPMENT_STOCK_DETAIL_ADD_SET';
export const EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_ADD = 'EQUIPMENT_STOCK_DETAIL_ADD';
export const EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ADD_ERROR = 'EQUIPMENT_STOCK_DETAIL_ADD_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ADD_CHANGE = 'EQUIPMENT_STOCK_DETAIL_ADD_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_DETAIL = 'EQUIPMENT_STOCK_DETAIL_DETAIL';
export const EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR = 'EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR';
export const EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_EDIT_SET = 'EQUIPMENT_STOCK_DETAIL_EDIT_SET';
export const EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE = 'EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_UPDATE = 'EQUIPMENT_STOCK_DETAIL_UPDATE';
export const EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR = 'EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET = 'EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET';

/* EQUIPMENT_STOCK_DETAIL_ITEM */
export const EQUIPMENT_STOCK_DETAIL_ITEM_LIST = 'EQUIPMENT_STOCK_DETAIL_ITEM_LIST';
export const EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE = 'EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL = 'EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL';
export const EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_SET';
export const EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE = 'EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE = 'EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE';
export const EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS = 'EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS';
export const EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR = 'EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR';
export const EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET = 'EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET';


/* ASSESSMENT_CATEGORY */
export const ASSESSMENT_CATEGORY_LIST = 'ASSESSMENT_CATEGORY_LIST';
export const ASSESSMENT_CATEGORY_LIST_SUCCESS = 'ASSESSMENT_CATEGORY_LIST_SUCCESS';
export const ASSESSMENT_CATEGORY_LIST_ERROR = 'ASSESSMENT_CATEGORY_LIST_ERROR';
export const ASSESSMENT_CATEGORY_PAGE_SET = 'ASSESSMENT_CATEGORY_PAGE_SET';
export const ASSESSMENT_CATEGORY_SEARCH_SET = 'ASSESSMENT_CATEGORY_SEARCH_SET';
export const ASSESSMENT_CATEGORY_SEARCH_CHANGE = 'ASSESSMENT_CATEGORY_SEARCH_CHANGE';
export const ASSESSMENT_CATEGORY_ADD_SET = 'ASSESSMENT_CATEGORY_ADD_SET';
export const ASSESSMENT_CATEGORY_ADD_MODAL_SET = 'ASSESSMENT_CATEGORY_ADD_MODAL_SET';
export const ASSESSMENT_CATEGORY_ADD = 'ASSESSMENT_CATEGORY_ADD';
export const ASSESSMENT_CATEGORY_ADD_SUCCESS = 'ASSESSMENT_CATEGORY_ADD_SUCCESS';
export const ASSESSMENT_CATEGORY_ADD_ERROR = 'ASSESSMENT_CATEGORY_ADD_ERROR';
export const ASSESSMENT_CATEGORY_ADD_CHANGE = 'ASSESSMENT_CATEGORY_ADD_CHANGE';
export const ASSESSMENT_CATEGORY_DETAIL = 'ASSESSMENT_CATEGORY_DETAIL';
export const ASSESSMENT_CATEGORY_DETAIL_SUCCESS = 'ASSESSMENT_CATEGORY_DETAIL_SUCCESS';
export const ASSESSMENT_CATEGORY_DETAIL_ERROR = 'ASSESSMENT_CATEGORY_DETAIL_ERROR';
export const ASSESSMENT_CATEGORY_VIEW_MODAL_SET = 'ASSESSMENT_CATEGORY_VIEW_MODAL_SET';
export const ASSESSMENT_CATEGORY_EDIT_MODAL_SET = 'ASSESSMENT_CATEGORY_EDIT_MODAL_SET';
export const ASSESSMENT_CATEGORY_EDIT_SET = 'ASSESSMENT_CATEGORY_EDIT_SET';
export const ASSESSMENT_CATEGORY_EDIT_CHANGE = 'ASSESSMENT_CATEGORY_EDIT_CHANGE';
export const ASSESSMENT_CATEGORY_UPDATE = 'ASSESSMENT_CATEGORY_UPDATE';
export const ASSESSMENT_CATEGORY_UPDATE_SUCCESS = 'ASSESSMENT_CATEGORY_UPDATE_SUCCESS';
export const ASSESSMENT_CATEGORY_UPDATE_ERROR = 'ASSESSMENT_CATEGORY_UPDATE_ERROR';
export const ASSESSMENT_CATEGORY_VIEW_TAB_SET = 'ASSESSMENT_CATEGORY_VIEW_TAB_SET';

/* EQUIPMENT */
export const EQUIPMENT_LIST = 'EQUIPMENT_LIST';
export const EQUIPMENT_LIST_SUCCESS = 'EQUIPMENT_LIST_SUCCESS';
export const EQUIPMENT_LIST_ERROR = 'EQUIPMENT_LIST_ERROR';
export const EQUIPMENT_PAGE_SET = 'EQUIPMENT_PAGE_SET';
export const EQUIPMENT_SEARCH_SET = 'EQUIPMENT_SEARCH_SET';
export const EQUIPMENT_SEARCH_CHANGE = 'EQUIPMENT_SEARCH_CHANGE';
export const EQUIPMENT_ADD_SET = 'EQUIPMENT_ADD_SET';
export const EQUIPMENT_ADD_MODAL_SET = 'EQUIPMENT_ADD_MODAL_SET';
export const EQUIPMENT_ADD = 'EQUIPMENT_ADD';
export const EQUIPMENT_ADD_SUCCESS = 'EQUIPMENT_ADD_SUCCESS';
export const EQUIPMENT_ADD_ERROR = 'EQUIPMENT_ADD_ERROR';
export const EQUIPMENT_ADD_CHANGE = 'EQUIPMENT_ADD_CHANGE';
export const EQUIPMENT_DETAIL = 'EQUIPMENT_DETAIL';
export const EQUIPMENT_DETAIL_SUCCESS = 'EQUIPMENT_DETAIL_SUCCESS';
export const EQUIPMENT_DETAIL_ERROR = 'EQUIPMENT_DETAIL_ERROR';
export const EQUIPMENT_VIEW_MODAL_SET = 'EQUIPMENT_VIEW_MODAL_SET';
export const EQUIPMENT_EDIT_MODAL_SET = 'EQUIPMENT_EDIT_MODAL_SET';
export const EQUIPMENT_EDIT_SET = 'EQUIPMENT_EDIT_SET';
export const EQUIPMENT_EDIT_CHANGE = 'EQUIPMENT_EDIT_CHANGE';
export const EQUIPMENT_UPDATE = 'EQUIPMENT_UPDATE';
export const EQUIPMENT_UPDATE_SUCCESS = 'EQUIPMENT_UPDATE_SUCCESS';
export const EQUIPMENT_UPDATE_ERROR = 'EQUIPMENT_UPDATE_ERROR';
export const EQUIPMENT_VIEW_TAB_SET = 'EQUIPMENT_VIEW_TAB_SET';

/*****************INDEX_RPT EQUIPMENT*************************************************************/
export const IDX_RPT_EQUIPMENT_REPORT = 'IDX_RPT_EQUIPMENT_REPORT';
export const IDX_RPT_EQUIPMENT_REPORT_SUCCESS = 'IDX_RPT_EQUIPMENT_REPORT_SUCCESS';
export const IDX_RPT_EQUIPMENT_REPORT_ERROR = 'IDX_RPT_EQUIPMENT_REPORT_ERROR';
export const IDX_RPT_EQUIPMENT_HOSPITAL_LIST = 'IDX_RPT_EQUIPMENT_HOSPITAL_LIST';
export const IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS = 'IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS';
export const IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR = 'IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR';
export const IDX_RPT_EQUIPMENT_DETAIL_EQP = 'IDX_RPT_EQUIPMENT_DETAIL_EQP';
export const IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR';
export const IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE = 'IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION = 'IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR';
export const IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS = 'IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS';
export const IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR';
export const IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY = 'IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY';
export const IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR';
export const IDX_RPT_EQUIPMENT_DETAIL_OTHERS = 'IDX_RPT_EQUIPMENT_DETAIL_OTHERS';
export const IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION = 'IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS = 'IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS';
export const IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR = 'IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR';
export const IDX_RPT_EQUIPMENT_EVALUATION_FORM = 'IDX_RPT_EQUIPMENT_EVALUATION_FORM';
export const IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS = 'IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS';
export const IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR = 'IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR';
export const IDX_RPT_REQ_EQP_HOSPITAL_SERVICE = 'IDX_RPT_REQ_EQP_HOSPITAL_SERVICE';
export const IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS = 'IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS';
export const IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR = 'IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR';
export const IDX_RPT_EQUIPMENT_SERVICE_LIST = 'IDX_RPT_EQUIPMENT_SERVICE_LIST';
export const IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS = 'IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS';
export const IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR = 'IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR';
export const IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE = 'IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE';
export const IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS = 'IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS';
export const IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR = 'IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR';
export const IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE = 'IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE';
export const IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS = 'IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS';
export const IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR = 'IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR';

/*****************OTHER_REASSIGNATION EQUIPMENT*************************************************************/
export const OTHER_EQUIPMENT_HOSPITAL_LIST = 'OTHER_EQUIPMENT_HOSPITAL_LIST';
export const OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS = 'OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS';
export const OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR = 'OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR';
export const OTHER_EQUIPMENT_LIST = 'OTHER_EQUIPMENT_LIST';
export const OTHER_EQUIPMENT_LIST_SUCCESS = 'OTHER_EQUIPMENT_LIST_SUCCESS';
export const OTHER_EQUIPMENT_LIST_ERROR = 'OTHER_EQUIPMENT_LIST_ERROR';
export const OTHER_EQUIPMENT_LIST_SEARCH_CHANGE = 'OTHER_EQUIPMENT_LIST_SEARCH_CHANGE';
export const OTHER_EQUIPMENT_EDIT_MODAL_SET = 'OTHER_EQUIPMENT_EDIT_MODAL_SET';
export const OTHER_EQUIPMENT_EDIT_CHANGE_SET = 'OTHER_EQUIPMENT_EDIT_CHANGE_SET';
export const OTHER_EQUIPMENT_EDIT = 'OTHER_EQUIPMENT_EDIT';
export const OTHER_EQUIPMENT_EDIT_SUCCESS = 'OTHER_EQUIPMENT_EDIT_SUCCESS';
export const OTHER_EQUIPMENT_EDIT_ERROR = 'OTHER_EQUIPMENT_EDIT_ERROR';
export const OTHER_EQUIPMENT_EQP = 'OTHER_EQUIPMENT_EQP';
export const OTHER_EQUIPMENT_EQP_SUCCESS = 'OTHER_EQUIPMENT_EQP_SUCCESS';
export const OTHER_EQUIPMENT_EQP_ERROR = 'OTHER_EQUIPMENT_EQP_ERROR';

/*****************SCHEDULE MTO*************************************************************/
export const SCHEDULE_MTO_EVENT_LIST = 'SCHEDULE_MTO_EVENT_LIST';
export const SCHEDULE_MTO_EVENT_LIST_SUCCESS = 'SCHEDULE_MTO_EVENT_LIST_SUCCESS';
export const SCHEDULE_MTO_EVENT_LIST_ERROR = 'SCHEDULE_MTO_EVENT_LIST_ERROR';
export const SCHEDULE_MTO_DETAIL_EVENT_LIST = 'SCHEDULE_MTO_DETAIL_EVENT_LIST';
export const SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS = 'SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS';
export const SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR = 'SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR';
export const SCHEDULE_MTO_REMINDER = 'SCHEDULE_MTO_REMINDER';
export const SCHEDULE_MTO_REMINDER_SUCCESS = 'SCHEDULE_MTO_REMINDER_SUCCESS';
export const SCHEDULE_MTO_REMINDER_ERROR = 'SCHEDULE_MTO_REMINDER_ERROR';

/*****************REQUEST EQUIPMENT*************************************************************/
export const REQUEST_PRODUCT = 'REQUEST_PRODUCT';
export const REQUEST_PRODUCT_SUCCESS = 'REQUEST_PRODUCT_SUCCESS';
export const REQUEST_PRODUCT_ERROR = 'REQUEST_PRODUCT_ERROR';
export const REQUEST_SUPPLIER = 'REQUEST_SUPPLIER';
export const REQUEST_SUPPLIER_SUCCESS = 'REQUEST_SUPPLIER_SUCCESS';
export const REQUEST_SUPPLIER_ERROR = 'REQUEST_SUPPLIER_ERROR';
export const REQUEST_DELIVERY_ORDER = 'REQUEST_DELIVERY_ORDER';
export const REQUEST_DELIVERY_ORDER_SUCCESS = 'REQUEST_DELIVERY_ORDER_SUCCESS';
export const REQUEST_DELIVERY_ORDER_ERROR = 'REQUEST_DELIVERY_ORDER_ERROR';
export const REQUEST_UNIT_HEALTH = 'REQUEST_UNIT_HEALTH';
export const REQUEST_UNIT_HEALTH_SUCCESS = 'REQUEST_UNIT_HEALTH_SUCCESS';
export const REQUEST_UNIT_HEALTH_ERROR = 'REQUEST_UNIT_HEALTH_ERROR';
export const REQUEST_TICKET = 'REQUEST_TICKET';
export const REQUEST_TICKET_SUCCESS = 'REQUEST_TICKET_SUCCESS';
export const REQUEST_TICKET_ERROR = 'REQUEST_TICKET_ERROR';
export const REQUEST_SERIAL = 'REQUEST_SERIAL';
export const REQUEST_SERIAL_SUCCESS = 'REQUEST_SERIAL_SUCCESS';
export const REQUEST_SERIAL_ERROR = 'REQUEST_SERIAL_ERROR';
export const REQUEST_REQ_TYPE = 'REQUEST_REQ_TYPE';
export const REQUEST_REQ_TYPE_SUCCESS = 'REQUEST_REQ_TYPE_SUCCESS';
export const REQUEST_REQ_TYPE_ERROR = 'REQUEST_REQ_TYPE_ERROR';
export const REQUEST_PRIORITY = 'REQUEST_PRIORITY';
export const REQUEST_PRIORITY_SUCCESS = 'REQUEST_PRIORITY_SUCCESS';
export const REQUEST_PRIORITY_ERROR = 'REQUEST_PRIORITY_ERROR';
export const REQUEST_DOCUMENT_TYPE = 'REQUEST_DOCUMENT_TYPE';
export const REQUEST_DOCUMENT_TYPE_SUCCESS = 'REQUEST_DOCUMENT_TYPE_SUCCESS';
export const REQUEST_DOCUMENT_TYPE_ERROR = 'REQUEST_DOCUMENT_TYPE_ERROR';
export const REQUEST_STATUS = 'REQUEST_STATUS';
export const REQUEST_STATUS_SUCCESS = 'REQUEST_STATUS_SUCCESS';
export const REQUEST_STATUS_ERROR = 'REQUEST_STATUS_ERROR';
export const REQUEST_LIST = 'REQUEST_LIST';
export const REQUEST_LIST_SUCCESS = 'REQUEST_LIST_SUCCESS';
export const REQUEST_LIST_ERROR = 'REQUEST_LIST_ERROR';
export const REQUEST_LIST_SEARCH_CHANGE = 'REQUEST_LIST_SEARCH_CHANGE';
export const REQUEST_LIST_PAGE_SET = 'REQUEST_LIST_PAGE_SET';
export const REQUEST_DETAIL = 'REQUEST_DETAIL';
export const REQUEST_DETAIL_SUCCESS = 'REQUEST_DETAIL_SUCCESS';
export const REQUEST_DETAIL_ERROR = 'REQUEST_DETAIL_ERROR';
export const REQUEST_DATA_SET = 'REQUEST_DATA_SET';
export const REQUEST_MODAL_SET = 'REQUEST_MODAL_SET';
export const REQUEST_EDIT_MODAL_SET = 'REQUEST_EDIT_MODAL_SET';
export const REQUEST_EDIT_CHANGE_SET = 'REQUEST_EDIT_CHANGE_SET';
export const REQUEST_EDIT = 'REQUEST_EDIT';
export const REQUEST_EDIT_SUCCESS = 'REQUEST_EDIT_SUCCESS';
export const REQUEST_EDIT_ERROR = 'REQUEST_EDIT_ERROR';
export const REQUEST_UPLOAD_SET = 'REQUEST_UPLOAD_SET';
export const REQUEST_UPLOAD_SET_SUCCESS = 'REQUEST_UPLOAD_SET_SUCCESS';
export const REQUEST_UPLOAD_SET_ERROR = 'REQUEST_UPLOAD_SET_ERROR';
export const REQUEST_UPLOAD_RESET = 'REQUEST_UPLOAD_RESET';





/********************ACTIVITIES (TASK) *******************************************************/
export const ACT_LIST = 'ACT_LIST';
export const ACT_LIST_SUCCESS = 'ACT_LIST_SUCCESS';
export const ACT_LIST_ERROR = 'ACT_LIST_ERROR';
export const ACT_LIST_SEARCH_CHANGE = 'ACT_LIST_SEARCH_CHANGE';
export const ACT_LIST_PAGE_SET = 'ACT_LIST_PAGE_SET';
export const ACT_ADD_MODAL_SET = 'ACT_ADD_MODAL_SET';
export const ACT_ADD_CHANGE_SET = 'ACT_ADD_CHANGE_SET';
export const ACT_ADD = 'ACT_ADD';
export const ACT_ADD_SUCCESS = 'ACT_ADD_SUCCESS';
export const ACT_ADD_ERROR = 'ACT_ADD_ERROR';
export const ACT_CALENDAR = 'ACT_CALENDAR';
export const ACT_CALENDAR_SUCCESS = 'ACT_CALENDAR_SUCCESS';
export const ACT_CALENDAR_ERROR = 'ACT_CALENDAR_ERROR';
export const ACT_DESTINATIONS = 'ACT_DESTINATIONS';
export const ACT_DESTINATIONS_SUCCESS = 'ACT_DESTINATIONS_SUCCESS';
export const ACT_DESTINATIONS_ERROR = 'ACT_DESTINATIONS_ERROR';
export const ACT_SUPPLIERS = 'ACT_SUPPLIERS';
export const ACT_SUPPLIERS_SUCCESS = 'ACT_SUPPLIERS_SUCCESS';
export const ACT_SUPPLIERS_ERROR = 'ACT_SUPPLIERS_ERROR';
export const ACT_TASK_TYPES = 'ACT_TASK_TYPES';
export const ACT_TASK_TYPES_SUCCESS = 'ACT_TASK_TYPES_SUCCESS';
export const ACT_TASK_TYPES_ERROR = 'ACT_TASK_TYPES_ERROR';
export const ACT_ENGINEERS = 'ACT_ENGINEERS';
export const ACT_ENGINEERS_SUCCESS = 'ACT_ENGINEERS_SUCCESS';
export const ACT_ENGINEERS_ERROR = 'ACT_ENGINEERS_ERROR';
export const ACT_GET = 'ACT_GET';
export const ACT_GET_SUCCESS = 'ACT_GET_SUCCESS';
export const ACT_GET_ERROR = 'ACT_GET_ERROR';
export const ACT_EDIT_MODAL_SET = 'ACT_EDIT_MODAL_SET';
export const ACT_EDIT_CHANGE_SET = 'ACT_EDIT_CHANGE_SET';
export const ACT_EDIT = 'ACT_EDIT';
export const ACT_EDIT_SUCCESS = 'ACT_EDIT_SUCCESS';
export const ACT_EDIT_ERROR = 'ACT_EDIT_ERROR';
export const ACT_VIEW_MODAL_SET = 'ACT_VIEW_MODAL_SET';
export const ACT_DETAIL = 'ACT_DETAIL';
export const ACT_DETAIL_SUCCESS = 'ACT_DETAIL_SUCCESS';
export const ACT_DETAIL_ERROR = 'ACT_DETAIL_ERROR';

export const ACT_TYPE_LIST = 'ACT_TYPE_LIST';
export const ACT_TYPE_LIST_SUCCESS = 'ACT_TYPE_LIST_SUCCESS';
export const ACT_TYPE_LIST_ERROR = 'ACT_TYPE_LIST_ERROR';
export const ACT_TYPE_LIST_SEARCH_CHANGE = 'ACT_TYPE_LIST_SEARCH_CHANGE';
export const ACT_TYPE_LIST_PAGE_SET = 'ACT_TYPE_LIST_PAGE_SET';
export const ACT_TYPE_ADD_MODAL_SET = 'ACT_TYPE_ADD_MODAL_SET';
export const ACT_TYPE_ADD_CHANGE_SET = 'ACT_TYPE_ADD_CHANGE_SET';
export const ACT_TYPE_ADD = 'ACT_TYPE_ADD';
export const ACT_TYPE_ADD_SUCCESS = 'ACT_TYPE_ADD_SUCCESS';
export const ACT_TYPE_ADD_ERROR = 'ACT_TYPE_ADD_ERROR';
export const ACT_TYPE_GET = 'ACT_TYPE_GET';
export const ACT_TYPE_GET_SUCCESS = 'ACT_TYPE_GET_SUCCESS';
export const ACT_TYPE_GET_ERROR = 'ACT_TYPE_GET_ERROR';
export const ACT_TYPE_VIEW_MODAL_SET = 'ACT_TYPE_VIEW_MODAL_SET';
export const ACT_TYPE_EDIT_MODAL_SET = 'ACT_TYPE_EDIT_MODAL_SET';
export const ACT_TYPE_EDIT_CHANGE_SET = 'ACT_TYPE_EDIT_CHANGE_SET';
export const ACT_TYPE_EDIT = 'ACT_TYPE_EDIT';
export const ACT_TYPE_EDIT_SUCCESS = 'ACT_TYPE_EDIT_SUCCESS';
export const ACT_TYPE_EDIT_ERROR = 'ACT_TYPE_EDIT_ERROR';

/********************ACTIVITIES (TASK) - DETAIL CHAT *******************************************************/
export const ACT_DETAIL_LIST = 'ACT_DETAIL_LIST';
export const ACT_DETAIL_LIST_SUCCESS = 'ACT_DETAIL_LIST_SUCCESS';
export const ACT_DETAIL_LIST_ERROR = 'ACT_DETAIL_LIST_ERROR';
export const ACT_DETAIL_ADD = 'ACT_DETAIL_ADD';
export const ACT_DETAIL_ADD_SUCCESS = 'ACT_DETAIL_ADD_SUCCESS';
export const ACT_DETAIL_ADD_ERROR = 'ACT_DETAIL_ADD_ERROR';
export const ACT_TASK_STATUS = 'ACT_TASK_STATUS';
export const ACT_TASK_STATUS_SUCCESS = 'ACT_TASK_STATUS_SUCCESS';
export const ACT_TASK_STATUS_ERROR = 'ACT_TASK_STATUS_ERROR';

/********************ACTIVITIES (TASK) - DELIVERY PLAN DETAILS *********************************************/
export const ACT_MESSAGE_LIST = 'ACT_MESSAGE_LIST';
export const ACT_MESSAGE_LIST_SUCCESS = 'ACT_MESSAGE_LIST_SUCCESS';
export const ACT_MESSAGE_LIST_ERROR = 'ACT_MESSAGE_LIST_ERROR';

export const ACT_MESSAGE_READ = 'ACT_MESSAGE_READ';
export const ACT_MESSAGE_READ_SUCCESS = 'ACT_MESSAGE_READ_SUCCESS';
export const ACT_MESSAGE_READ_ERROR = 'ACT_MESSAGE_READ_ERROR';

export const ACT_DELIVERY_PLAN_DETAILS = 'ACT_DELIVERY_PLAN_DETAILS';
export const ACT_DELIVERY_PLAN_DETAILS_SUCCESS = 'ACT_DELIVERY_PLAN_DETAILS_SUCCESS';
export const ACT_DELIVERY_PLAN_DETAILS_ERROR = 'ACT_DELIVERY_PLAN_DETAILS_ERROR';

/********************EQUIPMENT UNIT *******************************************************/
export const ACT_GENERATE_EQUIPMENT_UNIT = 'ACT_GENERATE_EQUIPMENT_UNIT';
export const ACT_GENERATE_EQUIPMENT_UNIT_SUCCESS = 'ACT_GENERATE_EQUIPMENT_UNIT_SUCCESS';
export const ACT_GENERATE_EQUIPMENT_UNIT_ERROR = 'ACT_GENERATE_EQUIPMENT_UNIT_ERROR';

/********************MANAGEMENT / PROGRAM *******************************************************/
export const MGMT_PROGRAM_LIST = 'MGMT_PROGRAM_LIST';
export const MGMT_PROGRAM_LIST_SUCCESS = 'MGMT_PROGRAM_LIST_SUCCESS';
export const MGMT_PROGRAM_LIST_ERROR = 'MGMT_PROGRAM_LIST_ERROR';
export const MGMT_PROGRAM_PAGE_SET = 'MGMT_PROGRAM_PAGE_SET';
export const MGMT_PROGRAM_ADD = 'MGMT_PROGRAM_ADD';
export const MGMT_PROGRAM_ADD_SUCCESS = 'MGMT_PROGRAM_ADD_SUCCESS';
export const MGMT_PROGRAM_ADD_ERROR = 'MGMT_PROGRAM_ADD_ERROR';
export const MGMT_PROGRAM_ADD_CHANGE = 'MGMT_PROGRAM_ADD_CHANGE';
export const MGMT_PROGRAM_DETAIL = 'MGMT_PROGRAM_DETAIL';
export const MGMT_PROGRAM_DETAIL_SUCCESS = 'MGMT_PROGRAM_DETAIL_SUCCESS';
export const MGMT_PROGRAM_DETAIL_ERROR = 'MGMT_PROGRAM_DETAIL_ERROR';
export const MGMT_PROGRAM_UPDATE = 'MGMT_PROGRAM_UPDATE';
export const MGMT_PROGRAM_UPDATE_SUCCESS = 'MGMT_PROGRAM_UPDATE_SUCCESS';
export const MGMT_PROGRAM_UPDATE_ERROR = 'MGMT_PROGRAM_UPDATE_ERROR';

/********************MANAGEMENT / COMPONENT *******************************************************/
export const MGMT_COMPONENT_LIST = 'MGMT_COMPONENT_LIST';
export const MGMT_COMPONENT_LIST_SUCCESS = 'MGMT_COMPONENT_LIST_SUCCESS';
export const MGMT_COMPONENT_LIST_ERROR = 'MGMT_COMPONENT_LIST_ERROR';
export const MGMT_COMPONENT_PAGE_SET = 'MGMT_COMPONENT_PAGE_SET';
export const MGMT_COMPONENT_ADD = 'MGMT_COMPONENT_ADD';
export const MGMT_COMPONENT_ADD_SUCCESS = 'MGMT_COMPONENT_ADD_SUCCESS';
export const MGMT_COMPONENT_ADD_ERROR = 'MGMT_COMPONENT_ADD_ERROR';
export const MGMT_COMPONENT_ADD_CHANGE = 'MGMT_COMPONENT_ADD_CHANGE';
export const MGMT_COMPONENT_DETAIL = 'MGMT_COMPONENT_DETAIL';
export const MGMT_COMPONENT_DETAIL_SUCCESS = 'MGMT_COMPONENT_DETAIL_SUCCESS';
export const MGMT_COMPONENT_DETAIL_ERROR = 'MGMT_COMPONENT_DETAIL_ERROR';
export const MGMT_COMPONENT_UPDATE = 'MGMT_COMPONENT_UPDATE';
export const MGMT_COMPONENT_UPDATE_SUCCESS = 'MGMT_COMPONENT_UPDATE_SUCCESS';
export const MGMT_COMPONENT_UPDATE_ERROR = 'MGMT_COMPONENT_UPDATE_ERROR';

/********************MANAGEMENT / PROJECT *******************************************************/
export const MGMT_PROJECT_LIST = 'MGMT_PROJECT_LIST';
export const MGMT_PROJECT_LIST_SUCCESS = 'MGMT_PROJECT_LIST_SUCCESS';
export const MGMT_PROJECT_LIST_ERROR = 'MGMT_PROJECT_LIST_ERROR';
export const MGMT_PROJECT_PAGE_SET = 'MGMT_PROJECT_PAGE_SET';
export const MGMT_PROJECT_ADD = 'MGMT_PROJECT_ADD';
export const MGMT_PROJECT_ADD_SUCCESS = 'MGMT_PROJECT_ADD_SUCCESS';
export const MGMT_PROJECT_ADD_ERROR = 'MGMT_PROJECT_ADD_ERROR';
export const MGMT_PROJECT_ADD_CHANGE = 'MGMT_PROJECT_ADD_CHANGE';
export const MGMT_PROJECT_DETAIL = 'MGMT_PROJECT_DETAIL';
export const MGMT_PROJECT_DETAIL_SUCCESS = 'MGMT_PROJECT_DETAIL_SUCCESS';
export const MGMT_PROJECT_DETAIL_ERROR = 'MGMT_PROJECT_DETAIL_ERROR';
export const MGMT_PROJECT_UPDATE = 'MGMT_PROJECT_UPDATE';
export const MGMT_PROJECT_UPDATE_SUCCESS = 'MGMT_PROJECT_UPDATE_SUCCESS';
export const MGMT_PROJECT_UPDATE_ERROR = 'MGMT_PROJECT_UPDATE_ERROR';

/********************MANAGEMENT / OBJECTIVE *******************************************************/
export const MGMT_OBJECTIVE_LIST = 'MGMT_OBJECTIVE_LIST';
export const MGMT_OBJECTIVE_LIST_SUCCESS = 'MGMT_OBJECTIVE_LIST_SUCCESS';
export const MGMT_OBJECTIVE_LIST_ERROR = 'MGMT_OBJECTIVE_LIST_ERROR';
export const MGMT_OBJECTIVE_PAGE_SET = 'MGMT_OBJECTIVE_PAGE_SET';
export const MGMT_OBJECTIVE_ADD = 'MGMT_OBJECTIVE_ADD';
export const MGMT_OBJECTIVE_ADD_SUCCESS = 'MGMT_OBJECTIVE_ADD_SUCCESS';
export const MGMT_OBJECTIVE_ADD_ERROR = 'MGMT_OBJECTIVE_ADD_ERROR';
export const MGMT_OBJECTIVE_ADD_CHANGE = 'MGMT_OBJECTIVE_ADD_CHANGE';
export const MGMT_OBJECTIVE_DETAIL = 'MGMT_OBJECTIVE_DETAIL';
export const MGMT_OBJECTIVE_DETAIL_SUCCESS = 'MGMT_OBJECTIVE_DETAIL_SUCCESS';
export const MGMT_OBJECTIVE_DETAIL_ERROR = 'MGMT_OBJECTIVE_DETAIL_ERROR';
export const MGMT_OBJECTIVE_UPDATE = 'MGMT_OBJECTIVE_UPDATE';
export const MGMT_OBJECTIVE_UPDATE_SUCCESS = 'MGMT_OBJECTIVE_UPDATE_SUCCESS';
export const MGMT_OBJECTIVE_UPDATE_ERROR = 'MGMT_OBJECTIVE_UPDATE_ERROR';

/********************MANAGEMENT / OUTCOME *******************************************************/
export const MGMT_OUTCOME_LIST = 'MGMT_OUTCOME_LIST';
export const MGMT_OUTCOME_LIST_SUCCESS = 'MGMT_OUTCOME_LIST_SUCCESS';
export const MGMT_OUTCOME_LIST_ERROR = 'MGMT_OUTCOME_LIST_ERROR';
export const MGMT_OUTCOME_PAGE_SET = 'MGMT_OUTCOME_PAGE_SET';
export const MGMT_OUTCOME_ADD = 'MGMT_OUTCOME_ADD';
export const MGMT_OUTCOME_ADD_SUCCESS = 'MGMT_OUTCOME_ADD_SUCCESS';
export const MGMT_OUTCOME_ADD_ERROR = 'MGMT_OUTCOME_ADD_ERROR';
export const MGMT_OUTCOME_ADD_CHANGE = 'MGMT_OUTCOME_ADD_CHANGE';
export const MGMT_OUTCOME_DETAIL = 'MGMT_OUTCOME_DETAIL';
export const MGMT_OUTCOME_DETAIL_SUCCESS = 'MGMT_OUTCOME_DETAIL_SUCCESS';
export const MGMT_OUTCOME_DETAIL_ERROR = 'MGMT_OUTCOME_DETAIL_ERROR';
export const MGMT_OUTCOME_UPDATE = 'MGMT_OUTCOME_UPDATE';
export const MGMT_OUTCOME_UPDATE_SUCCESS = 'MGMT_OUTCOME_UPDATE_SUCCESS';
export const MGMT_OUTCOME_UPDATE_ERROR = 'MGMT_OUTCOME_UPDATE_ERROR';

/********************DELIVERY PLAN *******************************************************/
export const DP_LIST = 'DP_LIST';
export const DP_LIST_SUCCESS = 'DP_LIST_SUCCESS';
export const DP_LIST_ERROR = 'DP_LIST_ERROR';
export const DP_PAGE_SET = 'DP_PAGE_SET';
export const DP_UPDATE = 'DP_UPDATE';
export const DP_UPDATE_SUCCESS = 'DP_UPDATE_SUCCESS';
export const DP_UPDATE_ERROR = 'DP_UPDATE_ERROR';
export const DP_FILTER_SUPPLIERS = 'DP_FILTER_SUPPLIERS';
export const DP_FILTER_SUPPLIERS_SUCCESS = 'DP_FILTER_SUPPLIERS_SUCCESS';
export const DP_FILTER_ACQUISITION_DETAILS = 'DP_FILTER_ACQUISITION_DETAILS';
export const DP_FILTER_ACQUISITION_DETAILS_SUCCESS = 'DP_FILTER_ACQUISITION_DETAILS_SUCCESS';
export const DP_FILTER_DESTINATIONS = 'DP_FILTER_DESTINATIONS';
export const DP_FILTER_DESTINATIONS_SUCCESS = 'DP_FILTER_DESTINATIONS_SUCCESS';
export const DP_FILTER_DISBURSEMENTS = 'DP_FILTER_DISBURSEMENTS';
export const DP_FILTER_DISBURSEMENTS_SUCCESS = 'DP_FILTER_DISBURSEMENTS_SUCCESS';
export const DP_SEARCH_CHANGE = 'DP_SEARCH_CHANGE';


/********************DELIVERY PLAN DOCUMENTATION *******************************************************/
export const DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA = 'DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA';
export const DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS = 'DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS';
export const DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR = 'DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR';
export const DP_DOCUMENTATION_LIST = 'DP_DOCUMENTATION_LIST';
export const DP_DOCUMENTATION_LIST_SUCCESS = 'DP_DOCUMENTATION_LIST_SUCCESS';
export const DP_DOCUMENTATION_LIST_ERROR = 'DP_DOCUMENTATION_LIST_ERROR';
export const DP_DOCUMENTATION_SEND_INVOICE_EMAIL = 'DP_DOCUMENTATION_SEND_INVOICE_EMAIL';
export const DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS = 'DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS';
export const DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR = 'DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR';
export const DP_DOCUMENTATION_SEND_LETTERS_EMAIL = 'DP_DOCUMENTATION_SEND_LETTERS_EMAIL';
export const DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS = 'DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS';
export const DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR = 'DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR';

/********************DELIVERY PLAN TASK *******************************************************/
export const DELIVERY_PLAN_TASK_UPDATE = 'DELIVERY_PLAN_TASK_UPDATE';
export const DELIVERY_PLAN_TASK_UPDATE_SUCCESS = 'DELIVERY_PLAN_TASK_UPDATE_SUCCESS';
export const DELIVERY_PLAN_TASK_UPDATE_ERROR = 'DELIVERY_PLAN_TASK_UPDATE_ERROR';

/********************DELIVERY PLAN AUDIT *******************************************************/
export const DELIVERY_PLAN_AUDIT_LIST = 'DELIVERY_PLAN_AUDIT_LIST';
export const DELIVERY_PLAN_AUDIT_LIST_SUCCESS = 'DELIVERY_PLAN_AUDIT_LIST_SUCCESS';
export const DELIVERY_PLAN_AUDIT_LIST_ERROR = 'DELIVERY_PLAN_AUDIT_LIST_ERROR';
export const DELIVERY_PLAN_AUDIT_MODAL_SET = 'DELIVERY_PLAN_AUDIT_MODAL_SET';

/********************TASK INSPECTION *******************************************************/
export const TI_LIST = 'TI_LIST';
export const TI_LIST_SUCCESS = 'TI_LIST_SUCCESS';
export const TI_LIST_ERROR = 'TI_LIST_ERROR';
export const TI_PAGE_SET = 'TI_PAGE_SET';
export const TI_ENGINEERS = 'TI_ENGINEERS';
export const TI_ENGINEERS_SUCCESS = 'TI_ENGINEERS_SUCCESS';
export const TI_ADD = 'TI_ADD';
export const TI_ADD_SUCCESS = 'TI_ADD_SUCCESS';
export const TI_ADD_ERROR = 'TI_ADD_ERROR';
export const TI_SEARCH_CHANGE = 'TI_SEARCH_CHANGE';
export const TI_FILTER_TASK_STATUS = 'TI_FILTER_TASK_STATUS';
export const TI_FILTER_TASK_STATUS_SUCCESS = 'TI_FILTER_TASK_STATUS_SUCCESS';
export const TI_FILTER_SUPPLIERS = 'TI_FILTER_SUPPLIERS';
export const TI_FILTER_SUPPLIERS_SUCCESS = 'TI_FILTER_SUPPLIERS_SUCCESS';

/********************TASK INSPECTION DESTINATION *******************************************************/
export const TID_LIST = 'TID_LIST';
export const TID_LIST_SUCCESS = 'TID_LIST_SUCCESS';
export const TID_LIST_ERROR = 'TID_LIST_ERROR';
export const TID_PAGE_SET = 'TID_PAGE_SET';
export const TID_ENGINEERS = 'TID_ENGINEERS';
export const TID_ENGINEERS_SUCCESS = 'TID_ENGINEERS_SUCCESS';
export const TID_ADD = 'TID_ADD';
export const TID_ADD_SUCCESS = 'TID_ADD_SUCCESS';
export const TID_ADD_ERROR = 'TID_ADD_ERROR';
export const TID_SEARCH_CHANGE = 'TID_SEARCH_CHANGE';
export const TID_FILTER_TASK_STATUS = 'TID_FILTER_TASK_STATUS';
export const TID_FILTER_TASK_STATUS_SUCCESS = 'TID_FILTER_TASK_STATUS_SUCCESS';
export const TID_FILTER_SUPPLIERS = 'TID_FILTER_SUPPLIERS';
export const TID_FILTER_SUPPLIERS_SUCCESS = 'TID_FILTER_SUPPLIERS_SUCCESS';
export const TID_FILTER_DESTINATIONS = 'TID_FILTER_DESTINATIONS';
export const TID_FILTER_DESTINATIONS_SUCCESS = 'TID_FILTER_DESTINATIONS_SUCCESS';

/********************TASK DELIVERY *******************************************************/
export const TDLV_LIST = 'TDLV_LIST';
export const TDLV_LIST_SUCCESS = 'TDLV_LIST_SUCCESS';
export const TDLV_LIST_ERROR = 'TDLV_LIST_ERROR';
export const TDLV_PAGE_SET = 'TDLV_PAGE_SET';
export const TDLV_ENGINEERS = 'TDLV_ENGINEERS';
export const TDLV_ENGINEERS_SUCCESS = 'TDLV_ENGINEERS_SUCCESS';
export const TDLV_ADD = 'TDLV_ADD';
export const TDLV_ADD_SUCCESS = 'TDLV_ADD_SUCCESS';
export const TDLV_ADD_ERROR = 'TDLV_ADD_ERROR';
export const TDLV_SEARCH_CHANGE = 'TDLV_SEARCH_CHANGE';
export const TDLV_FILTER_TASK_STATUS = 'TDLV_FILTER_TASK_STATUS';
export const TDLV_FILTER_TASK_STATUS_SUCCESS = 'TDLV_FILTER_TASK_STATUS_SUCCESS';
export const TDLV_FILTER_SUPPLIERS = 'TDLV_FILTER_SUPPLIERS';
export const TDLV_FILTER_SUPPLIERS_SUCCESS = 'TDLV_FILTER_SUPPLIERS_SUCCESS';
export const TDLV_FILTER_DESTINATIONS = 'TDLV_FILTER_DESTINATIONS';
export const TDLV_FILTER_DESTINATIONS_SUCCESS = 'TDLV_FILTER_DESTINATIONS_SUCCESS';

/********************ACQUISITION *******************************************************/
export const ACQUISITION_LIST = 'ACQUISITION_LIST';
export const ACQUISITION_LIST_SUCCESS = 'ACQUISITION_LIST_SUCCESS';
export const ACQUISITION_LIST_ERROR = 'ACQUISITION_LIST_ERROR';
export const ACQUISITION_PAGE_SET = 'ACQUISITION_PAGE_SET';
export const ACQUISITION_DETAIL = 'ACQUISITION_DETAIL';
export const ACQUISITION_DETAIL_SUCCESS = 'ACQUISITION_DETAIL_SUCCESS';
export const ACQUISITION_DETAIL_ERROR = 'ACQUISITION_DETAIL_ERROR';
export const ACQUISITION_ADD = 'ACQUISITION_ADD';
export const ACQUISITION_ADD_SUCCESS = 'ACQUISITION_ADD_SUCCESS';
export const ACQUISITION_ADD_ERROR = 'ACQUISITION_ADD_ERROR';
export const ACQUISITION_ADD_CHANGE = 'ACQUISITION_ADD_CHANGE';
export const ACQUISITION_FILTER_DETAIL_TYPE = 'ACQUISITION_FILTER_DETAIL_TYPE';
export const ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS = 'ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS';
export const ACQUISITION_FILTER_DETAIL_PARENT = 'ACQUISITION_FILTER_DETAIL_PARENT';
export const ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS = 'ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS';

/********************ACQUISITION DETAIL BIDDABLE *******************************************************/
export const ACQUISITION_DETAIL_BIDDABLE_LIST = 'ACQUISITION_DETAIL_BIDDABLE_LIST';
export const ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS = 'ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS';
export const ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR = 'ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR';
export const ACQUISITION_DETAIL_BIDDABLE_PAGE_SET = 'ACQUISITION_DETAIL_BIDDABLE_PAGE_SET';
export const ACQUISITION_DETAIL_BIDDABLE_ADD = 'ACQUISITION_DETAIL_BIDDABLE_ADD';
export const ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS = 'ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS';
export const ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR = 'ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR';
export const ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE = 'ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE';
export const ACQUISITION_DETAIL_BIDDABLE_UPDATE = 'ACQUISITION_DETAIL_BIDDABLE_UPDATE';
export const ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS = 'ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS';
export const ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR = 'ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR';

/********************ACQUISITION DETAIL NOT BIDDABLE *******************************************************/
export const ACQUISITION_DETAIL_NOT_BIDDABLE_LIST = 'ACQUISITION_DETAIL_NOT_BIDDABLE_LIST';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_SUCCESS = 'ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_SUCCESS';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_ERROR = 'ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_ERROR';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_ADD = 'ACQUISITION_DETAIL_NOT_BIDDABLE_ADD';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_SUCCESS = 'ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_SUCCESS';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_ERROR = 'ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_ERROR';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_CHANGE = 'ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_CHANGE';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE = 'ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_SUCCESS = 'ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_SUCCESS';
export const ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_ERROR = 'ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_ERROR';
export const ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE = 'ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE';
export const ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE_SUCCESS = 'ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE_SUCCESS';

/********************TASK EQUIPMENT *******************************************************/
export const TASK_EQUIPMENT_RESET = 'TASK_EQUIPMENT_RESET';
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN';
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS';
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR';
export const EQUIPMENT_MODEL_UPDATE = 'EQUIPMENT_MODEL_UPDATE';
export const EQUIPMENT_MODEL_UPDATE_SUCCESS = 'EQUIPMENT_MODEL_UPDATE_SUCCESS';
export const EQUIPMENT_MODEL_UPDATE_ERROR = 'EQUIPMENT_MODEL_UPDATE_ERROR';
export const EQUIPMENT_UNIT_UPDATE = 'EQUIPMENT_UNIT_UPDATE';
export const EQUIPMENT_UNIT_UPDATE_SUCCESS = 'EQUIPMENT_UNIT_UPDATE_SUCCESS';
export const EQUIPMENT_UNIT_UPDATE_ERROR = 'EQUIPMENT_UNIT_UPDATE_ERROR';
export const EQUIPMENT_BULK_SAVE = 'EQUIPMENT_BULK_SAVE';
export const EQUIPMENT_BULK_SAVE_SUCCESS = 'EQUIPMENT_BULK_SAVE_SUCCESS';
export const EQUIPMENT_BULK_SAVE_ERROR = 'EQUIPMENT_BULK_SAVE_ERROR';

/********************CATALOG / VEHICLE TYPE *******************************************************/
export const CAT_VEHICLE_TYPE_LIST = 'CAT_VEHICLE_TYPE_LIST';
export const CAT_VEHICLE_TYPE_LIST_SUCCESS = 'CAT_VEHICLE_TYPE_LIST_SUCCESS';
export const CAT_VEHICLE_TYPE_LIST_ERROR = 'CAT_VEHICLE_TYPE_LIST_ERROR';
export const CAT_VEHICLE_TYPE_PAGE_SET = 'CAT_VEHICLE_TYPE_PAGE_SET';
export const CAT_VEHICLE_TYPE_ADD = 'CAT_VEHICLE_TYPE_ADD';
export const CAT_VEHICLE_TYPE_ADD_SUCCESS = 'CAT_VEHICLE_TYPE_ADD_SUCCESS';
export const CAT_VEHICLE_TYPE_ADD_ERROR = 'CAT_VEHICLE_TYPE_ADD_ERROR';
export const CAT_VEHICLE_TYPE_ADD_CHANGE = 'CAT_VEHICLE_TYPE_ADD_CHANGE';
export const CAT_VEHICLE_TYPE_DETAIL = 'CAT_VEHICLE_TYPE_DETAIL';
export const CAT_VEHICLE_TYPE_DETAIL_SUCCESS = 'CAT_VEHICLE_TYPE_DETAIL_SUCCESS';
export const CAT_VEHICLE_TYPE_DETAIL_ERROR = 'CAT_VEHICLE_TYPE_DETAIL_ERROR';
export const CAT_VEHICLE_TYPE_UPDATE = 'CAT_VEHICLE_TYPE_UPDATE';
export const CAT_VEHICLE_TYPE_UPDATE_SUCCESS = 'CAT_VEHICLE_TYPE_UPDATE_SUCCESS';
export const CAT_VEHICLE_TYPE_UPDATE_ERROR = 'CAT_VEHICLE_TYPE_UPDATE_ERROR';

/********************SUPPLIER / VEHICLE *******************************************************/
export const SUP_VEHICLE_LIST = 'SUP_VEHICLE_LIST';
export const SUP_VEHICLE_LIST_SUCCESS = 'SUP_VEHICLE_LIST_SUCCESS';
export const SUP_VEHICLE_LIST_ERROR = 'SUP_VEHICLE_LIST_ERROR';
export const SUP_VEHICLE_PAGE_SET = 'SUP_VEHICLE_PAGE_SET';
export const SUP_VEHICLE_ADD = 'SUP_VEHICLE_ADD';
export const SUP_VEHICLE_ADD_SUCCESS = 'SUP_VEHICLE_ADD_SUCCESS';
export const SUP_VEHICLE_ADD_ERROR = 'SUP_VEHICLE_ADD_ERROR';
export const SUP_VEHICLE_ADD_CHANGE = 'SUP_VEHICLE_ADD_CHANGE';
export const SUP_VEHICLE_DETAIL = 'SUP_VEHICLE_DETAIL';
export const SUP_VEHICLE_DETAIL_SUCCESS = 'SUP_VEHICLE_DETAIL_SUCCESS';
export const SUP_VEHICLE_DETAIL_ERROR = 'SUP_VEHICLE_DETAIL_ERROR';
export const SUP_VEHICLE_UPDATE = 'SUP_VEHICLE_UPDATE';
export const SUP_VEHICLE_UPDATE_SUCCESS = 'SUP_VEHICLE_UPDATE_SUCCESS';
export const SUP_VEHICLE_UPDATE_ERROR = 'SUP_VEHICLE_UPDATE_ERROR';
export const SUP_VEHICLE_FILTER_TYPE = 'SUP_VEHICLE_FILTER_TYPE';
export const SUP_VEHICLE_FILTER_TYPE_SUCCESS = 'SUP_VEHICLE_FILTER_TYPE_SUCCESS';
export const SUP_VEHICLE_FILTER_SUPPLIERS = 'SUP_VEHICLE_FILTER_SUPPLIERS';
export const SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS = 'SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS';

/********************SUPPLIER / EMPLOYEE *******************************************************/
export const SUP_EMPLOYEE_LIST = 'SUP_EMPLOYEE_LIST';
export const SUP_EMPLOYEE_LIST_SUCCESS = 'SUP_EMPLOYEE_LIST_SUCCESS';
export const SUP_EMPLOYEE_LIST_ERROR = 'SUP_EMPLOYEE_LIST_ERROR';
export const SUP_EMPLOYEE_PAGE_SET = 'SUP_EMPLOYEE_PAGE_SET';
export const SUP_EMPLOYEE_ADD = 'SUP_EMPLOYEE_ADD';
export const SUP_EMPLOYEE_ADD_SUCCESS = 'SUP_EMPLOYEE_ADD_SUCCESS';
export const SUP_EMPLOYEE_ADD_ERROR = 'SUP_EMPLOYEE_ADD_ERROR';
export const SUP_EMPLOYEE_ADD_CHANGE = 'SUP_EMPLOYEE_ADD_CHANGE';
export const SUP_EMPLOYEE_DETAIL = 'SUP_EMPLOYEE_DETAIL';
export const SUP_EMPLOYEE_DETAIL_SUCCESS = 'SUP_EMPLOYEE_DETAIL_SUCCESS';
export const SUP_EMPLOYEE_DETAIL_ERROR = 'SUP_EMPLOYEE_DETAIL_ERROR';
export const SUP_EMPLOYEE_UPDATE = 'SUP_EMPLOYEE_UPDATE';
export const SUP_EMPLOYEE_UPDATE_SUCCESS = 'SUP_EMPLOYEE_UPDATE_SUCCESS';
export const SUP_EMPLOYEE_UPDATE_ERROR = 'SUP_EMPLOYEE_UPDATE_ERROR';
export const SUP_EMPLOYEE_FILTER_SUPPLIERS = 'SUP_EMPLOYEE_FILTER_SUPPLIERS';
export const SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS = 'SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS';

/********************TASK / TASK EMPLOYEE AUDIT *******************************************************/
export const TASK_EMPLOYEE_AUDIT_LIST = 'TASK_EMPLOYEE_AUDIT_LIST';
export const TASK_EMPLOYEE_AUDIT_LIST_SUCCESS = 'TASK_EMPLOYEE_AUDIT_LIST_SUCCESS';
export const TASK_EMPLOYEE_AUDIT_LIST_ERROR = 'TASK_EMPLOYEE_AUDIT_LIST_ERROR';
export const TASK_EMPLOYEE_AUDIT_MODAL_SET = 'TASK_EMPLOYEE_AUDIT_MODAL_SET';

/********************TASK / TASK EMPLOYEE *******************************************************/
export const TASK_EMPLOYEE_LIST = 'TASK_EMPLOYEE_LIST';
export const TASK_EMPLOYEE_LIST_SUCCESS = 'TASK_EMPLOYEE_LIST_SUCCESS';
export const TASK_EMPLOYEE_LIST_ERROR = 'TASK_EMPLOYEE_LIST_ERROR';
export const TASK_EMPLOYEE_PAGE_SET = 'TASK_EMPLOYEE_PAGE_SET';
export const TASK_EMPLOYEE_ADD = 'TASK_EMPLOYEE_ADD';
export const TASK_EMPLOYEE_ADD_SUCCESS = 'TASK_EMPLOYEE_ADD_SUCCESS';
export const TASK_EMPLOYEE_ADD_ERROR = 'TASK_EMPLOYEE_ADD_ERROR';
export const TASK_EMPLOYEE_ADD_CHANGE = 'TASK_EMPLOYEE_ADD_CHANGE';
export const TASK_EMPLOYEE_DETAIL = 'TASK_EMPLOYEE_DETAIL';
export const TASK_EMPLOYEE_DETAIL_SUCCESS = 'TASK_EMPLOYEE_DETAIL_SUCCESS';
export const TASK_EMPLOYEE_DETAIL_ERROR = 'TASK_EMPLOYEE_DETAIL_ERROR';
export const TASK_EMPLOYEE_UPDATE = 'TASK_EMPLOYEE_UPDATE';
export const TASK_EMPLOYEE_UPDATE_SUCCESS = 'TASK_EMPLOYEE_UPDATE_SUCCESS';
export const TASK_EMPLOYEE_UPDATE_ERROR = 'TASK_EMPLOYEE_UPDATE_ERROR';
export const TASK_EMPLOYEE_FILTER_EMPLOYEES = 'TASK_EMPLOYEE_FILTER_EMPLOYEES';
export const TASK_EMPLOYEE_FILTER_EMPLOYEES_SUCCESS = 'TASK_EMPLOYEE_FILTER_EMPLOYEES_SUCCESS';

/********************TASK / TASK VEHICLE AUDIT *******************************************************/
export const TASK_VEHICLE_AUDIT_LIST = 'TASK_VEHICLE_AUDIT_LIST';
export const TASK_VEHICLE_AUDIT_LIST_SUCCESS = 'TASK_VEHICLE_AUDIT_LIST_SUCCESS';
export const TASK_VEHICLE_AUDIT_LIST_ERROR = 'TASK_VEHICLE_AUDIT_LIST_ERROR';
export const TASK_VEHICLE_AUDIT_MODAL_SET = 'TASK_VEHICLE_AUDIT_MODAL_SET';

/********************TASK / TASK VEHICLE *******************************************************/
export const TASK_VEHICLE_LIST = 'TASK_VEHICLE_LIST';
export const TASK_VEHICLE_LIST_SUCCESS = 'TASK_VEHICLE_LIST_SUCCESS';
export const TASK_VEHICLE_LIST_ERROR = 'TASK_VEHICLE_LIST_ERROR';
export const TASK_VEHICLE_PAGE_SET = 'TASK_VEHICLE_PAGE_SET';
export const TASK_VEHICLE_ADD = 'TASK_VEHICLE_ADD';
export const TASK_VEHICLE_ADD_SUCCESS = 'TASK_VEHICLE_ADD_SUCCESS';
export const TASK_VEHICLE_ADD_ERROR = 'TASK_VEHICLE_ADD_ERROR';
export const TASK_VEHICLE_ADD_CHANGE = 'TASK_VEHICLE_ADD_CHANGE';
export const TASK_VEHICLE_DETAIL = 'TASK_VEHICLE_DETAIL';
export const TASK_VEHICLE_DETAIL_SUCCESS = 'TASK_VEHICLE_DETAIL_SUCCESS';
export const TASK_VEHICLE_DETAIL_ERROR = 'TASK_VEHICLE_DETAIL_ERROR';
export const TASK_VEHICLE_UPDATE = 'TASK_VEHICLE_UPDATE';
export const TASK_VEHICLE_UPDATE_SUCCESS = 'TASK_VEHICLE_UPDATE_SUCCESS';
export const TASK_VEHICLE_UPDATE_ERROR = 'TASK_VEHICLE_UPDATE_ERROR';
export const TASK_VEHICLE_FILTER_TYPE = 'TASK_VEHICLE_FILTER_TYPE';
export const TASK_VEHICLE_FILTER_TYPE_SUCCESS = 'TASK_VEHICLE_FILTER_TYPE_SUCCESS';
export const TASK_VEHICLE_FILTER_VEHICLES = 'TASK_VEHICLE_FILTER_VEHICLES';
export const TASK_VEHICLE_FILTER_VEHICLES_SUCCESS = 'TASK_VEHICLE_FILTER_VEHICLES_SUCCESS';

/********************ENTERPRISE / SUPPLIER USER *******************************************************/
export const ENT_SUPPLIER_USER_LIST = 'ENT_SUPPLIER_USER_LIST';
export const ENT_SUPPLIER_USER_LIST_SUCCESS = 'ENT_SUPPLIER_USER_LIST_SUCCESS';
export const ENT_SUPPLIER_USER_LIST_ERROR = 'ENT_SUPPLIER_USER_LIST_ERROR';
export const ENT_SUPPLIER_USER_PAGE_SET = 'ENT_SUPPLIER_USER_PAGE_SET';
export const ENT_SUPPLIER_USER_ADD = 'ENT_SUPPLIER_USER_ADD';
export const ENT_SUPPLIER_USER_ADD_SUCCESS = 'ENT_SUPPLIER_USER_ADD_SUCCESS';
export const ENT_SUPPLIER_USER_ADD_ERROR = 'ENT_SUPPLIER_USER_ADD_ERROR';
export const ENT_SUPPLIER_USER_ADD_CHANGE = 'ENT_SUPPLIER_USER_ADD_CHANGE';
export const ENT_SUPPLIER_USER_DETAIL = 'ENT_SUPPLIER_USER_DETAIL';
export const ENT_SUPPLIER_USER_DETAIL_SUCCESS = 'ENT_SUPPLIER_USER_DETAIL_SUCCESS';
export const ENT_SUPPLIER_USER_DETAIL_ERROR = 'ENT_SUPPLIER_USER_DETAIL_ERROR';
export const ENT_SUPPLIER_USER_UPDATE = 'ENT_SUPPLIER_USER_UPDATE';
export const ENT_SUPPLIER_USER_UPDATE_SUCCESS = 'ENT_SUPPLIER_USER_UPDATE_SUCCESS';
export const ENT_SUPPLIER_USER_UPDATE_ERROR = 'ENT_SUPPLIER_USER_UPDATE_ERROR';

/********************ENTERPRISE / SUPPLIER *******************************************************/
export const ENT_SUPPLIER_LIST = 'ENT_SUPPLIER_LIST';
export const ENT_SUPPLIER_LIST_SUCCESS = 'ENT_SUPPLIER_LIST_SUCCESS';
export const ENT_SUPPLIER_LIST_ERROR = 'ENT_SUPPLIER_LIST_ERROR';
export const ENT_SUPPLIER_PAGE_SET = 'ENT_SUPPLIER_PAGE_SET';
export const ENT_SUPPLIER_SEARCH_CHANGE = 'ENT_SUPPLIER_SEARCH_CHANGE';
export const ENT_SUPPLIER_DETAIL = 'ENT_SUPPLIER_DETAIL';
export const ENT_SUPPLIER_DETAIL_SUCCESS = 'ENT_SUPPLIER_DETAIL_SUCCESS';
export const ENT_SUPPLIER_DETAIL_ERROR = 'ENT_SUPPLIER_DETAIL_ERROR';
export const ENT_SUPPLIER_VIEW_MODAL_SET = 'ENT_SUPPLIER_VIEW_MODAL_SET';

/********************COMMUNICATION / CATALOG *******************************************************/
export const COM_CATALOG_LIST = 'COM_CATALOG_LIST';
export const COM_CATALOG_LIST_SUCCESS = 'COM_CATALOG_LIST_SUCCESS';
export const COM_CATALOG_LIST_ERROR = 'COM_CATALOG_LIST_ERROR';
export const COM_CATALOG_PAGE_SET = 'COM_CATALOG_PAGE_SET';
export const COM_CATALOG_SEARCH_CHANGE = 'COM_CATALOG_SEARCH_CHANGE';
export const COM_CATALOG_ADD_MODAL_SET = 'COM_CATALOG_ADD_MODAL_SET';
export const COM_CATALOG_ADD_CHANGE = 'COM_CATALOG_ADD_CHANGE';
export const COM_CATALOG_ADD = 'COM_CATALOG_ADD';
export const COM_CATALOG_ADD_SUCCESS = 'COM_CATALOG_ADD_SUCCESS';
export const COM_CATALOG_ADD_ERROR = 'COM_CATALOG_ADD_ERROR';
export const COM_CATALOG_EDIT_MODAL_SET = 'COM_CATALOG_EDIT_MODAL_SET';
export const COM_CATALOG_EDIT_SET_DATA = 'COM_CATALOG_EDIT_SET_DATA';
export const COM_CATALOG_UPDATE = 'COM_CATALOG_UPDATE';
export const COM_CATALOG_UPDATE_SUCCESS = 'COM_CATALOG_UPDATE_SUCCESS';
export const COM_CATALOG_UPDATE_ERROR = 'COM_CATALOG_UPDATE_ERROR';
export const COM_CATALOG_CANCEL_MODAL_SET = 'COM_CATALOG_CANCEL_MODAL_SET';
export const COM_CATALOG_CANCEL_SET_DATA = 'COM_CATALOG_CANCEL_SET_DATA';

/********************COMMUNICATION / CATALOG DETAIL *******************************************************/
export const COM_CATALOG_DETAIL_LIST = 'COM_CATALOG_DETAIL_LIST';
export const COM_CATALOG_DETAIL_LIST_SUCCESS = 'COM_CATALOG_DETAIL_LIST_SUCCESS';
export const COM_CATALOG_DETAIL_LIST_ERROR = 'COM_CATALOG_DETAIL_LIST_ERROR';
export const COM_CATALOG_DETAIL_PAGE_SET = 'COM_CATALOG_DETAIL_PAGE_SET';
export const COM_CATALOG_DETAIL_ADD_MODAL_SET = 'COM_CATALOG_DETAIL_ADD_MODAL_SET';
export const COM_CATALOG_DETAIL_ADD_CHANGE = 'COM_CATALOG_DETAIL_ADD_CHANGE';
export const COM_CATALOG_DETAIL_ADD = 'COM_CATALOG_DETAIL_ADD';
export const COM_CATALOG_DETAIL_ADD_SUCCESS = 'COM_CATALOG_DETAIL_ADD_SUCCESS';
export const COM_CATALOG_DETAIL_ADD_ERROR = 'COM_CATALOG_DETAIL_ADD_ERROR';
export const COM_CATALOG_DETAIL_EDIT_MODAL_SET = 'COM_CATALOG_DETAIL_EDIT_MODAL_SET';
export const COM_CATALOG_DETAIL_EDIT_SET_DATA = 'COM_CATALOG_DETAIL_EDIT_SET_DATA';
export const COM_CATALOG_DETAIL_UPDATE = 'COM_CATALOG_DETAIL_UPDATE';
export const COM_CATALOG_DETAIL_UPDATE_SUCCESS = 'COM_CATALOG_DETAIL_UPDATE_SUCCESS';
export const COM_CATALOG_DETAIL_UPDATE_ERROR = 'COM_CATALOG_DETAIL_UPDATE_ERROR';
export const COM_CATALOG_DETAIL_CANCEL_MODAL_SET = 'COM_CATALOG_DETAIL_CANCEL_MODAL_SET';
export const COM_CATALOG_DETAIL_CANCEL_SET_DATA = 'COM_CATALOG_DETAIL_CANCEL_SET_DATA';

/********************COMMUNICATION / AREA *******************************************************/
export const COM_AREA_LIST = 'COM_AREA_LIST';
export const COM_AREA_LIST_SUCCESS = 'COM_AREA_LIST_SUCCESS';
export const COM_AREA_LIST_ERROR = 'COM_AREA_LIST_ERROR';
export const COM_AREA_PAGE_SET = 'COM_AREA_PAGE_SET';
export const COM_AREA_SEARCH_CHANGE = 'COM_AREA_SEARCH_CHANGE';
export const COM_AREA_ADD_MODAL_SET = 'COM_AREA_ADD_MODAL_SET';
export const COM_AREA_ADD_CHANGE = 'COM_AREA_ADD_CHANGE';
export const COM_AREA_ADD = 'COM_AREA_ADD';
export const COM_AREA_ADD_SUCCESS = 'COM_AREA_ADD_SUCCESS';
export const COM_AREA_ADD_ERROR = 'COM_AREA_ADD_ERROR';
export const COM_AREA_EDIT_MODAL_SET = 'COM_AREA_EDIT_MODAL_SET';
export const COM_AREA_EDIT_SET_DATA = 'COM_AREA_EDIT_SET_DATA';
export const COM_AREA_UPDATE = 'COM_AREA_UPDATE';
export const COM_AREA_UPDATE_SUCCESS = 'COM_AREA_UPDATE_SUCCESS';
export const COM_AREA_UPDATE_ERROR = 'COM_AREA_UPDATE_ERROR';
export const COM_AREA_CANCEL_MODAL_SET = 'COM_AREA_CANCEL_MODAL_SET';
export const COM_AREA_CANCEL_SET_DATA = 'COM_AREA_CANCEL_SET_DATA';

/********************REPORT / IDX PAYMENT REPORT *******************************************************/

export const INDEX_PAYMENT_REPORT_REPORT = 'INDEX_PAYMENT_REPORT_REPORT';
export const INDEX_PAYMENT_REPORT_REPORT_SUCCESS = 'INDEX_PAYMENT_REPORT_REPORT_SUCCESS';
export const INDEX_PAYMENT_REPORT_REPORT_ERROR = 'INDEX_PAYMENT_REPORT_REPORT_ERROR';
export const INDEX_PAYMENT_REPORT_SEARCH_SET = 'INDEX_PAYMENT_REPORT_SEARCH_SET';
export const INDEX_PAYMENT_REPORT_SEARCH_CHANGE = 'INDEX_PAYMENT_REPORT_SEARCH_SET';
export const INDEX_PAYMENT_REPORT_TAB_SET = 'INDEX_PAYMENT_REPORT_TAB_SET';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS';
export const INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR = 'INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR';
export const INDEX_PAYMENT_REPORT_DESTINATION = 'INDEX_PAYMENT_REPORT_DESTINATION';
export const INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS = 'INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS';
export const INDEX_PAYMENT_REPORT_DESTINATION_ERROR = 'INDEX_PAYMENT_REPORT_DESTINATION_ERROR';



/********************AMBULANCE / DOCUMENTS *******************************************************/
export const AMBULANCE_DOCUMENT_USER = 'AMBULANCE_DOCUMENT_USER';
export const AMBULANCE_DOCUMENT_USER_SUCCESS = 'AMBULANCE_DOCUMENT_USER_SUCCESS';
export const AMBULANCE_DOCUMENT_USER_ERROR = 'AMBULANCE_DOCUMENT_USER_ERROR';
export const AMBULANCE_DOCUMENT_CODE_IGSS = 'AMBULANCE_DOCUMENT_CODE_IGSS';
export const AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS = 'AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS';
export const AMBULANCE_DOCUMENT_CODE_IGSS_ERROR = 'AMBULANCE_DOCUMENT_CODE_IGSS_ERROR';
export const AMBULANCE_DOCUMENT_PLATES = 'AMBULANCE_DOCUMENT_PLATES';
export const AMBULANCE_DOCUMENT_PLATES_SUCCESS = 'AMBULANCE_DOCUMENT_PLATES_SUCCESS';
export const AMBULANCE_DOCUMENT_PLATES_ERROR = 'AMBULANCE_DOCUMENT_PLATES_ERROR';
export const AMBULANCE_DOCUMENT_CHASIS = 'AMBULANCE_DOCUMENT_CHASIS';
export const AMBULANCE_DOCUMENT_CHASIS_SUCCESS = 'AMBULANCE_DOCUMENT_CHASIS_SUCCESS';
export const AMBULANCE_DOCUMENT_CHASIS_ERROR = 'AMBULANCE_DOCUMENT_CHASIS_ERROR';
export const AMBULANCE_DOCUMENT_STATUS_REVIEW = 'AMBULANCE_DOCUMENT_STATUS_REVIEW';
export const AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS = 'AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS';
export const AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR = 'AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR';
export const AMBULANCE_DOCUMENT_USER_ASSIGNED = 'AMBULANCE_DOCUMENT_USER_ASSIGNED';
export const AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS = 'AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS';
export const AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR = 'AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR';
export const AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN = 'AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN';
export const AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS = 'AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS';
export const AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR = 'AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR';
export const AMBULANCE_DOCUMENT_LIST = 'AMBULANCE_DOCUMENT_LIST';
export const AMBULANCE_DOCUMENT_LIST_SUCCESS = 'AMBULANCE_DOCUMENT_LIST_SUCCESS';
export const AMBULANCE_DOCUMENT_LIST_ERROR = 'AMBULANCE_DOCUMENT_LIST_ERROR';
export const AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE = 'AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE';
export const AMBULANCE_DOCUMENT_LIST_PAGE_SET = 'AMBULANCE_DOCUMENT_LIST_PAGE_SET';
export const AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET = 'AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET';
export const AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET = 'AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET';
export const AMBULANCE_DOCUMENT_ASSIGN = 'AMBULANCE_DOCUMENT_ASSIGN';
export const AMBULANCE_DOCUMENT_ASSIGN_SUCCESS = 'AMBULANCE_DOCUMENT_ASSIGN_SUCCESS';
export const AMBULANCE_DOCUMENT_ASSIGN_ERROR = 'AMBULANCE_DOCUMENT_ASSIGN_ERROR';
export const AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET = 'AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET';
export const AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET = 'AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET';
export const AMBULANCE_DOCUMENT_VALIDATE = 'AMBULANCE_DOCUMENT_VALIDATE';
export const AMBULANCE_DOCUMENT_VALIDATE_SUCCESS = 'AMBULANCE_DOCUMENT_VALIDATE_SUCCESS';
export const AMBULANCE_DOCUMENT_VALIDATE_ERROR = 'AMBULANCE_DOCUMENT_VALIDATE_ERROR';
export const AMBULANCE_DOCUMENT_SEE_MODAL_SET = 'AMBULANCE_DOCUMENT_SEE_MODAL_SET';
export const AMBULANCE_DOCUMENT_SEE_CHANGE_SET = 'AMBULANCE_DOCUMENT_SEE_CHANGE_SET';
export const AMBULANCE_DOCUMENT_SEE_DOCUMENT = 'AMBULANCE_DOCUMENT_SEE_DOCUMENT';
export const AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS = 'AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS';
export const AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR = 'AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR';

/********************AMBULANCE / MAINTENANCE *******************************************************/
export const AMBULANCE_MAINTENANCE_PLATES = 'AMBULANCE_MAINTENANCE_PLATES';
export const AMBULANCE_MAINTENANCE_PLATES_SUCCESS = 'AMBULANCE_MAINTENANCE_PLATES_SUCCESS';
export const AMBULANCE_MAINTENANCE_PLATES_ERROR = 'AMBULANCE_MAINTENANCE_PLATES_ERROR';
export const AMBULANCE_MAINTENANCE_CHASIS = 'AMBULANCE_MAINTENANCE_CHASIS';
export const AMBULANCE_MAINTENANCE_CHASIS_SUCCESS = 'AMBULANCE_MAINTENANCE_CHASIS_SUCCESS';
export const AMBULANCE_MAINTENANCE_CHASIS_ERROR = 'AMBULANCE_MAINTENANCE_CHASIS_ERROR';
export const AMBULANCE_MAINTENANCE_CODE_IGSS = 'AMBULANCE_MAINTENANCE_CODE_IGSS';
export const AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS = 'AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS';
export const AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR = 'AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR';
export const AMBULANCE_MAINTENANCE_LIST = 'AMBULANCE_MAINTENANCE_LIST';
export const AMBULANCE_MAINTENANCE_LIST_SUCCESS = 'AMBULANCE_MAINTENANCE_LIST_SUCCESS';
export const AMBULANCE_MAINTENANCE_LIST_ERROR = 'AMBULANCE_MAINTENANCE_LIST_ERROR';
export const AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE = 'AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE';
export const AMBULANCE_MAINTENANCE_LIST_SEARCH_SET = 'AMBULANCE_MAINTENANCE_LIST_SEARCH_SET';
export const AMBULANCE_MAINTENANCE_LIST_PAGE_SET = 'AMBULANCE_MAINTENANCE_LIST_PAGE_SET';
export const AMBULANCE_MAINTENANCE_DETAIL = 'AMBULANCE_MAINTENANCE_DETAIL';
export const AMBULANCE_MAINTENANCE_DETAIL_SUCCESS = 'AMBULANCE_MAINTENANCE_DETAIL_SUCCESS';
export const AMBULANCE_MAINTENANCE_DETAIL_ERROR = 'AMBULANCE_MAINTENANCE_DETAIL_ERROR';
export const AMBULANCE_MAINTENANCE_VIEW_MODAL_SET = 'AMBULANCE_MAINTENANCE_VIEW_MODAL_SET';
export const AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET = 'AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET';
export const AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET = 'AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET';
export const AMBULANCE_MAINTENANCE_UPDATE = 'AMBULANCE_MAINTENANCE_UPDATE';
export const AMBULANCE_MAINTENANCE_UPDATE_SUCCESS = 'AMBULANCE_MAINTENANCE_UPDATE_SUCCESS';
export const AMBULANCE_MAINTENANCE_UPDATE_ERROR = 'AMBULANCE_MAINTENANCE_UPDATE_ERROR';

/********************INFRASTRUCTURE / DELIVERABLE *******************************************************/
export const INFRA_DELIVERABLE_PROJECT = 'INFRA_DELIVERABLE_PROJECT';
export const INFRA_DELIVERABLE_PROJECT_SUCCESS = 'INFRA_DELIVERABLE_PROJECT_SUCCESS';
export const INFRA_DELIVERABLE_PROJECT_ERROR = 'INFRA_DELIVERABLE_PROJECT_ERROR';

export const INFRA_DELIVERABLE_PHASES = 'INFRA_DELIVERABLE_PHASES';
export const INFRA_DELIVERABLE_PHASES_SUCCESS = 'INFRA_DELIVERABLE_PHASES_SUCCESS';
export const INFRA_DELIVERABLE_PHASES_ERROR = 'INFRA_DELIVERABLE_PHASES_ERROR';

export const INFRA_DELIVERABLE_PHASE_SET = 'INFRA_DELIVERABLE_PHASE_SET';

export const INFRA_DELIVERABLE_LIST = 'INFRA_DELIVERABLE_LIST';
export const INFRA_DELIVERABLE_LIST_SUCCESS = 'INFRA_DELIVERABLE_LIST_SUCCESS';
export const INFRA_DELIVERABLE_LIST_ERROR = 'INFRA_DELIVERABLE_LIST_ERROR';

export const INFRA_DELIVERABLE_FREQUENCY = 'INFRA_DELIVERABLE_FREQUENCY';
export const INFRA_DELIVERABLE_FREQUENCY_SUCCESS = 'INFRA_DELIVERABLE_FREQUENCY_SUCCESS';
export const INFRA_DELIVERABLE_FREQUENCY_ERROR = 'INFRA_DELIVERABLE_FREQUENCY_ERROR';

export const INFRA_DELIVERABLE_ACTIVITY_TYPE = 'INFRA_DELIVERABLE_ACTIVITY_TYPE';
export const INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS = 'INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS';
export const INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR = 'INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR';

export const INFRA_DELIVERABLE_STATUS_REVIEW = 'INFRA_DELIVERABLE_STATUS_REVIEW';
export const INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS = 'INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS';
export const INFRA_DELIVERABLE_STATUS_REVIEW_ERROR = 'INFRA_DELIVERABLE_STATUS_REVIEW_ERROR';

export const INFRA_DELIVERABLE_USERS = 'INFRA_DELIVERABLE_USERS';
export const INFRA_DELIVERABLE_USERS_SUCCESS = 'INFRA_DELIVERABLE_USERS_SUCCESS';
export const INFRA_DELIVERABLE_USERS_ERROR = 'INFRA_DELIVERABLE_USERS_ERROR';

// Entregable: sección EDIT (editar / crear si no existe id_deliverable)
export const INFRA_DELIVERABLE_EDIT_MODAL_SET = 'INFRA_DELIVERABLE_EDIT_MODAL_SET';
export const INFRA_DELIVERABLE_EDIT_CHANGE_SET = 'INFRA_DELIVERABLE_EDIT_CHANGE_SET';

// Entregable: sección VIEW (solo lectura)
export const INFRA_DELIVERABLE_VIEW_MODAL_SET = 'INFRA_DELIVERABLE_VIEW_MODAL_SET';
export const INFRA_DELIVERABLE_VIEW_SET = 'INFRA_DELIVERABLE_VIEW_SET';

export const INFRA_DELIVERABLE_ADD = 'INFRA_DELIVERABLE_ADD';
export const INFRA_DELIVERABLE_ADD_SUCCESS = 'INFRA_DELIVERABLE_ADD_SUCCESS';
export const INFRA_DELIVERABLE_ADD_ERROR = 'INFRA_DELIVERABLE_ADD_ERROR';

export const INFRA_DELIVERABLE_UPDATE = 'INFRA_DELIVERABLE_UPDATE';
export const INFRA_DELIVERABLE_UPDATE_SUCCESS = 'INFRA_DELIVERABLE_UPDATE_SUCCESS';
export const INFRA_DELIVERABLE_UPDATE_ERROR = 'INFRA_DELIVERABLE_UPDATE_ERROR';

/********************INFRASTRUCTURE / ACTIVITY *******************************************************/
export const INFRA_ACTIVITY_LIST = 'INFRA_ACTIVITY_LIST';
export const INFRA_ACTIVITY_LIST_SUCCESS = 'INFRA_ACTIVITY_LIST_SUCCESS';
export const INFRA_ACTIVITY_LIST_ERROR = 'INFRA_ACTIVITY_LIST_ERROR';

// Actividad: sección ADD
export const INFRA_ACTIVITY_ADD_MODAL_SET = 'INFRA_ACTIVITY_ADD_MODAL_SET';
export const INFRA_ACTIVITY_ADD_CHANGE_SET = 'INFRA_ACTIVITY_ADD_CHANGE_SET';

// Actividad: sección EDIT
export const INFRA_ACTIVITY_EDIT_MODAL_SET = 'INFRA_ACTIVITY_EDIT_MODAL_SET';
export const INFRA_ACTIVITY_EDIT_CHANGE_SET = 'INFRA_ACTIVITY_EDIT_CHANGE_SET';

// Actividad: sección VIEW (solo lectura)
export const INFRA_ACTIVITY_VIEW_MODAL_SET = 'INFRA_ACTIVITY_VIEW_MODAL_SET';
export const INFRA_ACTIVITY_VIEW_SET = 'INFRA_ACTIVITY_VIEW_SET';

export const INFRA_ACTIVITY_ADD = 'INFRA_ACTIVITY_ADD';
export const INFRA_ACTIVITY_ADD_SUCCESS = 'INFRA_ACTIVITY_ADD_SUCCESS';
export const INFRA_ACTIVITY_ADD_ERROR = 'INFRA_ACTIVITY_ADD_ERROR';

export const INFRA_ACTIVITY_UPDATE = 'INFRA_ACTIVITY_UPDATE';
export const INFRA_ACTIVITY_UPDATE_SUCCESS = 'INFRA_ACTIVITY_UPDATE_SUCCESS';
export const INFRA_ACTIVITY_UPDATE_ERROR = 'INFRA_ACTIVITY_UPDATE_ERROR';

export const INFRA_ACTIVITY_CANCEL = 'INFRA_ACTIVITY_CANCEL';
export const INFRA_ACTIVITY_CANCEL_SUCCESS = 'INFRA_ACTIVITY_CANCEL_SUCCESS';
export const INFRA_ACTIVITY_CANCEL_ERROR = 'INFRA_ACTIVITY_CANCEL_ERROR';

export const INFRA_ACTIVITY_DOCS_MODAL_SET = 'INFRA_ACTIVITY_DOCS_MODAL_SET';

export const INFRA_ACTIVITY_DOC_DELETE = 'INFRA_ACTIVITY_DOC_DELETE';
export const INFRA_ACTIVITY_DOC_DELETE_SUCCESS = 'INFRA_ACTIVITY_DOC_DELETE_SUCCESS';
export const INFRA_ACTIVITY_DOC_DELETE_ERROR = 'INFRA_ACTIVITY_DOC_DELETE_ERROR';

/********************INFRASTRUCTURE / LOGBOOK *******************************************************/

export const INFRA_LOGBOOK_CONTRACT_ERP_DATA = 'INFRA_LOGBOOK_CONTRACT_ERP_DATA';
export const INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS = 'INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS';
export const INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR = 'INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR';
export const INFRA_LOGBOOK_SAVE_CONTRACT = 'INFRA_LOGBOOK_SAVE_CONTRACT';
export const INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS = 'INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS';
export const INFRA_LOGBOOK_SAVE_CONTRACT_ERROR = 'INFRA_LOGBOOK_SAVE_CONTRACT_ERROR';
export const INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES = 'INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES';
export const INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS = 'INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS';
export const INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR = 'INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR';
export const INFRA_LOGBOOK_LIST = 'INFRA_LOGBOOK_LIST';
export const INFRA_LOGBOOK_LIST_SUCCESS = 'INFRA_LOGBOOK_LIST_SUCCESS';
export const INFRA_LOGBOOK_LIST_ERROR = 'INFRA_LOGBOOK_LIST_ERROR';
export const INFRA_LOGBOOK_PAGE_SET = 'INFRA_LOGBOOK_PAGE_SET';
export const INFRA_LOGBOOK_SEARCH_CHANGE = 'INFRA_LOGBOOK_SEARCH_CHANGE';
export const INFRA_LOGBOOK_ADD_MODAL_SET = 'INFRA_LOGBOOK_ADD_MODAL_SET';
export const INFRA_LOGBOOK_ADD_CHANGE = 'INFRA_LOGBOOK_ADD_CHANGE';
export const INFRA_LOGBOOK_ADD = 'INFRA_LOGBOOK_ADD';
export const INFRA_LOGBOOK_ADD_SUCCESS = 'INFRA_LOGBOOK_ADD_SUCCESS';
export const INFRA_LOGBOOK_ADD_ERROR = 'INFRA_LOGBOOK_ADD_ERROR';
export const INFRA_LOGBOOK_EDIT_MODAL_SET = 'INFRA_LOGBOOK_EDIT_MODAL_SET';
export const INFRA_LOGBOOK_EDIT_SET_DATA = 'INFRA_LOGBOOK_EDIT_SET_DATA';
export const INFRA_LOGBOOK_UPDATE = 'INFRA_LOGBOOK_UPDATE';
export const INFRA_LOGBOOK_UPDATE_SUCCESS = 'INFRA_LOGBOOK_UPDATE_SUCCESS';
export const INFRA_LOGBOOK_UPDATE_ERROR = 'INFRA_LOGBOOK_UPDATE_ERROR';



export * from './task/task_employee/actions';
export * from './task/task_employee_audit/actions';
export * from './task/task_vehicle/actions';
export * from './task/task_vehicle_audit/actions';
export * from './communication/catalog/actions';
export * from './communication/area/actions';
export * from './report/idxPaymentReport/actions';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './upload/actions';
export * from './menuRole/actions';
export * from './reportBugs/actions';
export * from './adminCommunication/actions';
export * from './communication/supplierCommunication/actions';
export * from './communication/supplierCommunicationInfra/actions';
export * from './communication/communicationInfra/actions';

export * from './speTool/actions';
export * from './hospitalNet/evaluation/actions';
export * from './quality/healthRegistration/actions';
export * from './quality/healthLicense/actions';
export * from './quality/healthBPM/actions';
export * from './quality/productInfo/actions';
export * from './quality/idxRptQuality/actions';

export * from './finance/cashReceipt/actions';
export * from './finance/paymentReceipt/actions';

export * from './assessment/assessment/actions';
export * from './assessment/section/actions';
export * from './assessment/question/actions';
export * from './assessment/answer/actions';
export * from './assessment/section_equipment/actions';
export * from './assessment/assessment_project/actions';
export * from './assessment/evaluation/actions';
export * from './assessment/evaluation_detail/actions';
export * from './assessment/document_type/actions';
export * from './assessment/assessment_type/actions';
export * from './assessment/document/actions';
export * from './assessment/evaluation_state/actions';
export * from './assessment/evaluation_role/actions';
export * from './assessment/evaluation_user/actions';
export * from './assessment/evaluation_message/actions';
export * from './assessment/equipment_stock/actions';
export * from './assessment/equipment_stock_detail/actions';
export * from './assessment/equipment_stock_detail_item/actions';
export * from './assessment/assessment_category/actions';
export * from './assessment/equipment/actions';
export * from './assessment/idxRptEquipment/actions';
export * from './assessment/otherReassignation/actions';

export * from './equipment/trackingInstallation/actions';
export * from './equipment/assignTechnic/actions';
export * from './equipment/validationDocumentReview/actions';
export * from './equipment/scheduleMto/actions';
export * from './equipment/request/actions';
export * from './task/actions';
export * from './taskType/actions';
export * from './management/program/actions';
export * from './management/component/actions';
export * from './management/project/actions';
export * from './management/objective/actions';
export * from './management/outcome/actions';
export * from './delivery_plan/delivery_plan/actions';
export * from './delivery_plan/documentation/actions';
export * from './delivery_plan/delivery_plan_audit/actions';
export * from './delivery_plan/task_inspection/actions';
export * from './delivery_plan/task_inspection_destination/actions';
export * from './delivery_plan/task_delivery/actions';
export * from './acquisition/acquisition/actions';
export * from './acquisition/acquisition_detail/actions';
export * from './acquisition/acquisition_detail_not_biddable/actions';
export * from './task_equipment/actions';
export * from './catalog/vehicle_type/actions';
export * from './supplier/vehicle/actions';
export * from './supplier/employee/actions';
export * from './enterprise/supplier/actions';
export * from './enterprise/supplier_user/actions';

export * from './ambulance/document/actions';
export * from './ambulance/maintenance/actions';

export * from './infrastructure/deliverable/actions';
export * from './infrastructure/logbook/actions';
